export const translationStrings: {
  [key: string]: {
    en: string | any;
    se: string | any;
    es: string | any;
  };
} = {
  'Accounting.InvalidOrders': {
    en: 'Invalid orders',
    se: 'Felaktiga beställningar',
    es: 'Pedidos inválidos',
  },
  'Accounting.InvalidRefunds': {
    en: 'Invalid refunds',
    se: 'Felaktiga återbetalningar',
    es: 'Reembolsos inválidos',
  },
  'Accounting.Vouchers': {
    en: 'Vouchers',
    se: 'Verifikationer',
    es: 'Vouchers',
  },
  'Accounting.SelectCompany': {
    en: 'Select company',
    se: 'Välj företag',
    es: 'Seleccionar empresa',
  },
  'Accounting.SelectStatus': {
    en: 'Select status',
    se: 'Välj status',
    es: 'Seleccionar estado',
  },
  'Accounting.Success': {
    en: 'Success',
    se: 'Lyckad',
    es: 'Éxito',
  },
  'Accounting.Pending': {
    en: 'Pending',
    se: 'Pågående',
    es: 'Pendiente',
  },
  'Accounting.Failed': {
    en: 'Failed',
    se: 'Misslyckades',
    es: 'Fallido',
  },
  'Accounting.EmptyList': {
    en: 'Select an item from the list to the left to view more information.',
    se: 'Välj ett objekt från listan till vänster för att se mer information.',
    es: 'Seleccione un elemento de la lista a la izquierda para ver más información.',
  },
  'Accounting.VoucherId': {
    en: 'Voucher ID',
    se: 'Verifikations ID',
    es: 'ID de cupón',
  },
  'Accounting.Company': {
    en: 'Company',
    se: 'Företag',
    es: 'Empresa',
  },
  'Accounting.Venue': {
    en: 'Venue',
    se: 'Butik',
    es: 'Lugar',
  },
  'Accounting.Provider': {
    en: 'Provider',
    se: 'Leverantör',
    es: 'Proveedor',
  },
  'Accounting.AccountingDate': {
    en: 'Accounting date',
    se: 'Bokföringsdatum',
    es: 'Fecha de contabilidad',
  },
  'Accounting.CreatedAt': {
    en: 'Created at',
    se: 'Skapades',
    es: 'Creado en',
  },
  'Accounting.UpdatedAt': {
    en: 'Updated at',
    se: 'Uppdaterades',
    es: 'Actualizado en',
  },
  'Accounting.Status': {
    en: 'Status',
    se: 'Status',
    es: 'Estado',
  },
  'Accounting.Message': {
    en: 'Message',
    se: 'Meddelande',
    es: 'Mensaje',
  },
  'Accounting.Content': {
    en: 'Content',
    se: 'Innehåll',
    es: 'Contenido',
  },
  'Accounting.Resend': {
    en: 'Resend',
    se: 'Skicka om',
    es: 'Reenviar',
  },
  'Accounting.VoucherResent': {
    en: 'Voucher successfully resent',
    se: 'Verifikation har skickats om',
    es: 'Cupón reenviado con éxito',
  },
  'Accounting.OrderJson': {
    en: 'Order JSON',
    se: 'Beställningens JSON',
    es: 'JSON de pedido',
  },
  'Accounting.UpdateOrder': {
    en: 'Update order',
    se: 'Uppdatera beställning',
    es: 'Actualizar pedido',
  },
  'Accounting.RefundJson': {
    en: 'Refund JSON',
    se: 'Återbetalningens JSON',
    es: 'JSON de reembolso',
  },
  'Accounting.UpdateRefund': {
    en: 'Update refund',
    se: 'Uppdatera återbetalning',
    es: 'Actualizar reembolso',
  },
  'Accounting.JsonValid': {
    en: 'The JSON is valid',
    se: 'JSON är giltig',
    es: 'El JSON es válido',
  },
  'Accounting.JsonInvalid': {
    en: 'The JSON is invalid',
    se: 'Ogiltig JSON',
    es: 'El JSON no es válido',
  },
  'Accounting.OrderUpdated': {
    en: 'Order successfully updated!',
    se: 'Beställningen har uppdaterats!',
    es: '¡Pedido actualizado con éxito!',
  },
  'Accounting.OrderNotUpdated': {
    en: 'Unable to update order!',
    se: 'Det gick inte att uppdatera beställningen!',
    es: '¡No se pudo actualizar el pedido!',
  },
  'Accounting.RefundUpdated': {
    en: 'Refund successfully updated!',
    se: 'Återbetalningen har uppdaterats!',
    es: '¡Reembolso actualizado con éxito!',
  },
  'Accounting.RefundNotUpdated': {
    en: 'Unable to update refund!',
    se: 'Det gick inte att uppdatera återbetalningen!',
    es: '¡No se pudo actualizar el reembolso!',
  },
  'Accounting.SendVouchers': {
    en: 'Send Vouchers',
    se: 'Skicka Verifikationer',
    es: 'Enviar cupones',
  },
  'Accounting.ForceResend': {
    en: 'Force resend',
    se: 'Tvinga återsändning',
    es: 'Forzar reenvío',
  },
  'Accounting.ConfigWasAdded': {
    en: 'Config was successfully added',
    se: 'Konfigurationen har lagts till!',
    es: 'La configuración se agregó correctamente',
  },
  'Accounting.ConfigWasUpdated': {
    en: 'Config was successfully updated',
    se: 'Konfigurationen har uppdaterats!',
    es: 'La configuración se actualizó correctamente',
  },
  'AddLocation.Title': {
    en: 'Add information about your restaurant locations',
    se: 'Lägg till information om era filialer',
    es: 'Añadir información sobre las ubicaciones de su restaurante',
  },
  'AddLocation.PasswordHint': {
    en: 'This information can be changed later.',
    se: 'Denna information kan ändras senare',
    es: 'Esta información se puede cambiar más tarde.',
  },
  'AddLocation.LocationName': {
    en: 'Restaurant location name',
    se: 'Namn på filialen',
    es: 'Nombre de la ubicación del restaurante',
  },
  'AddLocation.LocationAddress': {
    en: 'Restaurang Location Address',
    se: 'Restaurangens address',
    es: 'Dirección de la ubicación del restaurante',
  },
  'AddLocation.Zip': {
    en: 'Zip code',
    se: 'Postnummer',
    es: 'Código postal',
  },
  'AddLocation.City': {
    en: 'City',
    se: 'Stad',
    es: 'Ciudad',
  },
  'AddLocation.Submit': {
    en: 'Add restaurant locations',
    se: 'Lägg till',
    es: 'Añadir ubicaciones de restaurante',
  },
  'AddLocation.Loading': {
    en: 'Loading',
    se: 'Laddar',
    es: 'Cargando',
  },
  'Campaigns.Campaigns': {
    en: 'Campaigns',
    se: 'Kampanjer',
    es: 'Campañas',
  },
  'Campaigns.CreateCampaign': {
    en: 'Create campaign',
    se: 'Skapa kampanj',
    es: 'Crear campaña',
  },
  'Campaigns.CreateDuplicateOffers': {
    en: 'Create duplicate offers',
    se: 'Skapa dubbletter av erbjudanden',
    es: 'Crear ofertas duplicadas',
  },
  'Campaigns.NotificationTitle': {
    en: 'Notification Title',
    se: 'Aviseringens rubrik',
    es: 'Título de la notificación',
  },
  'Campaigns.NotificationBody': {
    en: 'Notification Body',
    se: 'Aviseringens brödtext',
    es: 'Cuerpo de la notificación',
  },
  'Campaigns.SendOfferAtDate': {
    en: 'Send offer at date',
    se: 'Skicka erbjudande vid datum',
    es: 'Enviar oferta en la fecha',
  },
  'Campaigns.SendOfferAtTime': {
    en: 'Send offer at time',
    se: 'Skicka erbjudande vid tid',
    es: 'Enviar oferta en la hora',
  },
  'Campaigns.RepeatCampaign': {
    en: 'Repeat this campaign',
    se: 'Upprepa denna kampanj',
    es: 'Repetir esta campaña',
  },
  'Campaigns.Audience': {
    en: 'Audience',
    se: 'Målgrupp',
    es: 'Público',
  },
  'Campaigns.SpecifyOffer': {
    en: 'You must specify an offer',
    se: 'Du måste ange ett erbjudande',
    es: 'Debe especificar una oferta',
  },
  'Campaigns.SpecifyName': {
    en: 'You must specify a name',
    se: 'Du måste ange ett namn',
    es: 'Debe especificar un nombre',
  },
  'Campaigns.SpecifyAudience': {
    en: 'You must specify an audience',
    se: 'Du måste ange en målgrupp',
    es: 'Debe especificar un público',
  },
  'Campaigns.SpecifyExpiration': {
    en: 'Expire is enabled. An expiration value has to be specified',
    se: 'Utgång är aktiverat. Ett utgångsvärde måste anges',
    es: 'La expiración está habilitada. Se debe especificar un valor de expiración',
  },
  'Campaigns.SpecifyNotification': {
    en: 'Notifications are enabled. Specify either title, body or both',
    se: 'Aviseringar är aktiverade. Ange antingen titel, text eller båda',
    es: 'Las notificaciones están habilitadas. Especifique el título, el cuerpo o ambos',
  },
  'Campaigns.NameDescription': {
    en: `The name for this scheduled event. For internal use to keep track of different scheduled
          offers`,
    se: `Namnet på denna schemalagda händelse. För internt bruk för att hålla reda på olika schemalagda
    erbjudanden`,
    es: `El nombre de este evento programado. Para uso interno para mantener un seguimiento de diferentes ofertas programadas`,
  },
  'Campaigns.OfferDescription': {
    en: 'Pick which offer you would like to send out',
    se: 'Välj vilket erbjudande du vill skicka ut',
    es: 'Elija la oferta que le gustaría enviar',
  },
  'Campaigns.DuplicateOffersDescription': {
    en: 'Should this offer be sent to users that already have the offer?',
    se: 'Ska detta erbjudande skickas till användare som redan har erbjudandet?',
    es: '¿Debería enviarse esta oferta a los usuarios que ya tienen la oferta?',
  },
  'Campaigns.DateDescription': {
    en: 'Which date would you like give out this offer',
    se: 'Vilket datum vill du ge ut detta erbjudande',
    es: '¿Qué fecha le gustaría dar esta oferta',
  },
  'Campaigns.TimeDescription': {
    en: 'Which time of the day you would like to send out the offer',
    se: 'Vilken tid du vill skicka ut erbjudandet',
    es: '¿A qué hora del día le gustaría enviar la oferta',
  },
  'Campaigns.Expire': {
    en: 'Expire',
    se: 'Utgång',
    es: 'Expirar',
  },
  'Campaigns.ExpireDescription': {
    en: 'Would you like this offer to expire after a set amount of time?',
    se: 'Vill du att det här erbjudandet ska löpa ut efter en viss tid?',
    es: '¿Le gustaría que esta oferta expirara después de un tiempo determinado?',
  },
  'Campaigns.Schedule': {
    en: 'Schedule',
    se: 'Schema',
    es: 'Horario',
  },
  'Campaigns.ScheduleDescription': {
    en: 'Would you like this to be a repeating event?',
    se: 'Vill du att detta ska bli en återkommande händelse?',
    es: '¿Le gustaría que esto sea un evento recurrente?',
  },
  'Campaigns.AudienceDescription': {
    en: 'Select which users or Segments should receive this offer',
    se: 'Välj vilka användare eller segment som ska få det här erbjudandet',
    es: 'Seleccione los usuarios o segmentos que deben recibir esta oferta',
  },
  'Campaigns.PushNotification': {
    en: 'Push notification',
    se: 'Push-meddelande',
    es: 'Notificación push',
  },
  'Campaigns.PushNotificationDescription': {
    en: `Send out a notification to the together with the offer. Clicking the notification will
          open the offer`,
    se: `Skicka ut en avisering till den tillsammans med erbjudandet. Klicka på meddelandet
    för att öppna erbjudandet`,
    es: `Envíe una notificación junto con la oferta. Haciendo clic en la notificación se abrirá la oferta`,
  },
  'Campaigns.UsersSegments': {
    en: 'Users and segments',
    se: 'Användare och segment',
    es: 'Usuarios y segmentos',
  },
  'Company.CodeTwoChars': {
    en: 'Code (two characters)',
    se: 'Kod (Två tecken)',
    es: 'Código (dos caracteres)',
  },
  'Company.SupportEmail': {
    en: 'Support E-mail',
    se: 'Support email',
    es: 'Correo electrónico de soporte',
  },
  'Company.CodeDescription': {
    en: 'Code has to be exactly two characters and uppercase',
    se: 'Koden måste vara exakt två tecken!',
    es: 'El código debe tener exactamente dos caracteres y mayúsculas',
  },
  'Company.EnableCashPoints': {
    en: 'Enable CashPoints',
    se: 'Aktivera CashPoints',
    es: 'Habilitar puntos de efectivo',
  },
  'Company.EnableMembershipCards': {
    en: 'Enable membership cards (dont touch)',
    se: 'Använd medlemskort (rör ej)',
    es: 'Habilitar tarjetas de membresía (no tocar)',
  },
  'Company.MembershipPointsPercentage': {
    en: 'Membership Card Points Percentage',
    se: 'Medlemskapspoäng procentsats',
    es: 'Porcentaje de puntos de tarjeta de membresía',
  },
  'Company.ExtendedMode': {
    en: 'Extended mode',
    se: 'Utökat läge',
    es: 'Modo extendido',
  },
  'Company.AppOrdersMode': {
    en: 'App Orders Mode for OM',
    se: 'Apporderläge för OM',
    es: 'Modo de pedidos de aplicación para OM',
  },
  'Company.TableManagementMode': {
    en: 'Table Management Mode for OM',
    se: 'Bordshanteringsläge för OM',
    es: 'Modo de gestión de mesas para OM',
  },
  'Company.PointOfSaleMode': {
    en: 'Point of Sale Mode for OM',
    se: 'Point of Sale för OM',
    es: 'Modo de venta al por menor para OM',
  },
  'Company.PointsMode': {
    en: 'Points Mode for OM',
    se: 'Poäng för OM',
    es: 'Modo de puntos para OM',
  },
  'Company.KitchenDisplayMode': {
    en: 'Kitchen Display Mode for OM',
    se: 'Köksskärm för OM',
    es: 'Modo de pantalla de cocina para OM',
  },
  'Company.CustomerDisplayMode': {
    en: 'Customer Display Mode for OM',
    se: 'Nummerredo skärm för OM',
    es: 'Modo de pantalla de cliente para OM',
  },
  'Company.ExpressCheckoutMode': {
    en: 'Express Checkout Mode for OM',
    se: 'Expresskassa för OM',
    es: 'Modo de pago rápido para OM',
  },
  'Company.InventoryMode': {
    en: 'Inventory Mode for OM',
    se: 'Lager for OM',
    es: 'Modo de inventario para OM',
  },
  'Company.ManualEndOfDay': {
    en: 'Manual End of Day for OM',
    se: 'Manuella dagsavslut för OM',
    es: 'Fin de día manual para OM',
  },
  'Company.Referrals': {
    en: 'Referrals',
    se: 'Referrals',
    es: 'Referencias',
  },
  'Company.ReferralsEnabled': {
    en: 'Referrals enabled',
    se: 'Referrals aktiverat',
    es: 'Referencias habilitadas',
  },
  'Company.ReferralTitle': {
    en: 'Referral Page Title',
    se: 'Referral Sida Titel',
    es: 'Título de la página de referencia',
  },
  'Company.ReferralBody': {
    en: 'Referral Page Body',
    se: 'Referral Sida Brödtext',
    es: 'Cuerpo de la página de referencia',
  },
  'Company.ReferralShareMessage': {
    en: 'Referral Share Message',
    se: 'Referral Dela Meddelande',
    es: 'Mensaje de referencia compartida',
  },
  'Company.ReferralOffer': {
    en: 'Referral Offer',
    se: 'Referral Erbjudande',
    es: 'Oferta de referencia',
  },
  'Company.ReferrerOffer': {
    en: 'Referrer Offer',
    se: 'Referrer Erbjudande',
    es: 'Oferta de referencia',
  },
  'Company.Active': {
    en: 'Active',
    se: 'Aktiv',
    es: 'Activo',
  },
  'Company.ServiceFee': {
    en: 'Service fee',
    se: 'Serviceavgift',
    es: 'Tarifa de servicio',
  },
  'Company.Languages': {
    en: 'Languages',
    se: 'Språk',
    es: 'Idiomas',
  },
  'Company.LoginMethods': {
    en: 'Login Methods',
    se: 'Inloggningsmetoder',
    es: 'Métodos de inicio de sesión',
  },
  'Company.DefaultOrderStatus': {
    en: 'Default Order Status',
    se: 'Standard Order Status',
    es: 'Estado de pedido predeterminado',
  },
  'Company.Accepted': {
    en: 'Accepted',
    se: 'Accepterad',
    es: 'Aceptado',
  },
  'Company.Completed': {
    en: 'Completed',
    se: 'Avslutad',
    es: 'Completado',
  },
  'Company.AccessibleRoutes': {
    en: 'Accessible routes',
    se: 'Tillgängliga vägar',
    es: 'Rutas accesibles',
  },
  'Companies.Search': {
    en: 'Search for a company',
    se: 'Sök efter ett företag',
    es: 'Buscar una empresa',
  },
  'Companies.Edit': {
    en: 'Edit this company',
    se: 'Ändra detta företag',
    es: 'Editar esta empresa',
  },
  'Companies.CreateTitle': {
    en: 'Create Company',
    se: 'Skapa företag',
    es: 'Crear empresa',
  },
  'Companies.CreateDescription': {
    en: 'Create a brand new company',
    se: 'Skapa ett helt nytt företag',
    es: 'Crea una empresa completamente nueva',
  },
  'Companies.Form.Name': {
    en: 'Name',
    se: 'Namn',
    es: 'Nombre',
  },
  'Companies.Form.NamePlaceholder': {
    en: 'Fill in company name',
    se: 'Fyll i företagsnamn',
    es: 'Rellene el nombre de la empresa',
  },
  'Companies.Form.NameValidation': {
    en: 'The company name already exist',
    se: 'Företagsnamnet finns redan',
    es: 'El nombre de la empresa ya existe',
  },
  'Companies.Form.Code': {
    en: 'Code',
    se: 'Kod',
    es: 'Código',
  },
  'Companies.Form.CodePlaceholder': {
    en: '2 character code',
    se: '2 teckens kod',
    es: 'Código de 2 caracteres',
  },
  'Companies.Form.CodeValidation': {
    en: 'Code has to be exactly two characters and uppercase',
    se: 'Koden måste vara exakt två tecken och i versaler',
    es: 'El código debe tener exactamente dos caracteres y mayúsculas',
  },
  'Companies.Form.Email': {
    en: 'Support Email',
    se: 'Support email',
    es: 'Correo electrónico de soporte',
  },
  'Companies.Form.EmailPlaceholder': {
    en: 'Fill in the company email',
    se: 'Fyll i företagets email',
    es: 'Rellene el correo electrónico de la empresa',
  },
  'Companies.Form.Cashback': {
    en: 'Enable CashPoints',
    se: 'Använd CashPoints',
    es: 'Habilitar CashPoints',
  },
  'Companies.Form.MembershipCards': {
    en: 'Enable membership cards (dont touch)',
    se: 'Använd medlemskort (rör ej)',
    es: 'Habilitar tarjetas de membresía (no tocar)',
  },
  'Companies.Form.MembershipPointsPercentage': {
    en: 'Membership Card Points Percentage',
    se: 'Medlemskapspoäng procentsats',
    es: 'Porcentaje de puntos de tarjeta de membresía',
  },
  'Companies.Form.MembershipPointsPercentagePlaceholder': {
    en: 'Enter percentage value',
    se: 'Ange procentuellt värde',
    es: 'Ingrese el valor porcentual',
  },
  'Companies.Form.AppOrders': {
    en: 'Enable app',
    se: 'Aktivera app',
    es: 'Habilitar aplicación',
  },
  'Companies.Form.TSR': {
    en: 'Enable TSR',
    se: 'Aktivera TSR',
    es: 'Habilitar TSR',
  },
  'Companies.Form.POS': {
    en: 'Enable POS',
    se: 'Aktivera POS',
    es: 'Habilitar POS',
  },
  'Companies.Form.Points': {
    en: 'Enable Points mode',
    se: 'Aktivera poäng läge',
    es: 'Habilitar modo de puntos',
  },
  'Companies.Form.KDS': {
    en: 'Enable kitchen display',
    se: 'Aktivera köksdisplay',
    es: 'Habilitar pantalla de cocina',
  },
  'Companies.Form.CDS': {
    en: 'Enable customer display',
    se: 'Aktivera nummerredo skärm',
    es: 'Habilitar pantalla de cliente',
  },
  'Companies.Form.Express': {
    en: 'Enable Express',
    se: 'Aktivera Expresskassa',
    es: 'Habilitar Express',
  },
  'Companies.Form.Inventory': {
    en: 'Enable Inventory',
    se: 'Aktivera Lager',
    es: 'Habilitar Inventario',
  },
  'Companies.Form.MEOD': {
    en: 'Enable manual End of Day',
    se: 'Aktivera manuella dagsavslut',
    es: 'Habilitar fin de día manual',
  },
  'Companies.Form.AutoCashEOD': {
    en: "Enable automatic 'End of Day' for cash",
    se: "Aktivera automatisk 'Dagsavslut' för växelkassa",
    es: "Habilitar 'Fin de día' automático para efectivo",
  },
  'Companies.Form.AutoCashEOD.Desc': {
    en: 'Use with caution – please read notion before activating.',
    se: 'Använd med försiktighet - läs Notion innan aktivering.',
    es: 'Usar con precaución: lea la noción antes de activar.',
  },
  'Companies.Form.Active': {
    en: 'Company is active',
    se: 'Företaget är aktivt',
    es: 'La empresa está activa',
  },
  'Companies.Form.ServiceFee': {
    en: 'Service Fee',
    se: 'Serviceavgift',
    es: 'Tarifa de servicio',
  },
  'Companies.Form.ServiceFeePlaceHolder': {
    en: 'Enter service fee',
    se: 'Ange serviceavgift',
    es: 'Ingrese la tarifa de servicio',
  },
  'Companies.Form.Languages': {
    en: 'Languages',
    se: 'Språk',
    es: 'Idiomas',
  },
  'Companies.Form.Languages.Swedish': {
    en: 'Swedish',
    se: 'Svenska',
    es: 'Sueco',
  },
  'Companies.Form.Languages.English': {
    en: 'English',
    se: 'Engelska',
    es: 'Inglés',
  },
  'Companies.Form.Languages.Spanish': {
    en: 'Spanish',
    se: 'Spanska',
    es: 'Español',
  },
  'Companies.Form.Languages.Norwegian': {
    en: 'Norwegian',
    se: 'Norska',
    es: 'Noruego',
  },
  'Companies.Form.Languages.Turkish': {
    en: 'Turkish',
    se: 'Turkiska',
    es: 'Turco',
  },
  'Companies.Form.Languages.Danish': {
    en: 'Danish',
    se: 'Danska',
    es: 'Danés',
  },
  'Companies.Form.Languages.Arabic': {
    en: 'Arabic',
    se: 'Arabiska',
    es: 'Árabe',
  },
  'Companies.Form.DefaultLanguage': {
    en: 'Default Language',
    se: 'Standardspråk',
    es: 'Idioma predeterminado',
  },
  'Companies.Form.DefaultCurrency': {
    en: 'Default Currency',
    se: 'Standardvaluta',
    es: 'Moneda predeterminada',
  },
  'Companies.Form.LoginMethods': {
    en: 'Login Methods',
    se: 'Loginmetoder',
    es: 'Métodos de inicio de sesión',
  },
  'Companies.Form.DefaultOrderStatus': {
    en: 'Default Order Status',
    se: 'Standard orderstatus',
    es: 'Estado de pedido predeterminado',
  },
  'Companies.Form.BETA': {
    en: 'Activate BETA features',
    se: 'Aktivera BETA funktioner',
    es: 'Activar funciones BETA',
  },
  'Companies.Form.BETARoutes': {
    en: 'Accessible BETA routes',
    se: 'Tillgängliga BETA routes',
    es: 'Rutas BETA accesibles',
  },
  'Companies.Form.BETAModifications': {
    en: 'Enable new modifications',
    se: 'Aktivera nya modifieringar',
    es: 'Habilitar nuevas modificaciones',
  },
  'Companies.Form.TimeZone': {
    en: 'Time zone',
    se: 'Tidszon',
    es: 'Zona horaria',
  },
  'Content.Slug': {
    en: 'Slug',
    se: 'Slug',
    es: 'Slug',
  },
  'Content.HeroArea': {
    en: 'Hero area',
    se: 'Hero area',
    es: 'Hero area',
  },
  'Content.Sidebar': {
    en: 'Sidebar',
    se: 'Sidofält',
    es: 'Barra lateral',
  },
  'Content.Feed': {
    en: 'Feed',
    se: 'Flöde',
    es: 'Feed',
  },
  'Content.Restaurant': {
    en: 'Restaurant',
    se: 'Restaurang',
    es: 'Restaurante',
  },
  'Content.Offers': {
    en: 'Offers',
    se: 'Erbjudanden',
    es: 'Ofertas',
  },
  'Content.ShowFrom': {
    en: 'Show from',
    se: 'Visa från',
    es: 'Mostrar desde',
  },
  'Content.ShowUntil': {
    en: 'Show until',
    se: 'Visa till',
    es: 'Mostrar hasta',
  },
  'Content.Image': {
    en: 'Image',
    se: 'Bild',
    es: 'Imagen',
  },
  'Content.Created': {
    en: 'Created',
    se: 'Skapad',
    es: 'Creado',
  },
  'Content.Updated': {
    en: 'Updated',
    se: 'Uppdaterad',
    es: 'Actualizado',
  },
  'Content.Content': {
    en: 'Content',
    se: 'Innehåll',
    es: 'Contenido',
  },
  'Content.CreateContent': {
    en: 'Create content',
    se: 'Skapa innehåll',
    es: 'Crear contenido',
  },
  'Content.BodyContent': {
    en: 'Body / Content',
    se: 'Brödtext / Innehåll',
    es: 'Cuerpo / Contenido',
  },
  'Content.Segments': {
    en: 'Segments',
    se: 'Segment',
    es: 'Segmentos',
  },
  'Content.Segment': {
    en: 'Segment',
    se: 'Segment',
    es: 'Segmento',
  },
  'GiftCards.GiftCards': {
    en: 'Gift cards',
    se: 'Presentkort',
    es: 'Tarjetas de regalo',
  },
  'GiftCards.GiftCard': {
    en: 'Gift card',
    se: 'Presentkort',
    es: 'Tarjeta de regalo',
  },
  'GiftCards.GiftCardsReport': {
    en: 'Gift cards report',
    se: 'Presentkortsrapport',
    es: 'Informe de tarjetas de regalo',
  },
  'GiftCards.GiftCardsDescription': {
    en: 'To view more information on gift card sales, view the gift card section in reports',
    se: 'För att se mer information om presentkortsförsäljning, se presentkortssektionen i rapporter',
    es: 'Para ver más información sobre las ventas de tarjetas de regalo, consulte la sección de tarjetas de regalo en los informes',
  },
  'GiftCards.GiftCardsActivateDescription': {
    en: 'First, assign an article from PIM to represent the gift card product',
    se: 'Aktivera en artikel från PIM för att representera presentkorts produkten.',
    es: 'Primero, asigne un artículo de PIM para representar el producto de tarjeta de regalo',
  },
  'GiftCards.OrderPhysicalGiftCards': {
    en: 'Order physical gift cards',
    se: 'Beställ fysiska presentkort',
    es: 'Ordenar tarjetas de regalo físicas',
  },
  'GiftCards.CreateGiftCard': {
    en: 'Create a gift card',
    se: 'Skapa presentkort',
    es: 'Crear una tarjeta de regalo',
  },
  'GiftCards.CreateNewGiftCard': {
    en: 'Create a new gift card',
    se: 'Skapa ett nytt presentkort',
    es: 'Crear una nueva tarjeta de regalo',
  },
  'GiftCards.CardsInCirculation': {
    en: 'Cards in circulation',
    se: 'Aktiva kort',
    es: 'Tarjetas en circulación',
  },
  'GiftCards.OutstandingBalance': {
    en: 'Outstanding balance',
    se: 'Utestående saldo',
    es: 'Saldo pendiente',
  },
  'GiftCards.TransactionVolume': {
    en: 'Transaction volume',
    se: 'Transaktionsvolym',
    es: 'Volumen de transacciones',
  },
  'GiftCards.SearchPlaceholder': {
    en: 'Search for a gift card code...',
    se: 'Sök efter en presentkortskod...',
    es: 'Buscar un código de tarjeta de regalo...',
  },
  'GiftCards.StatusPlaceholder': {
    en: 'Select status',
    se: 'Välj status',
    es: 'Seleccionar estado',
  },
  'GiftCards.NotFound': {
    en: "Couldn't find any gift cards",
    se: 'Inga presentkort hittades',
    es: 'No se encontraron tarjetas de regalo',
  },
  'GiftCards.Error': {
    en: 'There was an error retrieving the gift cards. Please try again.',
    se: 'Det gick inte att hämta presentkorten. Var god försök igen.',
    es: 'Hubo un error al recuperar las tarjetas de regalo. Por favor, inténtelo de nuevo.',
  },
  'GiftCards.Code': {
    en: 'Code',
    se: 'Kod',
    es: 'Código',
  },
  'GiftCards.GiftCardCode': {
    en: 'Gift card code',
    se: 'Presentkortskod',
    es: 'Código de tarjeta de regalo',
  },
  'GiftCards.GiftCardQRCodesFor': {
    en: 'Gift card QR codes for',
    se: 'Presentkort QR-koder för',
    es: 'Códigos QR de tarjetas de regalo para',
  },
  'GiftCards.ExpiresAt': {
    en: 'Expires at',
    se: 'Utgångsdatum',
    es: 'Expira en',
  },
  'GiftCards.Status': {
    en: 'Status',
    se: 'Status',
    es: 'Estado',
  },
  'GiftCards.Balance': {
    en: 'Balance',
    se: 'Saldo',
    es: 'Saldo',
  },
  'GiftCards.OrderModalDescription': {
    en: 'Get physical gift cards for your restaurant to improve your customer experience.',
    se: 'Beställ fysiska presentkort till ditt restaurang för att förbättra din kundupplevelse.',
    es: 'Obtenga tarjetas de regalo físicas para su restaurante para mejorar su experiencia de cliente.',
  },
  'GiftCards.NumberOfCards': {
    en: 'Number of cards',
    se: 'Antal kort',
    es: 'Número de tarjetas',
  },
  'GiftCards.ExpiryInYears': {
    en: 'Expiry in years',
    se: 'Utgångsdatum i år',
    es: 'Expiración en años',
  },
  'GiftCards.InitialBalance': {
    en: 'Initial balance',
    se: 'Startsaldo',
    es: 'Saldo inicial',
  },
  'GiftCards.SelectDesign': {
    en: 'Select a design',
    se: 'Välj design',
    es: 'Seleccione un diseño',
  },
  'GiftCards.Selected': {
    en: 'Selected',
    se: 'Vald',
    es: 'Seleccionado',
  },
  'GiftCards.PriceForEachCard': {
    en: 'Price for each card',
    se: 'Pris för varje kort',
    es: 'Precio por cada tarjeta',
  },
  'GiftCards.TotalPrice': {
    en: 'Total price',
    se: 'Total pris',
    es: 'Precio total',
  },
  'GiftCards.OrderNow': {
    en: 'Order now',
    se: 'Beställ nu',
    es: 'Ordenar ahora',
  },
  'GiftCards.IncreaseGiftCardBalance': {
    en: 'Increase gift card balance',
    se: 'Öka presentkortssaldo',
    es: 'Aumentar el saldo de la tarjeta de regalo',
  },
  'GiftCards.UserId': {
    en: 'User ID',
    se: 'Användar ID',
    es: 'ID de usuario',
  },
  'GiftCards.SuccessToast': {
    en: 'The gift card has been saved!',
    se: 'Presentkortet är sparat!',
    es: '¡La tarjeta de regalo ha sido guardada!',
  },
  'GiftCards.SuccessOrder': {
    en: 'Gift card order has been placed!',
    se: 'Presentkortsbeställning har gjorts!',
    es: '¡El pedido de tarjeta de regalo ha sido realizado!',
  },
  'GiftCards.BalanceToAdd': {
    en: 'Balance to add',
    se: 'Saldo att lägga till',
    es: 'Saldo a agregar',
  },
  'GiftCards.ActivateCard': {
    en: 'Activate Card',
    se: 'Aktivera kort',
    es: 'Activar tarjeta',
  },
  'GiftCards.Cashback.Button': {
    en: 'Add cashback to user',
    se: 'Lägg till cashback till användare',
    es: 'Añadir cashback a usuario',
  },
  'GiftCards.Cashback.Title': {
    en: 'Add cashback',
    se: 'Lägg till cashback',
    es: 'Añadir cashback',
  },
  'GiftCards.Cashback.Description': {
    en: 'Search for a user and add money to their cashback balance.',
    se: 'Sök efter en användare och lägg till pengar på deras cashback-saldo.',
    es: 'Busca un usuario y añade dinero a su saldo de cashback.',
  },
  'GiftCards.Cashback.SearchPlaceholder': {
    en: 'Search by name, email, card or personal number',
    se: 'Sök på namn, e-post, kort eller personnummer',
    es: 'Buscar por nombre, correo, tarjeta o número personal',
  },
  'GiftCards.Cashback.NoUsers': {
    en: 'No users found',
    se: 'Inga användare hittades',
    es: 'No se encontraron usuarios',
  },
  'GiftCards.Cashback.NoCardYet': {
    en: 'This user has no cashback card yet. One will be created when you add balance.',
    se: 'Användaren har inget cashback-kort ännu. Ett skapas när du lägger till saldo.',
    es: 'Este usuario aún no tiene tarjeta de cashback. Se creará al añadir saldo.',
  },
  'GiftCards.Cashback.AmountToAdd': {
    en: 'Cashback to add',
    se: 'Cashback att lägga till',
    es: 'Cashback a añadir',
  },
  'GiftCards.Cashback.InvalidAmount': {
    en: 'Enter an amount greater than zero.',
    se: 'Ange ett belopp större än noll.',
    es: 'Introduce un importe mayor que cero.',
  },
  'GiftCards.Cashback.Success': {
    en: 'Cashback has been added!',
    se: 'Cashback har lagts till!',
    es: '¡Se ha añadido el cashback!',
  },
  'GiftCards.Cashback.Error': {
    en: 'There was an error adding cashback. Please try again.',
    se: 'Något gick fel när cashback skulle läggas till. Försök igen.',
    es: 'Hubo un error al añadir el cashback. Inténtalo de nuevo.',
  },
  'GiftCards.NoActiveLicenseFound': {
    en: 'No active gift card license found',
    se: 'Ingen aktiv presentkortslicens hittades',
    es: 'No se encontró ninguna licencia de tarjeta de regalo activa',
  },
  'GiftCards.NoUniverseAccessFound': {
    en: 'No universe access found',
    se: 'No universe access found',
    es: 'No universe access found',
  },
  'GiftCards.AdminTitle': {
    en: 'Gift Cards Admin',
    se: 'Presentkort Admin',
    es: 'Administrador de tarjetas de regalo',
  },
  'GiftCards.ExportSubTitle': {
    en: 'Export QR codes ',
    se: 'Exportera QR-koder',
    es: 'Exportar códigos QR',
  },
  'GiftCards.ExportDescription': {
    en: 'Export gift card QR codes for',
    se: 'Exportera presentkort QR-koder för',
    es: 'Exportar códigos QR de tarjetas de regalo para',
  },
  'GiftCards.ExportToPDF': {
    en: 'PDF',
    se: 'PDF',
    es: 'PDF',
  },
  'GiftCards.ExportToPNG': {
    en: 'PNG',
    se: 'PNG',
    es: 'PNG',
  },
  'GiftCards.ExportToCSV': {
    en: 'CSV',
    se: 'CSV',
    es: 'CSV',
  },
  'GiftCards.ExportTo': {
    en: 'Export to',
    se: 'Exportera till',
    es: 'Exportar a',
  },
  'GiftCards.SelectDocumentSize': {
    en: 'PDF size',
    se: 'PDF storlek',
    es: 'tamaño del PDF',
  },
  'GiftCards.SelectBatchTooltipTitle': {
    en: 'Select what batch to generate QR codes for.',
    se: 'Välj vilken grupp som QR-koder ska genereras för.',
    es: 'Seleccione qué grupo generar códigos QR para.',
  },
  'GiftCards.SelectBatchTooltipDescription': {
    en: 'If no batch is selected, then it will export all gift cards.',
    se: 'Om ingen grupp är vald, så kommer alla presentkort att exporteras.',
    es: 'Si no se selecciona ningún grupo, se exportarán todas las tarjetas de regalo.',
  },
  'GiftCards.SelectBatch': {
    en: 'Select gift card batch',
    se: 'Välj presentkortsgrupp',
    es: 'Seleccione el grupo de tarjetas de regalo',
  },
  'GiftCards.Import.TooltipTitle': {
    en: 'XLSX Structure',
    se: 'XLSX Struktur',
    es: 'Estructura XLSX',
  },
  'GiftCards.Import.TooltipDescription': {
    en: `Headers 'code' and 'amount' must exist, 'expiryYears' is optional (1-3), defaults to 1 year. Amount must be in cents.`,
    se: `Kolumnerna 'code' och 'amount' måste finnas, 'expiryYears' är valfritt (1-3), standard är 1 år. Amount måste vara i ören.`,
    es: `Los encabezados 'code' y 'amount' deben existir, 'expiryYears' es opcional (1-3), el valor predeterminado es 1 año. El monto debe estar en centavos.`,
  },
  'GiftCards.Import.Title': {
    en: 'Import External Giftcards',
    se: 'Importera Externa Presentkort',
    es: 'Importar Tarjetas de Regalo Externas',
  },
  'GiftCards.Import.Description': {
    en: 'Import giftcards from external systems to the Baemingo Platform.',
    se: 'Importera presentkort från externa system till Baemingo Platformen.',
    es: 'Importar tarjetas de regalo de sistemas externos a la plataforma Baemingo.',
  },
  'GiftCards.Import.Importing': {
    en: 'Importing...',
    se: 'Importerar...',
    es: 'Importando...',
  },
  'GiftCards.Import.Success': {
    en: 'Successfully imported ',
    se: 'Importerade ',
    es: 'Importado con éxito ',
  },
  'GiftCards.Import.Duplicates': {
    en: 'Skipped giftcards with the following codes because they already exist: ',
    se: 'Hoppade över presentkort med följande koder eftersom de redan finns: ',
    es: 'Se saltaron las tarjetas de regalo con los siguientes códigos porque ya existen: ',
  },
  'GiftCards.Import.MissingColumn': {
    en: 'Missing column ',
    se: 'Saknar kolumn ',
    es: 'Columna faltante ',
  },
  'GiftCards.Import.MissingColumns': {
    en: 'Missing columns ',
    se: 'Saknar kolumner ',
    es: 'Columnas faltantes ',
  },
  'GiftCards.ChangeGiftCardItemTitle': {
    en: 'Edit Giftcard Item',
    se: 'Redigera Presentkort Artikel',
    es: 'Editar artículo de tarjeta de regalo',
  },
  'GiftCards.ChangeGiftCardItemDescription': {
    en: 'If the giftcard item is not correct, you can change it here.',
    se: 'Om presentkortsartikeln inte är korrekt, kan du ändra den här.',
    es: 'Si el artículo de la tarjeta de regalo no es correcto, puede cambiarlo aquí.',
  },
  'Giftcards.ChangeGiftCardItemButton': {
    en: 'Change giftcard item',
    se: 'Ändra presentkortsartikel',
    es: 'Cambiar artículo de tarjeta de regalo',
  },
  'Giftcard.Event.PAYMENT': {
    en: 'Payment',
    se: 'Betalning',
    es: 'Pago',
  },
  'Giftcard.Event.CREATE_CARD': {
    en: 'Card created',
    se: 'Kort skapat',
    es: 'Tarjeta creada',
  },
  'Giftcard.Event.ACTIVATE': {
    en: 'Card activated',
    se: 'Kort aktiverat',
    es: 'Tarjeta activada',
  },
  'Giftcard.Event.ADD_BALANCE': {
    en: 'Balance added',
    se: 'Saldo tillagt',
    es: 'Saldo agregado',
  },
  'General.Today': {
    en: 'Today',
    se: 'Idag',
    es: 'Hoy',
  },
  'General.Yesterday': {
    en: 'Yesterday',
    se: 'Igår',
    es: 'Ayer',
  },
  'General.ThisWeek': {
    en: 'This week',
    se: 'Denna vecka',
    es: 'Esta semana',
  },
  'General.LastWeek': {
    en: 'Last week',
    se: 'Förra veckan',
    es: 'La semana pasada',
  },
  'General.ThisMonth': {
    en: 'This month',
    se: 'Den här månaden',
    es: 'Este mes',
  },
  'General.LastMonth': {
    en: 'Last month',
    se: 'Förra månaden',
    es: 'El mes pasado',
  },
  'General.ThisYear': {
    en: 'This year',
    se: 'Det här året',
    es: 'Este año',
  },
  'General.LastYear': {
    en: 'Last year',
    se: 'Förra året',
    es: 'El año pasado',
  },
  'General.StartDate': {
    en: 'Start date',
    se: 'Startdatum',
    es: 'Fecha de inicio',
  },
  'General.EndDate': {
    en: 'End date',
    se: 'Slutdatum',
    es: 'Fecha de finalización',
  },
  'General.Date': {
    en: 'Date',
    se: 'Datum',
    es: 'Fecha',
  },
  'General.Select': {
    en: 'Select',
    se: 'Välj',
    es: 'Seleccionar',
  },
  'General.SelectDate': {
    en: 'Select date',
    se: 'Välj datum',
    es: 'Seleccionar fecha',
  },
  'General.LoadMore': {
    en: 'Load more',
    se: 'Ladda fler',
    es: 'Cargar más',
  },
  'General.Loading': {
    en: 'Loading',
    se: 'Laddar',
    es: 'Cargando',
  },
  'General.Name': {
    en: 'Name',
    se: 'Namn',
    es: 'Nombre',
  },
  'General.UserName': {
    en: 'User name',
    se: 'Användarnamn',
    es: 'Nombre de usuario',
  },
  'General.User.Permissions': {
    en: 'Permissions',
    se: 'Behörigheter',
    es: 'Permisos',
  },
  'General.User.AllPermissions': {
    en: 'All permissions',
    se: 'Alla behörigheter',
    es: 'Todos los permisos',
  },
  'General.Email': {
    en: 'Email',
    se: 'Email',
    es: 'Correo electrónico',
  },
  'General.Phone': {
    en: 'Phone',
    se: 'Telefon',
    es: 'Teléfono',
  },
  'General.About': {
    en: 'About',
    se: 'Om',
    es: 'Acerca de',
  },
  'General.Title': {
    en: 'Title',
    se: 'Titel',
    es: 'Título',
  },
  'General.Description': {
    en: 'Description',
    se: 'Beskrivning',
    es: 'Descripción',
  },
  'General.Search': {
    en: 'Search',
    se: 'Sök',
    es: 'Buscar',
  },
  'General.Delete': {
    en: 'Delete',
    se: 'Ta bort',
    es: 'Borrar',
  },
  'General.Cancel': {
    en: 'Cancel',
    se: 'Avbryt',
    es: 'Cancelar',
  },
  'General.ConfirmDelete': {
    en: 'Confirm delete',
    se: 'Bekräfta borttagning',
    es: 'Confirmar eliminación',
  },
  'General.Deselect': {
    en: 'Deselect',
    se: 'Avmarkera',
    es: 'Deseleccionar',
  },
  'General.AnErrorOccurred': {
    en: 'An error occurred',
    se: 'Ett fel uppstod',
    es: 'Ocurrió un error',
  },
  'General.ConfirmAction': {
    en: 'Confirm action',
    se: 'Bekräfta',
    es: 'Confirmar acción',
  },
  'General.Submit': {
    en: 'Submit',
    se: 'Skicka in',
    es: 'Enviar',
  },
  'General.Save': {
    en: 'Save',
    se: 'Spara',
    es: 'Guardar',
  },
  'General.Ok': {
    en: 'Ok',
    se: 'Ok',
    es: 'Ok',
  },
  'General.Menu': {
    en: 'Menu',
    se: 'Meny',
    es: 'Menú',
  },
  'General.ServiceType': {
    en: 'Service type',
    se: 'Service typ',
    es: 'Tipo de servicio',
  },
  'General.UnknownUser': {
    en: 'Unknown user',
    se: 'Okänd användare',
    es: 'Usuario desconocido',
  },
  'General.EntityFailedToLoad': {
    en: 'Entity failed to load. Please try again.',
    se: 'Det gick inte att läsa in enheten. Var god försök igen.',
    es: 'La entidad no se pudo cargar. Por favor, inténtelo de nuevo.',
  },
  'General.Users': {
    en: 'Users',
    se: 'Användare',
    es: 'Usuarios',
  },
  'General.Amount': {
    en: 'Amount',
    se: 'Antal',
    es: 'Cantidad',
  },
  'General.Send': {
    en: 'Send',
    se: 'Skicka',
    es: 'Enviar',
  },
  'General.Accept': {
    en: 'Accept',
    se: 'Acceptera',
    es: 'Aceptar',
  },
  'General.Reject': {
    en: 'Reject',
    se: 'Avvisa',
    es: 'Rechazar',
  },
  'General.Upload': {
    en: 'Upload',
    se: 'Ladda upp',
    es: 'Subir',
  },
  'General.Clear': {
    en: 'Clear',
    se: 'Rensa',
    es: 'Limpiar',
  },
  'General.NoItems': {
    en: 'No items',
    se: 'Inga artiklar',
    es: 'No hay artículos',
  },
  'General.TimesUsed': {
    en: 'Times used',
    se: 'Gånger använt',
    es: 'Veces usado',
  },
  'General.Context': {
    en: 'Context',
    se: 'Kontext',
    es: 'Contexto',
  },
  'General.Offer': {
    en: 'Offer',
    se: 'Erbjudande',
    es: 'Oferta',
  },
  'General.Repeat': {
    en: 'Repeat',
    se: 'Upprepa',
    es: 'Repetir',
  },
  'General.Completed': {
    en: 'Completed',
    se: 'Avslutad',
    es: 'Completado',
  },
  'General.Edit': {
    en: 'Edit',
    se: 'Redigera',
    es: 'Editar',
  },
  'General.CreateNew': {
    en: 'Create new',
    se: 'Skapa ny',
    es: 'Crear nuevo',
  },
  'General.Minutes': {
    en: 'Minutes',
    se: 'Minuter',
    es: 'Minutos',
  },
  'General.Hours': {
    en: 'Hours',
    se: 'Timmar',
    es: 'Horas',
  },
  'General.Days': {
    en: 'Days',
    se: 'Dagar',
    es: 'Días',
  },
  'General.Weeks': {
    en: 'Weeks',
    se: 'Veckor',
    es: 'Semanas',
  },
  'General.Months': {
    en: 'Months',
    se: 'Månader',
    es: 'Meses',
  },
  'General.Subtitle': {
    en: 'Subtitle',
    se: 'Undertitel',
    es: 'Subtítulo',
  },
  'General.RequiredField': {
    en: 'Required Field',
    se: 'Obligatoriskt fält',
    es: 'Campo requerido',
  },
  'General.Time': {
    en: 'Time',
    se: 'Tid',
    es: 'Tiempo',
  },
  'General.Back': {
    en: 'Back',
    se: 'Tillbaka',
    es: 'Atrás',
  },
  'General.PushNotification': {
    en: 'Push notification',
    se: 'Push-meddelande',
    es: 'Notificación push',
  },
  'General.UsersAndSegments': {
    en: 'Users & Segments',
    se: 'Användare & Segment',
    es: 'Usuarios y Segmentos',
  },
  'General.Optional': {
    en: 'Optional',
    se: 'Valfritt',
    es: 'Opcional',
  },
  'General.Create': {
    en: 'Create',
    se: 'Skapa',
    es: 'Crear',
  },
  'General.Update': {
    en: 'Update',
    se: 'Uppdatera',
    es: 'Actualizar',
  },
  'General.Price': {
    en: 'Price',
    se: 'Pris',
    es: 'Precio',
  },
  'General.Warning': {
    en: 'Warning',
    se: 'Varning',
    es: 'Advertencia',
  },
  'General.NamePlaceholder': {
    en: 'Fill in the name',
    se: 'Fyll i namnet',
    es: 'Rellene el nombre',
  },
  'General.Monday': {
    en: 'Monday',
    se: 'Måndag',
    es: 'Lunes',
  },
  'General.Tuesday': {
    en: 'Tuesday',
    se: 'Tisdag',
    es: 'Martes',
  },
  'General.Wednesday': {
    en: 'Wednesday',
    se: 'Onsdag',
    es: 'Miércoles',
  },
  'General.Thursday': {
    en: 'Thursday',
    se: 'Torsdag',
    es: 'Jueves',
  },
  'General.Friday': {
    en: 'Friday',
    se: 'Fredag',
    es: 'Viernes',
  },
  'General.Saturday': {
    en: 'Saturday',
    se: 'Lördag',
    es: 'Sábado',
  },
  'General.Sunday': {
    en: 'Sunday',
    se: 'Söndag',
    es: 'Domingo',
  },
  'General.Venue': {
    en: 'Venue',
    se: 'Butik',
    es: 'Lugar',
  },
  'General.AllVenues': {
    en: 'All venues',
    se: 'Alla butiker',
    es: 'Todos los lugares',
  },
  'General.FeatureDisabledForCompany': {
    en: 'is disabled for your company. Enable it in the company settings or contact administrator.',
    se: 'är inaktiverat för ditt företag. Aktivera det i företagsinställningarna eller kontakta administratören.',
    es: 'está deshabilitado para su empresa. Actívelo en la configuración de la empresa o póngase en contacto con el administrador.',
  },
  'General.Dashboard': {
    en: 'Dashboard',
    se: 'Dashboard',
    es: 'Tablero',
  },
  'General.Revenue': {
    en: 'Revenue',
    se: 'Inkomst',
    es: 'Ingresos',
  },
  'General.GiftCardSales': {
    en: 'Gift cards sold',
    se: 'Presentkort sålda',
    es: 'Tarjetas regalo',
  },
  'General.Errors': {
    en: 'Errors',
    se: 'Fel',
    es: 'Errores',
  },
  'General.Company': {
    en: 'Company',
    se: 'Företag',
    es: 'Empresa',
  },
  'General.Home': {
    en: 'Home',
    se: 'Hem',
    es: 'Inicio',
  },
  'General.Admins': {
    en: 'Admins',
    se: 'Admins',
    es: 'Admins',
  },
  'General.Companies': {
    en: 'Companies',
    se: 'Alla Företag',
    es: 'Empresas',
  },
  'General.Devices': {
    en: 'Devices',
    se: 'Enheter',
    es: 'Dispositivos',
  },
  'General.Integrations': {
    en: 'Integrations',
    se: 'Integrationer',
    es: 'Integraciones',
  },
  'General.IntegrationList': {
    en: 'Integration list',
    se: 'Integrationslista',
    es: 'Lista de integraciones',
  },
  'General.Configurations': {
    en: 'Configurations',
    se: 'Konfigurationer',
    es: 'Configuraciones',
  },
  'General.Adyen': {
    en: 'Adyen',
    se: 'Adyen',
    es: 'Adyen',
  },
  'General.AccountHolders': {
    en: 'Account holders',
    se: 'Kontoinnehavare',
    es: 'Titulares de cuenta',
  },
  'General.Payments': {
    en: 'Payments',
    se: 'Betalningar',
    es: 'Pagos',
  },
  'General.Terminals': {
    en: 'Terminals',
    se: 'Terminaler',
    es: 'Terminales',
  },
  'General.Tools': {
    en: 'Tools',
    se: 'Verktyg',
    es: 'Herramientas',
  },
  'General.DataExtractionTool': {
    en: 'Data extraction tool',
    se: 'Dataextraktionsverktyg',
    es: 'Herramienta de extracción de datos',
  },
  'General.Graveyard': {
    en: 'Deadletters',
    se: 'Deadletters',
    es: 'Deadletters',
  },
  'General.OrderCreator': {
    en: 'Order creator',
    se: 'Order skapare',
    es: 'Creador de pedidos',
  },
  'General.TableService': {
    en: 'Table service',
    se: 'Bordsservering',
    es: 'Servicio de mesa',
  },
  'General.OnlineOrdering': {
    en: 'Online Ordering',
    se: 'Online Ordering',
    es: 'Online Ordering',
  },
  'General.AdyenPayoutsInspector': {
    en: 'Adyen payouts inspector',
    se: 'Adyen payouts inspector',
    es: 'Adyen payouts inspector',
  },
  'General.AdyenTransactionsInspector': {
    en: 'Adyen transactions inspector',
    se: 'Adyen transactions inspector',
    es: 'Adyen transactions inspector',
  },
  'General.Monitoring': {
    en: 'Monitoring',
    se: 'Övervakning',
    es: 'Monitoreo',
  },
  'General.Onboarding': {
    en: 'Onboarding',
    se: 'Onboarding',
    es: 'Onboarding',
  },
  'General.ActionLogs': {
    en: 'Action logs',
    se: 'Actionsloggar',
    es: 'Registros de acciones',
  },
  'General.NotificationLogs': {
    en: 'Notification logs',
    se: 'Aviseringsloggar',
    es: 'Registros de notificaciones',
  },
  'General.Orders': {
    en: 'Orders',
    se: 'Beställningar',
    es: 'Pedidos',
  },
  'General.ZReportsDebug': {
    en: 'Z-reports (Debug)',
    se: 'Z-rapporter (Debug)',
    es: 'Z-reports (Debug)',
  },
  'General.AdyenTransactions': {
    en: 'Transactions list',
    se: 'Transaktionslista',
    es: 'Lista de transacciones',
  },
  'General.AdyenReports': {
    en: 'Transaction Fee reports',
    se: 'Transaktionsrapporter',
    es: 'Informes de transacciones',
  },
  'General.App': {
    en: 'App',
    se: 'App',
    es: 'App',
  },
  'General.Members': {
    en: 'Members',
    se: 'Medlemmar',
    es: 'Miembros',
  },
  'General.Memberships': {
    en: 'Memberships',
    se: 'Medlemskap',
    es: 'Membresías',
  },
  'General.AssignPoints': {
    en: 'Assign points',
    se: 'Tilldela poäng',
    es: 'Asignar puntos',
  },
  'General.SendCSV': {
    en: 'Send CSV',
    se: 'Skicka CSV',
    es: 'Enviar CSV',
  },
  'General.SendExcel': {
    en: 'Send excel',
    se: 'Skicka excel',
    es: 'Enviar excel',
  },
  'General.Offers': {
    en: 'Offers',
    se: 'Erbjudanden',
    es: 'Ofertas',
  },
  'General.Campaigns': {
    en: 'Campaigns',
    se: 'Kampanjer',
    es: 'Campañas',
  },
  'General.StampCards': {
    en: 'Stamp cards',
    se: 'Stämpelkort',
    es: 'Tarjetas de sello',
  },
  'General.PromoCodes': {
    en: 'Promo codes',
    se: 'Rabattkoder',
    es: 'Códigos promocionales',
  },
  'General.Notifications': {
    en: 'Notifications',
    se: 'Aviseringar',
    es: 'Notificaciones',
  },
  'General.Segments': {
    en: 'Segments',
    se: 'Segment',
    es: 'Segmentos',
  },
  'General.Store': {
    en: 'Store',
    se: 'Butik',
    es: 'Tienda',
  },
  'General.Venues': {
    en: 'Venues',
    se: 'Butiker',
    es: 'Lugares',
  },
  'General.OpeningHours': {
    en: 'Opening hours',
    se: 'Öppettider',
    es: 'Horario de apertura',
  },
  'General.VenueStatuses': {
    en: 'Venue statuses',
    se: 'Butik status',
    es: 'Estado de lugar',
  },
  'General.PaymentMethods': {
    en: 'Payment methods',
    se: 'Betalmetoder',
    es: 'Métodos de pago',
  },
  'General.ReceiptTemplates': {
    en: 'Receipt templates',
    se: 'Kvittomallar',
    es: 'Plantillas de recibo',
  },
  'General.PredefinedMessages': {
    en: 'Predefined messages',
    se: 'Förvalda meddelanden',
    es: 'Mensajes predefinidos',
  },
  'General.Content': {
    en: 'Newletters & Content',
    se: 'Nyhetsbrev & Texter',
    es: 'Boletines y contenido',
  },
  'General.Stations': {
    en: 'Stations',
    se: 'Stationer',
    es: 'Estaciones',
  },
  'General.Menus': {
    en: 'Menus',
    se: 'Menyer',
    es: 'Menús',
  },
  'General.Categories': {
    en: 'Categories',
    se: 'Kategorier',
    es: 'Categorías',
  },
  'General.Coursetypes': {
    en: 'Coursetypes',
    se: 'Rätt-typer',
    es: 'Tipos de curso',
  },
  'General.Items': {
    en: 'Items',
    se: 'Artiklar',
    es: 'Artículos',
  },
  'General.Variations': {
    en: 'Variations',
    se: 'Variationer',
    es: 'Variaciones',
  },
  'General.VariationGroups': {
    en: 'Variation groups',
    se: 'Variationsgrupper',
    es: 'Grupos de variaciones',
  },
  'General.Upsells': {
    en: 'Upsells',
    se: 'Merförsäljning',
    es: 'Ventas adicionales',
  },
  'General.PIMPOS': {
    en: 'PIM/POS',
    se: 'PIM/POS',
    es: 'PIM/POS',
  },
  'General.TSR': {
    en: 'TSR',
    se: 'TSR',
    es: 'TSR',
  },
  'General.Floorplans': {
    en: 'Floorplans',
    se: 'Planlösningar',
    es: 'Planos de planta',
  },
  'General.Tables': {
    en: 'Tables',
    se: 'Bord',
    es: 'Mesas',
  },
  'General.Zones': {
    en: 'Zones',
    se: 'Zoner',
    es: 'Zonas',
  },
  'General.TSRMonitoring': {
    en: 'TSR monitoring',
    se: 'TSR-övervakning',
    es: 'Monitoreo de TSR',
  },
  'General.ExpressPages': {
    en: 'Express pages',
    se: 'Expressidor',
    es: 'Páginas de expresión',
  },
  'General.AdyenTerminals': {
    en: 'Adyen terminals',
    se: 'Adyen terminaler',
    es: 'Terminales Adyen',
  },
  'General.ReportsMonitoring': {
    en: 'Reports monitoring',
    se: 'Rapporter övervakning',
    es: 'Monitoreo de informes',
  },
  'General.Inventory': {
    en: 'Inventory',
    se: 'Lager',
    es: 'Inventario',
  },
  'General.ShoppingCarts': {
    en: 'Shopping carts',
    se: 'Kundvagnar',
    es: 'Carritos de compras',
  },
  'General.Reports': {
    en: 'Reports',
    se: 'Rapporter',
    es: 'Informes',
  },
  'General.AppPOSReport': {
    en: 'App/POS report',
    se: 'App/POS rapport',
    es: 'Informe de App/POS',
  },
  'General.POSItemReport': {
    en: 'POS item report',
    se: 'POS artikelrapport',
    es: 'Informe de artículo POS',
  },
  'General.FortnoxReport': {
    en: 'Fortnox report',
    se: 'Fortnox rapport',
    es: 'Informe de Fortnox',
  },
  'General.ZReport': {
    en: 'Z-report',
    se: 'Z-rapport',
    es: 'Informe Z',
  },
  'General.PayoutsBeta': {
    en: 'Payouts',
    se: 'Utbetalningar ',
    es: 'Pagos',
  },
  'General.AccessLevels': {
    en: 'Access levels',
    se: 'Åtkomstnivåer',
    es: 'Niveles de acceso',
  },
  'General.AllAccessLevels': {
    en: 'All access levels',
    se: 'Alla åtkomstnivåer',
    es: 'Todos los niveles de acceso',
  },
  'General.Staff': {
    en: 'Staff',
    se: 'Personal',
    es: 'Personal',
  },
  'General.StaffReport': {
    en: 'Staff report',
    se: 'Personalrapport',
    es: 'Informe de personal',
  },
  'General.LogOut': {
    en: 'Log out',
    se: 'Logga ut',
    es: 'Cerrar sesión',
  },
  'General.Exit': {
    en: 'Exit',
    se: 'Lämna',
    es: 'Salir',
  },
  'General.SelectImage': {
    en: 'Select image',
    se: 'Välj bild',
    es: 'Seleccionar imagen',
  },
  'General.NoName': {
    en: 'No name',
    se: 'Inget namn',
    es: 'Sin nombre',
  },
  'General.SupportTicketCreated': {
    en: 'Support ticket created. We will get back to you as soon as possible.',
    se: 'Supportärende har skapats. Vi återkommer till dig så snart som möjligt.',
    es: 'Se ha creado un ticket de soporte. Nos pondremos en contacto contigo lo antes posible.',
  },
  'General.SupportTicketDescription': {
    en: 'App requests, Order receiver or Venue Manager?<br /><br />Provide what time the problem happend:<br /><br />Describe in which step the problem occured, as well what the user was trying to do.<br /><br />If this request is about the app, provide the customers phone number and/or full name:<br /><br />',
    se: 'Gäller det app, ordermottagare eller VM?<br /><br />Ange tidpunkt när problemet inträffade:<br /><br />Beskriv i vilket steg som problemet inträffade samt vad användaren försökte utföra:<br /><br />Om det gäller appen, ange kundens mobilnummer och/eller fullt namn:<br /><br />',
    es: '¿Se trata de una solicitud de aplicación, un receptor de pedidos o un administrador de instalaciones?<br /><br />Proporcione la hora en que ocurrió el problema:<br /><br />Describa en qué paso ocurrió el problema, así como lo que el usuario estaba tratando de hacer.<br /><br />Si esta solicitud se refiere a la aplicación, proporcione el número de teléfono y / o el nombre completo del cliente:<br /><br />',
  },
  'General.Support': {
    en: 'Support',
    se: 'Support',
    es: 'Soporte',
  },
  'General.UnsavedMessage': {
    en: 'If you leave the page, all unsaved data will be lost.',
    se: 'Om du lämnar sidan kommer all osparad data att gå förlorad.',
    es: 'Si deja la página, se perderán todos los datos no guardados.',
  },
  'General.DropFileText': {
    en: 'Drop file here or click to select',
    se: 'Släpp filen här eller klicka för att välja',
    es: 'Suelta el archivo aquí o haz clic para seleccionar',
  },
  'General.DropFileDropText': {
    en: 'Drop file here...',
    se: 'Släpp filen här...',
    es: 'Suelta el archivo aquí...',
  },
  'General.Sales': {
    en: 'Sales',
    se: 'Försäljning',
    es: 'Ventas',
  },
  'General.Total': {
    en: 'Total',
    se: 'Total',
    es: 'Total',
  },
  'General.TotalVat': {
    en: 'Total VAT',
    se: 'Total Moms',
    es: 'Total IVA',
  },
  'General.TotalOrders': {
    en: 'Total orders',
    se: 'Totalt antal beställningar',
    es: 'Total de pedidos',
  },
  'General.Payment': {
    en: 'Payment',
    se: 'Betalning',
    es: 'Pago',
  },
  'General.Paid': {
    en: 'Paid',
    se: 'Betalt',
    es: 'Pagado',
  },
  'General.Refunded': {
    en: 'Refunded',
    se: 'Återbetalt',
    es: 'Reembolsado',
  },
  'General.Claimed': {
    en: 'Claimed',
    se: 'Tagen',
    es: 'Reclamado',
  },
  'General.Confirmed': {
    en: 'Confirmed',
    se: 'Bekräftad',
    es: 'Confirmado',
  },
  'General.Vat': {
    en: 'VAT',
    se: 'Moms',
    es: 'IVA',
  },
  'General.Discounts': {
    en: 'Discounts',
    se: 'Rabatter',
    es: 'Descuentos',
  },
  'General.Tips': {
    en: 'Tips',
    se: 'Dricks',
    es: 'Propinas',
  },
  'General.Tip': {
    en: 'Tip',
    se: 'Dricks',
    es: 'Propina',
  },
  'General.Refunds': {
    en: 'Refunds',
    se: 'Återbetalningar',
    es: 'Reembolsos',
  },
  'General.Filters': {
    en: 'Filters',
    se: 'Filter',
    es: 'Filtros',
  },
  'General.EventType': {
    en: 'Event type',
    se: 'Event typ',
    es: 'Tipo de evento',
  },
  'General.InfoMeta': {
    en: 'Info / meta',
    se: 'Info / meta',
    es: 'Info / meta',
  },
  'General.Export': {
    en: 'Export',
    se: 'Export',
    es: 'Exportar',
  },
  'General.Action': {
    en: 'Action',
    se: 'Action',
    es: 'Acción',
  },
  'General.Value': {
    en: 'Value',
    se: 'Värde',
    es: 'Valor',
  },
  'General.Info': {
    en: 'Info',
    se: 'Info',
    es: 'Info',
  },
  'General.User': {
    en: 'User',
    se: 'Användare',
    es: 'Usuario',
  },
  'General.Remove': {
    en: 'Remove',
    se: 'Ta bort',
    es: 'Eliminar',
  },
  'General.Code': {
    en: 'Code',
    se: 'Kod',
    es: 'Código',
  },
  'General.Message': {
    en: 'Message',
    se: 'Meddelande',
    es: 'Mensaje',
  },
  'General.Type': {
    en: 'Type',
    se: 'Typ',
    es: 'Tipo',
  },
  'General.Item': {
    en: 'Item',
    se: 'Artikel',
    es: 'Artículo',
  },
  'General.Cheque': {
    en: 'Cheque',
    se: 'Nota',
    es: 'Cheque',
  },
  'General.Order': {
    en: 'Order',
    se: 'Order',
    es: 'Orden',
  },
  'General.OrderHigherComesFirst': {
    en: 'Order (higher comes first)',
    se: 'Ordning (högre kommer först)',
    es: 'Orden (mayor primero)',
  },
  'General.Image': {
    en: 'Image',
    se: 'Bild',
    es: 'Imagen',
  },
  'General.Icon': {
    en: 'Icon',
    se: 'Ikon',
    es: 'Icono',
  },
  'General.Tomorrow': {
    en: 'Tomorrow',
    se: 'Imorgon',
    es: 'Mañana',
  },
  'General.Last': {
    en: 'Last',
    se: 'Sista',
    es: 'Último',
  },
  'General.Comment': {
    en: 'Comment',
    se: 'Kommentar',
    es: 'Comentario',
  },
  'General.Membership': {
    en: 'Membership',
    se: 'Medlemskap',
    es: 'Membresía',
  },
  'General.WriteEmailAddress': {
    en: 'Write email address...',
    se: 'Skriv e-postadress...',
    es: 'Escribe la dirección de correo electrónico...',
  },
  'General.LoadingThreeDots': {
    en: 'Loading...',
    se: 'Laddar...',
    es: 'Cargando...',
  },
  'General.Product': {
    en: 'Product',
    se: 'Produkt',
    es: 'Producto',
  },
  'General.Yes': {
    en: 'YES',
    se: 'JA',
    es: 'SI',
  },
  'General.No': {
    en: 'NO',
    se: 'NEJ',
    es: 'NO',
  },
  'General.ChooseVenue': {
    en: 'Choose venue',
    se: 'Välj butik',
    es: 'Elegir lugar',
  },
  'General.SomethingWentWrong': {
    en: 'Something went wrong',
    se: 'Något gick fel',
    es: 'Algo salió mal',
  },
  'General.SomethingWentWrongTryAgain': {
    en: 'Something went wrong, try again.',
    se: 'Något gick fel, försök igen.',
    es: 'Algo salió mal, inténtalo de nuevo.',
  },
  'General.Username': {
    en: 'Username',
    se: 'Användarnamn',
    es: 'Nombre de usuario',
  },
  'General.Role': {
    en: 'Role',
    se: 'Roll',
    es: 'Rol',
  },
  'General.Registred': {
    en: 'Registred',
    se: 'Registrerad',
    es: 'Registrado',
  },
  'General.Unknown': {
    en: 'Unknown',
    se: 'Okänd',
    es: 'Desconocido',
  },
  'General.Welcome': {
    en: 'Welcome!',
    se: 'Välkommen!',
    es: '¡Bienvenido!',
  },
  'General.Next': {
    en: 'Next',
    se: 'Nästa',
    es: 'Siguiente',
  },
  'General.Previous': {
    en: 'Previous',
    se: 'Föregående',
    es: 'Anterior',
  },
  'General.Login': {
    en: 'Login',
    se: 'Logga in',
    es: 'Iniciar sesión',
  },
  'General.Confirm': {
    en: 'Confirm',
    se: 'Bekräfta',
    es: 'Confirmar',
  },
  'General.CreateAccount': {
    en: 'Create account',
    se: 'Skapa konto',
    es: 'Crear cuenta',
  },
  'General.SomethingIsWrong': {
    en: 'Something is wrong',
    se: 'Något är fel',
    es: 'Algo está mal',
  },
  'General.Identity': {
    en: 'Identity',
    se: 'Identitet',
    es: 'Identidad',
  },
  'General.PayoutMethod': {
    en: 'Payout method',
    se: 'Betalmetod',
    es: 'Método de pago',
  },
  'General.Passport': {
    en: 'Passport',
    se: 'Pass',
    es: 'Pasaporte',
  },
  'General.BankAccount': {
    en: 'Bank account',
    se: 'Bankkonto',
    es: 'Cuenta bancaria',
  },
  'General.Payouts': {
    en: 'Payouts',
    se: 'Utbetalningar',
    es: 'Pagos',
  },
  'General.Products': {
    en: 'Products',
    se: 'Produkter',
    es: 'Productos',
  },
  'General.Add': {
    en: 'Add',
    se: 'Lägg till',
    es: 'Añadir',
  },
  'General.ExportImport': {
    en: 'Export/Import',
    se: 'Exportera/Importera',
    es: 'Exportar/Importar',
  },
  'General.CreateMenu': {
    en: 'Create menu',
    se: 'Skapa meny',
    es: 'Crear menú',
  },
  'General.RequestFailedPleaseTryAgain': {
    en: 'Request failed. Please try again',
    se: 'Begäran misslyckades. Var god försök igen.',
    es: 'La solicitud falló. Por favor, inténtelo de nuevo',
  },
  'General.State': {
    en: 'State',
    se: 'State',
    es: 'Estado',
  },
  'General.TransactionCost': {
    en: 'Transaction cost',
    se: 'Transaktionskostnad',
    es: 'Costo de transacción',
  },
  'General.ComingSoon': {
    en: 'Coming soon',
    se: 'Kommer snart',
    es: 'Próximamente',
  },
  'General.SelectVenues': {
    en: 'Select venues',
    se: 'Välj butiker',
    es: 'Seleccionar lugares',
  },
  'General.Label': {
    en: 'Label',
    se: 'Label',
    es: 'Etiqueta',
  },
  'General.FullName': {
    en: 'Full Name',
    se: 'Fullständigt namn',
    es: 'Nombre completo',
  },
  'General.Color': {
    en: 'Color',
    se: 'Färg',
    es: 'Color',
  },
  'General.ChooseColor': {
    en: 'Choose color',
    se: 'Välj färg',
    es: 'Elegir color',
  },
  'General.EnterText': {
    en: 'Enter text',
    se: 'Skriv text',
    es: 'Escriba el texto',
  },
  'General.Choose': {
    en: 'Choose',
    se: 'Välj',
    es: 'Elegir',
  },
  'General.ChooseVAT': {
    en: 'Choose VAT',
    se: 'Välj Moms',
    es: 'Elegir IVA',
  },
  'General.AddArticles': {
    en: 'Add articles',
    se: 'Lägg till artiklar',
    es: 'Añadir artículos',
  },
  'General.AddIngredients': {
    en: 'Add ingredients',
    se: 'Lägg till ingredienser',
    es: 'Añadir ingredientes',
  },
  'General.AddUpsales': {
    en: 'Add upsales',
    se: 'Lägg till upsales',
    es: 'Añadir upsales',
  },
  'General.AddIngredientGroups': {
    en: 'Add ingredient groups',
    se: 'Lägg till ingrediensgrupper',
    es: 'Añadir grupos de ingredientes',
  },
  'General.AddExtraIngredients': {
    en: 'Add extra ingredients',
    se: 'Lägg till extra ingredienser',
    es: 'Añadir ingredientes extra',
  },
  'General.CouldntFindResults': {
    en: 'Could not find any results for',
    se: 'Kunde inte hitta några resultat för',
    es: 'No se encontraron resultados para',
  },
  'General.CheckSpelling': {
    en: 'Check your spelling',
    se: 'Kontrollera din stavning',
    es: 'Revisa la ortografía',
  },
  'General.CheckSpellingOrCreate': {
    en: 'Check your spelling, or create the',
    se: 'Kontrollera din stavning eller skapa',
    es: 'Revisa la ortografía o crea el',
  },
  'General.AddIngredient': {
    en: 'Add new ingredient',
    se: 'Lägg till ny ingrediens',
    es: 'Añadir nuevo ingrediente',
  },
  'General.AddUpsellGroup': {
    en: 'Add new upsell group',
    se: 'Lägg till ny merförsäljnings-grupp',
    es: 'Añadir nuevo grupo de upsales',
  },
  'General.AddGroup': {
    en: 'Add new group',
    se: 'Lägg till ny grupp',
    es: 'Añadir nuevo grupo',
  },
  'General.Uploading': {
    en: 'Uploading',
    se: 'Laddar upp',
    es: 'Subiendo',
  },
  'General.ImageTooBig': {
    en: 'The image is too big, maximum size is 5mb',
    se: 'Bilden är för stor, maximal storlek är 5mb',
    es: 'La imagen es demasiado grande, el tamaño máximo es de 5mb',
  },
  'General.UploadFailed': {
    en: 'Upload failed',
    se: 'Uppladdningen misslyckades',
    es: 'La carga falló',
  },
  'General.Uploaded': {
    en: 'Uploaded',
    se: 'Uppladdad',
    es: 'Subido',
  },
  'General.NumberOfItems': {
    en: 'Number of items',
    se: 'Antal artiklar',
    es: 'Número de artículos',
  },
  'General.Rule': {
    en: 'Rule',
    se: 'Regel',
    es: 'Regla',
  },
  'General.AddRule': {
    en: '+ Add rule',
    se: '+ Lägg till regel',
    es: '+ Añadir regla',
  },
  'General.QueryAndParse': {
    en: 'Query and parse',
    se: 'Query and parse',
    es: 'Query and parse',
  },
  'General.DefaultOptional': {
    en: 'Default (Optional)',
    se: 'Standard (Valfritt)',
    es: 'Predeterminado (Opcional)',
  },
  'General.DeliveryRates': {
    en: 'Delivery rates',
    se: 'Leveranspriser',
    es: 'Tarifas de entrega',
  },
  'General.CreateDelivery': {
    en: 'Create delivery',
    se: 'Skapa leverans',
    es: 'Crear entrega',
  },
  'General.DeliveryCost': {
    en: 'Delivery cost',
    se: 'Leveranskostnad',
    es: 'Costo de entrega',
  },
  'General.DeliveryMessage': {
    en: 'Delivery message',
    se: 'Leveransmeddelande',
    es: 'Mensaje de entrega',
  },
  'General.DeliveryArea': {
    en: 'Delivery area',
    se: 'Leveransområde',
    es: 'Área de entrega',
  },
  'General.CreateVariation': {
    en: 'Create variation',
    se: 'Skapa variation',
    es: 'Crear variación',
  },
  'General.LastActive': {
    en: 'Last active',
    se: 'Senast aktiv',
    es: 'Última actividad',
  },
  'General.POSDevices': {
    en: 'POS devices',
    se: 'POS enheter',
    es: 'Dispositivos POS',
  },
  'General.CreateDevice': {
    en: 'Create device',
    se: 'Skapa enhet',
    es: 'Crear dispositivo',
  },
  'General.NotRequired': {
    en: 'Not required',
    se: 'Krävs inte',
    es: 'No requerido',
  },
  'General.ChooseMenu': {
    en: 'Choose menu(s)',
    se: 'Välj meny(er)',
    es: 'Elegir menú(s)',
  },
  'General.DefaultPrice': {
    en: 'Default price',
    se: 'Standardpris',
    es: 'Precio predeterminado',
  },
  'General.CreateItem': {
    en: 'Create item',
    se: 'Skapa artikel',
    es: 'Crear artículo',
  },
  'General.UseManualPrice': {
    en: 'Use manual price',
    se: 'Använd manuellt pris',
    es: 'Usar precio manual',
  },
  'General.VolumeWeight': {
    en: 'Volume / Weight',
    se: 'Volym / Vikt',
    es: 'Volumen / Peso',
  },
  'General.AgeRestricted': {
    en: 'Age restricted (18+)',
    se: 'Åldergräns (18+)',
    es: 'Restringido por edad (18+)',
  },
  'General.DisableMembershipDiscount': {
    en: 'Disable Membership Discount',
    se: 'Inaktivera medlemsrabatt',
    es: 'Deshabilitar descuento de membresía',
  },
  'General.ManageInventoryAtEndOfDay': {
    en: 'Manage inventory at the end of day',
    se: 'Hantera lager i slutet av dagen',
    es: 'Administrar inventario al final del día',
  },
  'General.DefaultOrderStatusKDS': {
    en: 'Default order status in KDS',
    se: 'Standardorderstatus i KDS',
    es: 'Estado de pedido predeterminado en KDS',
  },
  'General.AcceptedBlue': {
    en: 'Accepted (Blue)',
    se: 'Accepterad (Blå)',
    es: 'Aceptado (Azul)',
  },
  'General.FinalizingOrange': {
    en: 'Finalizing (Orange)',
    se: 'Slutför (Orange)',
    es: 'Finalizando (Naranja)',
  },
  'General.ReadyGreen': {
    en: 'Ready (Green)',
    se: 'Redo (Grön)',
    es: 'Listo (Verde)',
  },
  'General.DefaultVariations': {
    en: 'Default Variations',
    se: 'Standard variationer',
    es: 'Variaciones predeterminadas',
  },
  'General.ExpandedByDefault': {
    en: 'Expanded By Default',
    se: 'Expanderad Som Standard',
    es: 'Expandido Por Defecto',
  },
  'General.VariationGroup': {
    en: 'Variation group',
    se: 'Variation grupp',
    es: 'Grupo de variación',
  },
  'General.TagsEnterToAdd': {
    en: 'Tags (Enter to add)',
    se: 'Taggar (Enter för att lägga till)',
    es: 'Etiquetas (Enter para agregar)',
  },
  'General.Required': {
    en: 'Required',
    se: 'Obligatorisk',
    es: 'Requerido',
  },
  'General.Layouts': {
    en: 'Layouts',
    se: 'Layouter',
    es: 'Diseños',
  },
  'General.CreateLayout': {
    en: 'Create layout',
    se: 'Skapa layout',
    es: 'Crear diseño',
  },
  'General.ShowDebugData': {
    en: 'Show debug data',
    se: 'Visa felsökningsdata',
    es: 'Mostrar datos de depuración',
  },
  'General.Address': {
    en: 'Address',
    se: 'Adress',
    es: 'Dirección',
  },
  'General.NoLocation': {
    en: 'No location',
    se: 'Ingen plats',
    es: 'Sin ubicación',
  },
  'General.Pages': {
    en: 'Pages',
    se: 'Sidor',
    es: 'Páginas',
  },
  'General.CreatePage': {
    en: 'Create page',
    se: 'Skapa sida',
    es: 'Crear página',
  },
  'General.POSCategories': {
    en: 'POS Categories',
    se: 'POS Kategorier',
    es: 'Categorías POS',
  },
  'General.CreatePOSCategory': {
    en: 'Create POS category',
    se: 'Skapa POS kategori',
    es: 'Crear categoría POS',
  },
  'General.MembershipLevel': {
    en: 'Membership level',
    se: 'Medlemskapsnivå',
    es: 'Nivel de membresía',
  },
  'General.CreateItemSize': {
    en: 'Create Item Size',
    se: 'Skapa artikel storlek',
    es: 'Crear tamaño de artículo',
  },
  'General.ViewType': {
    en: 'View type',
    se: 'Visa typ',
    es: 'Ver tipo',
  },
  'General.VenuesOptional': {
    en: 'Venues (optional)',
    se: 'Butiker (valfri)',
    es: 'Lugares (opcional)',
  },
  'General.Device': {
    en: 'Device',
    se: 'Enhet',
    es: 'Dispositivo',
  },
  'General.Status': {
    en: 'Status',
    se: 'Status',
    es: 'Estado',
  },
  'General.IP': {
    en: 'IP',
    se: 'IP',
    es: 'IP',
  },
  'General.LastTransaction': {
    en: 'Last transaction',
    se: 'Senaste transaktionen',
    es: 'Última transacción',
  },
  'General.LastActivity': {
    en: 'Last activity',
    se: 'Senaste aktiviteten',
    es: 'Última actividad',
  },
  'General.LiveUpdates': {
    en: 'Live updates',
    se: 'Liveuppdateringar',
    es: 'Actualizaciones en vivo',
  },
  'General.UserNameOrEmail': {
    en: 'User name or email',
    se: 'Användarnamn eller e-postadress',
    es: 'Nombre de usuario o correo electrónico',
  },
  'General.OfferName': {
    en: 'Offer name',
    se: 'Erbjudandets namn',
    es: 'Nombre de la oferta',
  },
  'General.UpsellItems': {
    en: 'Upsell items',
    se: 'Merförsäljnings-artiklar',
    es: 'Artículos de venta cruzada',
  },
  'General.UsedOn': {
    en: 'Used on',
    se: 'Används på',
    es: 'Usado en',
  },
  'General.ActivateUser': {
    en: 'Activating...',
    se: 'Aktiverar...',
    es: 'Activando...',
  },
  'General.Article': {
    en: 'article',
    se: 'artikel',
    es: 'artículo',
  },
  'General.Articles': {
    en: 'articles',
    se: 'artiklar',
    es: 'artículos',
  },
  'General.OtherFunctions': {
    en: 'Other functions',
    se: 'Andra funktioner',
    es: 'Otras funciones',
  },
  'General.Analytics': {
    en: 'Analytics',
    se: 'Analys',
    es: 'Analítica',
  },
  'General.Password': {
    en: 'Password',
    se: 'Lösenord',
    es: 'Contraseña',
  },
  'General.Licenses': {
    en: 'Licenses',
    se: 'Licenser',
    es: 'Licenses',
  },
  'General.Enabled': {
    en: 'Enabled',
    se: 'Aktiverad',
    es: 'Habilitado',
  },
  'General.In': {
    en: 'in',
    se: 'i',
    es: 'en',
  },
  'General.Beepers': {
    en: 'Beepers',
    se: 'Puckar',
    es: 'Pagers',
  },
  'Express.ExpressPages': {
    en: 'Expres pages',
    se: 'Expressidor',
    es: 'Páginas de expresión',
  },
  'Express.CreateExpressPage': {
    en: 'Create express page',
    se: 'Skapa expresssida',
    es: 'Crear página de expresión',
  },
  'ExportImport.Title': {
    en: 'Export and import articles',
    se: 'Exportera och importera artiklar',
    es: 'Exportar e importar artículos',
  },
  'ExportImport.Description': {
    en: 'Add and edit several articles and menus',
    se: 'Lägg till och redigera flera artiklar och menyer',
    es: 'Agregue y edite varios artículos y menús',
  },
  'ExportImport.Completed': {
    en: 'Import was completed',
    se: 'Importen slutfördes',
    es: 'La importación se completó',
  },
  'ExportImport.ErrorDescription': {
    en: 'Please reupload your file with following corrections to proceed the import',
    se: 'Ladda upp din fil igen med följande korrigeringar',
    es: 'Vuelva a cargar su archivo con las siguientes correcciones para continuar con la importación',
  },
  'ExportImport.ImportArticles': {
    en: 'Import articles',
    se: 'Importera artiklar',
    es: 'Importar artículos',
  },
  'ExportImport.ArticlesAdded': {
    en: 'Articles have been added',
    se: 'Artiklar har lagts till',
    es: 'Los artículos se han agregado',
  },
  'ExportImport.ImportArticlesDescription': {
    en: 'Create all categories and course types before you import the articles. You can choose which menu you want the articles to be added to.',
    se: 'Skapa alla kategorier och kurstyper innan du importerar artiklarna. Du kan välja vilken meny du vill att artiklarna ska läggas till.',
    es: 'Cree todas las categorías y tipos de curso antes de importar los artículos. Puede elegir qué menú desea agregar los artículos.',
  },
  'Dashboard.SelectChannels': {
    en: 'Select channels',
    se: 'Välj kanaler',
    es: 'Seleccionar canales',
  },
  'Dashboard.Live': {
    en: 'Live',
    se: 'Direkt',
    es: 'En vivo',
  },
  'Dashboard.DelayedData': {
    en: 'Data might be delayed up to 15 minutes',
    se: 'Datan kan vara försenad med upp till 15 minuter',
    es: 'Los datos pueden retrasarse hasta 15 minutos',
  },
  'Dashboard.Revenue': {
    en: 'Revenue',
    se: 'Inkomst',
    es: 'Ingresos',
  },
  'Dashboard.UserConversion': {
    en: 'User conversion',
    se: 'Användarkonvertering',
    es: 'Conversión de usuario',
  },
  'Dashboard.Usage': {
    en: 'Usage',
    se: 'Bruk',
    es: 'Uso',
  },
  'Dashboard.OrderStats': {
    en: 'Order stats',
    se: 'Beställningsstatistik',
    es: 'Estadísticas de pedidos',
  },
  'Dashboard.HourlySales': {
    en: 'Hourly sales',
    se: 'Försäljning per timme',
    es: 'Ventas por hora',
  },
  'Dashboard.MostActiveVenues': {
    en: 'Most active venues',
    se: 'Mest aktiva butiker',
    es: 'Los lugares más activos',
  },
  'Dashboard.TopCategories': {
    en: 'Top categories',
    se: 'Toppkategorier',
    es: 'Categorías principales',
  },
  'Dashboard.MostPopularItems': {
    en: 'Most popular items',
    se: 'Mest populära artiklar',
    es: 'Los artículos más populares',
  },
  'Dashboard.AllItems': {
    en: 'All items',
    se: 'Alla artiklar',
    es: 'Todos los artículos',
  },
  'Dashboard.Venues': {
    en: 'Venues',
    se: 'Butiker',
    es: 'Lugares',
  },
  'Dashboard.Channels': {
    en: 'Channels',
    se: 'Kanaler',
    es: 'Canales',
  },
  'Dashboard.TotalRevenue': {
    en: 'Total revenue',
    se: 'Total inkomst',
    es: 'Ingresos totales',
  },
  'Dashboard.TotalRevenueNet': {
    en: 'Total revenue (net)',
    se: 'Total inkomst (netto)',
    es: 'Ingresos totales (netos)',
  },
  'Dashboard.TotalRevenueGross': {
    en: 'Total revenue (gross)',
    se: 'Total inkomst (brutto)',
    es: 'Ingresos totales (brutos)',
  },
  'Dashboard.AfterDiscounts': {
    en: 'After discounts',
    se: 'Efter rabatter',
    es: 'Después de descuentos',
  },
  'Dashboard.AppDownloads': {
    en: 'App downloads',
    se: 'App-nedladdningar',
    es: 'Descargas de aplicaciones',
  },
  'Dashboard.NewUsers': {
    en: 'New users',
    se: 'Nya användare',
    es: 'Nuevos usuarios',
  },
  'Dashboard.TotalOrders': {
    en: 'Total orders',
    se: 'Totala beställningar',
    es: 'Pedidos totales',
  },
  'Dashboard.TotalDiscount': {
    en: 'Total discount',
    se: 'Total rabatt',
    es: 'Descuento total',
  },
  'Dashboard.AverageSale': {
    en: 'Average sale (revenue/orders)',
    se: 'Genomsnittlig försäljning (inkomst/order)',
    es: 'Venta promedio (ingresos / pedidos)',
  },
  'Dashboard.TakeAway': {
    en: 'Take away',
    se: 'Hämtmat',
    es: 'Para llevar',
  },
  'Dashboard.Delivery': {
    en: 'Delivery',
    se: 'Leverans',
    es: 'Entrega',
  },
  'Dashboard.EatHere': {
    en: 'Eat here',
    se: 'Äta här',
    es: 'Comer aquí',
  },
  'Dashboard.Accepted': {
    en: 'Accepted',
    se: 'Accepterad',
    es: 'Aceptado',
  },
  'General.Rejected': {
    en: 'Rejected',
    se: 'Avvisad',
    es: 'Rechazado',
  },
  'Dashboard.Venue': {
    en: 'Venue',
    se: 'Butik',
    es: 'Lugar',
  },
  'Dashboard.Orders': {
    en: 'Orders',
    se: 'Beställningar',
    es: 'Pedidos',
  },
  'General.Category': {
    en: 'Category',
    se: 'Kategori',
    es: 'Categoría',
  },
  'General.Printers': {
    en: 'Printers',
    se: 'Skrivare',
    es: 'Impresoras',
  },
  'Dashboard.Item': {
    en: 'Item',
    se: 'Artikel',
    es: 'Artículo',
  },
  'Dashboard.Deleted': {
    en: 'Deleted',
    se: 'Borttagen',
    es: 'Eliminado',
  },
  'Dashboard.MostPopularWeekDays': {
    en: 'Most popular week days',
    se: 'Mest populära veckodagarna',
    es: 'Días de la semana más populares',
  },
  'Offers.Offers': {
    en: 'Offers',
    se: 'Erbjudanden',
    es: 'Ofertas',
  },
  'Offers.CreateOffer': {
    en: 'Create offer',
    se: 'Skapa erbjudande',
    es: 'Crear oferta',
  },
  'Offers.DefaultOffer': {
    en: 'Default offer',
    se: 'Standarderbjudande',
    es: 'Oferta predeterminada',
  },
  'Offers.SingleUseDefault': {
    en: 'Can only be used once',
    se: 'Får endast användas en gång',
    es: 'Solo se puede usar una vez',
  },
  'Offers.EnableOffer': {
    en: 'Enable offer',
    se: 'Aktivera erbjudande',
    es: 'Habilitar oferta',
  },
  'Offers.OnlyShowOfferIn': {
    en: 'Only show offer in',
    se: 'Visa endast erbjudande i',
    es: 'Mostrar solo oferta en',
  },
  'Offers.SelectImage': {
    en: 'Select an image',
    se: 'Välj en bild',
    es: 'Seleccionar una imagen',
  },
  'Offers.SelectOfferType': {
    en: 'Select offer type',
    se: 'Välj erbjudandetyp',
    es: 'Seleccione el tipo de oferta',
  },
  'Offers.CategoriesIncluded': {
    en: 'Categories included in this offer',
    se: 'Kategorier som ingår i detta erbjudande',
    es: 'Categorías incluidas en esta oferta',
  },
  'Offers.StagedOffer': {
    en: 'Staged offer',
    se: 'Stegvis erbjudande',
    es: 'Oferta de escenario',
  },
  'Offers.StagedOfferDescription': {
    en: 'Good for more advanced offers, for example "Buy lunch and get a drink for half the price"',
    se: 'Bra för mer avancerade erbjudanden, t.ex "Köp lunch och få dricka för halva priset"',
    es: 'Bueno para ofertas más avanzadas, por ejemplo "Compre el almuerzo y obtenga una bebida a la mitad del precio"',
  },
  'Offers.OrderOffer': {
    en: 'Order offer',
    se: 'Order erbjudande',
    es: 'Oferta de pedido',
  },
  'Offers.OrderOfferDescription': {
    en: 'Apply a discount on the whole order. E.g. "10% discount on your next order"',
    se: 'Apply a discount on the whole order. E.g. "10% discount on your next order"',
    es: 'Aplicar un descuento en todo el pedido. Por ejemplo "10% de descuento en su próximo pedido"',
  },
  'Offers.BundleOffer': {
    en: 'Bundle offer',
    se: 'Grupperat erbjudande',
    es: 'Oferta de paquete',
  },
  'Offers.BundleOfferDescription': {
    en: 'A bundle is a fixed group of items. E.g. "Buy 10 cinnamon buns for half price"',
    se: 'En grupp är en fast grupp produkter. T.ex "Köp 10 kanelbullar för halva priset"',
    es: 'Un paquete es un grupo fijo de artículos. Por ejemplo "Compre 10 bollos de canela a la mitad de precio"',
  },
  'Offers.VisualOffer': {
    en: 'Visual offer',
    se: 'Visuellt erbjudande',
    es: 'Oferta visual',
  },
  'Offers.VisualOfferDescription': {
    en: 'A visual offer is meant for offers which should be shown to the staff in-person.',
    se: 'Ett visuellt erbjudande är menat för erbjudanden som ska visas till kassa-personal.',
    es: 'Una oferta visual está destinada a ofertas que deben mostrarse al personal en persona.',
  },
  'Offers.DiscountStageIndividually': {
    en: 'Discount each stage individually',
    se: 'Rabattera varje steg individuellt',
    es: 'Descuento por etapa individualmente',
  },
  'Offers.DiscountStageIndividuallyDescription': {
    en: 'Each stage will have its own indivudal discount. Good for offers like "Buy 2 and get the third one for free".',
    se: 'Varje steg kommer ha sin egen rabatt. Bra för erbjudanden såsom "Köp två och få den tredje gratis".',
    es: 'Cada etapa tendrá su propio descuento individual. Bueno para ofertas como "Compre 2 y obtenga el tercero gratis".',
  },
  'Offers.DiscountAsBundle': {
    en: 'Discount as bundle',
    se: 'Rabattera som grupp',
    es: 'Descuento como paquete',
  },
  'Offers.DiscountAsBundleDescriptionPart1': {
    en: 'Discounting as a bundle will apply one discount on the whole package. Good for offers like "Get 50',
    se: 'Rabattering som grupp kommer applicera en rabatt på hela paketet. Bra för erbjudanden såsom "Få 50"',
    es: 'Descuento como paquete aplicará un descuento en todo el paquete. Bueno para ofertas como "Obtenga 50"',
  },
  'Offers.DiscountAsBundleDescriptionPart2': {
    en: 'discount when buying two lunches"',
    se: 'rabatt när du köper två luncher',
    es: 'descuento al comprar dos almuerzos',
  },
  'Offers.DiscountType': {
    en: 'Discount type',
    se: 'Rabattyp',
    es: 'Tipo de descuento',
  },
  'Offers.PercentagePoints': {
    en: 'Percentage points',
    se: 'Procentenheter',
    es: 'Puntos porcentuales',
  },
  'Offers.RelativeNumber': {
    en: 'Relative number',
    se: 'Relativ siffra',
    es: 'Número relativo',
  },
  'Offers.FixedValue': {
    en: 'Fixed value',
    se: 'Fast värde',
    es: 'Valor fijo',
  },
  'Offers.DiscountRate': {
    en: 'Discount rate',
    se: 'Rabattsats',
    es: 'Tasa de descuento',
  },
  'Offers.NoStages': {
    en: 'You have not added any stages. Get started by adding a stage',
    se: 'Du har inte lagt till några steg. Börja med att lägga till ett steg.',
    es: 'No ha agregado ninguna etapa. Comience agregando una etapa',
  },
  'Offers.AddStage': {
    en: '+ Add stage',
    se: '+ Lägg till steg',
    es: '+ Agregar etapa',
  },
  'Notifications.Notifications': {
    en: 'Notifications',
    se: 'Aviseringar',
    es: 'Notificaciones',
  },
  'Notifications.AtLeastOneUserOrSegment': {
    en: 'You need to add at least one user or segment',
    se: 'Du måste lägga till minst en användare eller segment',
    es: 'Debe agregar al menos un usuario o segmento',
  },
  'Notifications.AtLeastOneNotificationOrOffer': {
    en: 'You need to add a notification, an offer, or both',
    se: 'Du måste lägga till en avisering, ett erbjudande eller båda',
    es: 'Debe agregar una notificación, una oferta o ambas',
  },
  'Notifications.OnlyOfferOrContent': {
    en: 'You can only select offer or content, not both at once',
    se: 'Du kan bara välja erbjudande eller innehåll, inte båda samtidigt',
    es: 'Solo puede seleccionar oferta o contenido, no ambos a la vez',
  },
  'Notifications.SelectOffer': {
    en: 'Select an offer to send out',
    se: 'Välj ett erbjudande att skicka ut',
    es: 'Seleccione una oferta para enviar',
  },
  'Notifications.OfferDescription': {
    en: `If an offer is selected, pressing "submit" will let all targeted users use the offer. It may
        take a minute to deliver the offer to all users depending on the size of the target group.`,
    se: `Om ett erbjudande väljs kommer alla inriktade användare att använda erbjudandet genom att trycka på "skicka". Det kan
    ta en minut att leverera erbjudandet till alla användare beroende på målgruppens storlek.`,
    es: `Si se selecciona una oferta, presionar "enviar" permitirá que todos los usuarios objetivos usen la oferta. Puede
    tomar un minuto entregar la oferta a todos los usuarios dependiendo del tamaño del grupo objetivo.`,
  },
  'Notifications.PushNotificationDescription': {
    en: `A push notfication can be sent standalone or together with an offer. If an offer is
        specified, clicking the push notification will open the offer.`,
    se: `En push-notis kan skickas fristående eller tillsammans med ett erbjudande. Om ett erbjudande anges öppnas erbjudandet genom att klicka på push-meddelandet.`,
    es: `Una notificación push se puede enviar de forma independiente o junto con una oferta. Si se especifica una oferta, hacer clic en la notificación push abrirá la oferta.`,
  },
  'Notifications.SelectTargetGroup': {
    en: 'Select target group',
    se: 'Välj målgrupp',
    es: 'Seleccione grupo objetivo',
  },
  'Monitoring.LastSeen': {
    en: 'Last seen',
    se: 'Senast sedd',
    es: 'Visto por última vez',
  },
  'Monitoring.Never': {
    en: 'never',
    se: 'aldrig',
    es: 'nunca',
  },
  'Monitoring.Version': {
    en: 'version',
    se: 'version',
    es: 'versión',
  },
  'Monitoring.OrderHistory': {
    en: 'Order history',
    se: 'Beställningshistorik',
    es: 'Historial de pedidos',
  },
  'Monitoring.OrderDescription': {
    en: 'See all reciepts for a venue',
    se: 'Se alla kvitton för en butik',
    es: 'Ver todos los recibos de un lugar',
  },
  'Monitoring.OrderTableNo': {
    en: 'Order/Table no.',
    se: 'Beställnings- eller bordsnummer',
    es: 'Pedido/número de mesa',
  },
  'Monitoring.OrderAmount': {
    en: 'Order amount',
    se: 'Summa',
    es: 'Monto del pedido',
  },
  'Monitoring.SelectPaymentMethod': {
    en: 'Select payment method',
    se: 'Välj betalningsmetod',
    es: 'Seleccione método de pago',
  },
  'Monitoring.AnyPaymentMethod': {
    en: 'Any payment method',
    se: 'Vilken betalningsmetod som helst',
    es: 'Cualquier método de pago',
  },
  'Monitoring.SelectServiceType': {
    en: 'Select service type',
    se: 'Välj service typ',
    es: 'Seleccione tipo de servicio',
  },
  'Monitoring.AnyServiceType': {
    en: 'Any service type',
    se: 'Vilken servicetyp som helst',
    es: 'Cualquier tipo de servicio',
  },
  'Monitoring.SelectOrigins': {
    en: 'Select channel(s)',
    se: 'Välj köpkanal',
    es: 'Seleccione canal(es)',
  },
  'Monitoring.AnyOrigin': {
    en: 'Any origin',
    se: 'Vilken kanal som helst',
    es: 'Cualquier origen',
  },
  'Monitoring.OverallInfo': {
    en: 'Overall info',
    se: 'Övergripande info',
    es: 'Información general',
  },
  'Monitoring.OfferUsed': {
    en: 'Used offer',
    se: 'Använt erbjudande',
    es: 'Oferta usada',
  },
  'Monitoring.DesiredTime': {
    en: 'Desired time',
    se: 'Önskad tid',
    es: 'Tiempo deseado',
  },
  'Monitoring.RejectReason': {
    en: 'Reject reason',
    se: 'Avslagsskäl',
    es: 'Razón de rechazo',
  },
  'Monitoring.OrderStatus': {
    en: 'Order status',
    se: 'Status',
    es: 'Estado del pedido',
  },
  'Monitoring.Operation': {
    en: 'Operation',
    se: 'Verksamhet',
    es: 'Operación',
  },
  'Monitoring.Register': {
    en: 'Register',
    se: 'Kassa',
    es: 'Registro',
  },
  'Monitoring.Customer': {
    en: 'Customer',
    se: 'Kund',
    es: 'Cliente',
  },
  'Monitoring.InvoiceDetails': {
    en: 'Invoice details',
    se: 'Fakturainformation',
    es: 'Detalles de la factura',
  },
  'Monitoring.MiscInfo': {
    en: 'Misc. info',
    se: 'Övrig info',
    es: 'Info. miscelánea',
  },
  'Monitoring.Refund': {
    en: 'Refund',
    se: 'Återbetalning',
    es: 'Reembolso',
  },
  'Monitoring.DeliveryLocation': {
    en: 'Delivery location',
    se: 'Leveransplats',
    es: 'Ubicación de entrega',
  },
  'Monitoring.EmailSuccessfullySent': {
    en: 'Email successfully sent',
    se: 'E-post har skickats',
    es: 'Correo electrónico enviado con éxito',
  },
  'Monitoring."EmailCouldNotBeSent': {
    en: 'Email could not be sent',
    se: 'E-post kunde inte skickas',
    es: 'No se pudo enviar el correo electrónico',
  },
  'Monitoring.EventType.AddStock': {
    en: 'Add stock',
    se: 'Lägg till i lager',
    es: 'Añadir a stock',
  },
  'Monitoring.EventType.ReduceStock': {
    en: 'Reduce stock',
    se: 'Minska lager',
    es: 'Reducir stock',
  },
  'Monitoring.EventType.Transfer': {
    en: 'Transfer',
    se: 'Överför',
    es: 'Transferir',
  },
  'Monitoring.EventType.ClearStock': {
    en: 'Clear stock',
    se: 'Rensa lager',
    es: 'Limpiar stock',
  },
  'Monitoring.EventType.OutOfStockToggle': {
    en: 'Out of stock toggle',
    se: 'Slut på lager toggle',
    es: 'Agotado alternar',
  },
  'Monitoring.EventType.ExpirationTrigger': {
    en: 'Expiration trigger',
    se: 'Expiration trigger',
    es: 'Disparador de caducidad',
  },
  'Monitoring.HasAddedItems': {
    en: 'Has added items',
    se: 'Har lagt till artikel',
    es: 'Ha añadido artículo',
  },
  'Monitoring.OrderCreated': {
    en: 'Order created',
    se: 'Beställning skapad',
    es: 'Pedido creado',
  },
  'Monitoring.ClickACartToInspect': {
    en: 'Click a cart to inspect',
    se: 'Klicka på en kundvagn för att inspektera',
    es: 'Haga clic en un carrito para inspeccionar',
  },
  'Monitoring.Discount': {
    en: 'Discount',
    se: 'Rabatt',
    es: 'Descuento',
  },
  'Monitoring.TotalToPay': {
    en: 'Total to pay',
    se: 'Summa att betala',
    es: 'Total a pagar',
  },
  'Monitoring.IsFullyPaid': {
    en: 'Is fully paid',
    se: 'Är fullt betald',
    es: 'Está totalmente pagado',
  },
  'Monitoring.IsReadyForCheckout': {
    en: 'Is ready for checkout',
    se: 'Är redo för kassan',
    es: 'Está listo para el pago',
  },
  'Monitoring.Anonymous': {
    en: 'Anonymous',
    se: 'Anonym',
    es: 'Anónimo',
  },
  'Monitoring.UnknownItem': {
    en: 'Unknown item',
    se: 'Okänd artikel',
    es: 'Artículo desconocido',
  },
  'Monitoring.UnknownUser': {
    en: 'Unknown user',
    se: 'Okänd användare',
    es: 'Usuario desconocido',
  },
  'Monitoring.UnknownTable': {
    en: 'Unknown Table!',
    se: 'Okänt bord!',
    es: '¡Mesa desconocida!',
  },
  'Monitoring.CartId': {
    en: 'Cart ID',
    se: 'Varukorgs ID',
    es: 'ID de carrito',
  },
  'Memberships.Membership': {
    en: 'Membership',
    se: 'Medlemskap',
    es: 'Membresía',
  },
  'Memberships.CreateMembership': {
    en: 'Create membership',
    se: 'Skapa medlemskap',
    es: 'Crear membresía',
  },
  'Memberships.DiscountPercentage': {
    en: 'Discount percentage',
    se: 'Rabattprocent',
    es: 'Porcentaje de descuento',
  },
  'Memberships.PointsRequired': {
    en: 'Points required',
    se: 'Poäng krävs',
    es: 'Puntos requeridos',
  },
  'Memberships.DefaultDiscount': {
    en: 'Default discout',
    se: 'Standardrabatt',
    es: 'Descuento predeterminado',
  },
  'Memberships.PrimaryColor': {
    en: 'Primary color',
    se: 'Grundfärg',
    es: 'Color primario',
  },
  'Memberships.SecondaryColor': {
    en: 'Secondary color',
    se: 'Sekundär färg',
    es: 'Color secundario',
  },
  'Memberships.BackgroundImage': {
    en: 'Background image',
    se: 'Bakgrundsbild',
    es: 'Imagen de fondo',
  },
  'Memberships.MembershipExclusiveMenus': {
    en: 'Membership-exclusive menus',
    se: 'Medlemskapsexklusiva menyer',
    es: 'Menús exclusivos de membresía',
  },
  'Memberships.ItemPriceMenuPriceWarning': {
    en: 'Changing the price on items does not automatically update the existing menu prices. Make sure you update menu prices as well.',
    se: 'Att ändra priset på varor uppdaterar inte automatiskt de befintliga menypriserna. Se till att du uppdaterar menypriserna också.',
    es: 'Cambiar el precio de los artículos no actualiza automáticamente los precios de menú existentes. Asegúrese de actualizar los precios de menú también.',
  },
  'Memberships.AssignMembershipToUsers': {
    en: 'Assign membership to users',
    se: 'Tilldela medlemskap till användare',
    es: 'Asignar membresía a usuarios',
  },
  'Memberships.AssignMembershipDescription': {
    en: `Search for users by phone, name and email. Click their name to add them to the list of users
        to assign a membership to. You can also press enter to select the top result. Click a name
        you have added to remove it.`,
    se: `Sök efter användare via telefon, namn och e-post. Klicka på deras namn för att lägga till dem i listan över användare
    att tilldela ett medlemskap till. Du kan också trycka på enter för att välja toppresultatet. Klicka på ett namn
    du har lagt till för att ta bort den.`,
    es: `Busque usuarios por teléfono, nombre y correo electrónico. Haga clic en su nombre para agregarlos a la lista de usuarios
    para asignar una membresía. También puede presionar Enter para seleccionar el primer resultado. Haga clic en un nombre
    que ha agregado para eliminarlo.`,
  },
  'Memberships.UserNameEmailPhone': {
    en: 'User name/email/phone',
    se: 'Användarnamn/e-post/telefon',
    es: 'Nombre de usuario/correo electrónico/telefono',
  },
  'Memberships.AssignMembership': {
    en: 'Assign membership',
    se: 'Tilldela medlemskap',
    es: 'Asignar membresía',
  },
  'Memberships.AllUsersWithMembership': {
    en: 'All users with membership',
    se: 'Alla användare med medlemskap',
    es: 'Todos los usuarios con membresía',
  },
  'Memberships.Menu': {
    en: 'Menu',
    se: 'Meny',
    es: 'Menú',
  },
  'Memberships.UserId': {
    en: 'User ID',
    se: 'Användar ID',
    es: 'ID de usuario',
  },
  'Memberships.PointsAdded': {
    en: 'Points added',
    se: 'Poäng tillagda',
    es: 'Puntos agregados',
  },
  'Members.SearchEasyId': {
    en: 'Search for an easyId',
    se: 'Sök efter en easyId',
    es: 'Busque un easyId',
  },
  'Members.Invoice': {
    en: 'Connect to invoice customer',
    se: 'Koppla till fakturakund',
    es: 'Conectar con el cliente de facturación',
  },
  'Members.SearchNameEmail': {
    en: 'Search for a name or email',
    se: 'Sök efter ett namn eller e-postadress',
    es: 'Busque un nombre o correo electrónico',
  },
  'Members.NumberOfMembers': {
    en: 'Number of members',
    se: 'Antal medlemmar',
    es: 'Número de miembros',
  },
  'Members.UserDeleted': {
    en: 'User was deleted',
    se: 'Användaren togs bort',
    es: 'El usuario fue eliminado',
  },
  'Members.UserBlocked': {
    en: 'User was blocked',
    se: 'Användaren blockerades',
    es: 'El usuario fue bloqueado',
  },
  'Members.UserUnblocked': {
    en: 'User was unblocked',
    se: 'Användaren avblockerades',
    es: 'El usuario fue desbloqueado',
  },
  'Members.Refunded': {
    en: 'Refunded',
    se: 'Återbetald',
    es: 'Reembolsado',
  },
  'Members.ItemRefunded': {
    en: 'Item refunded',
    se: 'Artikel återbetald',
    es: 'Artículo reembolsado',
  },
  'Members.OrderRejected': {
    en: 'Order rejected',
    se: 'Beställning avvisad',
    es: 'Orden rechazada',
  },
  'Members.OrderRefunded': {
    en: 'Order refunded',
    se: 'Beställning återbetald',
    es: 'Orden reembolsada',
  },
  'Members.RefundOrder': {
    en: 'Refund order',
    se: 'Återbetala beställning',
    es: 'Reembolsar orden',
  },
  'Members.ReferralCode': {
    en: 'Referral code',
    se: 'Referral kod',
    es: 'Código de referencia',
  },
  'Members.IsActivated': {
    en: 'Is activated?',
    se: 'Är aktiverad?',
    es: '¿Está activado?',
  },
  'Members.Activated': {
    en: 'Activated',
    se: 'Aktiverad',
    es: 'Activado',
  },
  'Members.NotActivated': {
    en: 'Not activated',
    se: 'Ej aktiverad',
    es: 'No activado',
  },
  'Members.VenueLimited': {
    en: 'Venue limited? (admin)',
    se: 'Begränsad butik? (admin)',
    es: '¿Limitado al lugar? (admin)',
  },
  'Members.Limited': {
    en: 'Limited',
    se: 'Begränsad',
    es: 'Limitado',
  },
  'Members.NotLimited': {
    en: 'Not limited',
    se: 'Ej begränsad',
    es: 'No limitado',
  },
  'Members.Role': {
    en: 'Role',
    se: 'Roll',
    es: 'Rol',
  },
  'Members.Regular': {
    en: 'Regular',
    se: 'Vanlig',
    es: 'Regular',
  },
  'Members.Admin': {
    en: 'Admin',
    se: 'Admin',
    es: 'Admin',
  },
  'Members.Offers': {
    en: 'Offers',
    se: 'Erbjudanden',
    es: 'Ofertas',
  },
  'Members.ActiveOffers': {
    en: 'Active offers',
    se: 'Aktiva erbjudanden',
    es: 'Ofertas activas',
  },
  'Members.AvailableOffers': {
    en: 'Available offers',
    se: 'Tillgängliga erbjudanden',
    es: 'Ofertas disponibles',
  },
  'Members.Orders': {
    en: 'Orders',
    se: 'Beställningar',
    es: 'Órdenes',
  },
  'Members.RefundItem': {
    en: 'Refund item',
    se: 'Återbetala artikel',
    es: 'Reembolsar artículo',
  },
  'Members.Venues': {
    en: 'Venues',
    se: 'Butiker',
    es: 'Lugares',
  },
  'Members.AddStamp': {
    en: 'Add stamp',
    se: 'Lägg till stämpel',
    es: 'Agregar sello',
  },
  'Members.CantAddFinalStamp': {
    en: 'You can not manually add the final stamp',
    se: 'Du kan inte lägga till den slutliga stämpeln manuellt',
    es: 'No puede agregar manualmente el sello final',
  },
  'Members.NoStamp': {
    en: 'No stamp',
    se: 'Ingen stämpel',
    es: 'Sin sello',
  },
  'Members.StampCards': {
    en: 'Stamp cards',
    se: 'Stämpelkort',
    es: 'Tarjetas de sello',
  },
  'Members.TimeUsed': {
    en: 'Times used',
    se: 'Gånger använd',
    es: 'Veces usado',
  },
  'Members.InvalidItem': {
    en: 'Article not found.',
    se: 'Artikeln hittades inte.',
    es: 'Artículo no encontrado.',
  },
  'Members.ExportToCsv': {
    en: 'Export users to CSV',
    se: 'Exportera användare till CSV',
    es: 'Exportar usuarios a CSV',
  },
  'Login.IncorrectUsernameOrPassword': {
    en: 'The username or password is incorrect. Please try again or contact our support team.',
    se: 'Användarnamnet eller lösenordet är felaktigt. Försök igen eller kontakta vårt supportteam.',
    es: 'El nombre de usuario o la contraseña son incorrectos. Por favor, inténtelo de nuevo o póngase en contacto con nuestro equipo de soporte.',
  },
  'Login.InternalServerError': {
    en: 'Oops! An error occurred, and we are working to fix the problem. Please try again later.',
    se: 'Hoppsan! Ett fel uppstod och vi arbetar på att åtgärda problemet. Vänligen försök igen senare.',
    es: '¡Vaya! Se ha producido un error y estamos trabajando para solucionarlo. Por favor, inténtelo de nuevo más tarde.',
  },
  'Login.UnknownError': {
    en: 'Unknown error',
    se: 'Okänt fel',
    es: 'Error desconocido',
  },
  'Venues.Venues': {
    en: 'Venues',
    se: 'Butiker',
    es: 'Lugares',
  },
  'Venues.SearchForVenue': {
    en: 'Search for a venue',
    se: 'Sök efter en butik',
    es: 'Buscar un lugar',
  },
  'Venues.EditVenue': {
    en: 'Edit this venue',
    se: 'Redigera denna butik',
    es: 'Editar este lugar',
  },
  'Venues.DeleteVenue': {
    en: 'Delete venue',
    se: 'Ta bort butik',
    es: 'Eliminar lugar',
  },
  'Venues.VenueTitle': {
    en: 'Create venue',
    se: 'Skapa butik',
    es: 'Crear lugar',
  },
  'Venues.VenueDescription': {
    en: 'Create a brand new venue',
    se: 'Skapa en helt ny butik',
    es: 'Crear un lugar completamente nuevo',
  },
  'Venues.OrganizationId': {
    en: 'VAT No',
    se: 'Organisation ID',
    es: 'IVA No',
  },
  'Venues.OrganizationIdPlaceholder': {
    en: 'Fill in ID',
    se: 'Fyll i ID',
    es: 'Rellene la identificación',
  },
  'Venues.LegalName': {
    en: 'Legal name',
    se: 'Juridiskt namn',
    es: 'Nombre legal',
  },
  'Venues.LegalNamePlaceholder': {
    en: 'Fill in the legal name',
    se: 'Fyll i det juridiska namnet',
    es: 'Rellene el nombre legal',
  },
  'Venues.LocationAddress': {
    en: 'Location / Address (display purposes)',
    se: 'Plats/adress (visningsändamål)',
    es: 'Ubicación / Dirección (para fines de visualización)',
  },
  'Venues.LocationAddressPlaceholder': {
    en: 'Fill in address',
    se: 'Fyll i adress',
    es: 'Rellene la dirección',
  },
  'Venues.Street': {
    en: 'Street',
    se: 'Gata',
    es: 'Calle',
  },
  'Venues.StreetPlaceholder': {
    en: 'Fill in street',
    se: 'Fyll i gata',
    es: 'Rellene la calle',
  },
  'Venues.City': {
    en: 'City',
    se: 'Stad',
    es: 'Ciudad',
  },
  'Venues.CityPlaceholder': {
    en: 'Fill in city',
    se: 'Fyll i stad',
    es: 'Rellene la ciudad',
  },
  'Venues.ZipCode': {
    en: 'Zip code',
    se: 'Postnummer',
    es: 'Código postal',
  },
  'Venues.ZipCodePlaceholder': {
    en: 'Fill in zip',
    se: 'Fyll i postnummer',
    es: 'Rellene el código postal',
  },
  'Venues.Latitude': {
    en: 'Location / Latitude',
    se: 'Plats / Latitude',
    es: 'Ubicación / Latitud',
  },
  'Venues.LatitudePlaceholder': {
    en: 'Fill in latitude',
    se: 'Fyll i latitude',
    es: 'Rellene la latitud',
  },
  'Venues.Longitude': {
    en: 'Location / Longitude',
    se: 'Plats / Longitude',
    es: 'Ubicación / Longitud',
  },
  'Venues.LongitudePlaceholder': {
    en: 'Fill in longitude',
    se: 'Fyll i longitude',
    es: 'Rellene la longitud',
  },
  'Venues.Timezone': {
    en: 'Timezone',
    se: 'Tidszon',
    es: 'Zona horaria',
  },
  'Venues.PhoneNumber': {
    en: 'Phone number',
    se: 'Telefonnummer',
    es: 'Número de teléfono',
  },
  'Venues.PhoneNumberPlaceholder': {
    en: 'Fill in phone number',
    se: 'Fyll i telefonnummer',
    es: 'Rellene el número de teléfono',
  },
  'Venues.PhoneNumberValidation': {
    en: 'Invalid format, should be like +46123456789',
    se: 'Ogiltigt format, bör vara som +46123456789',
    es: 'Formato inválido, debe ser como +46123456789',
  },
  'Venues.SupportEmail': {
    en: 'Support email',
    se: 'Support e-post',
    es: 'Correo electrónico de soporte',
  },
  'Venues.SupportEmailPlaceholder': {
    en: 'Fill in email',
    se: 'Fyll i e-post',
    es: 'Rellene el correo electrónico',
  },
  'Venues.Image': {
    en: 'Image (recommended size: 2160 x 1440 px)',
    se: 'Bild (rekommenderad storlek: 2160 x 1440 px)',
    es: 'Imagen (tamaño recomendado: 2160 x 1440 px)',
  },
  'Venues.Active': {
    en: 'Active (shows up in app)',
    se: 'Aktiv (visas i appen)',
    es: 'Activo (aparece en la aplicación)',
  },
  'Venues.MinimumDeliveryFee': {
    en: 'Minimum Delivery Fee',
    se: 'Minsta leveransavgift',
    es: 'Tarifa de entrega mínima',
  },
  'Venues.MinimumDeliveryFeePlaceholder': {
    en: 'Fill in fee',
    se: 'Fyll i avgift',
    es: 'Rellene la tarifa',
  },
  'Venues.StaffIdleTimeout': {
    en: 'Staff Idle Timeout - Seconds before staff is logged out for idling',
    se: 'Personal Idle Timeout - Sekunder innan personal loggas ut för tomgång',
    es: 'Tiempo de inactividad del personal - Segundos antes de que el personal se cierre sesión por inactividad',
  },
  'Venues.StaffIdleTimeoutPlaceholder': {
    en: 'Fill in staff timeout',
    se: 'Fyll i personalens timeout',
    es: 'Rellene el tiempo de espera del personal',
  },
  'Venues.StaffIdleTimeoutValidation': {
    en: 'Timeout needs to be between 30 and 9999 seconds long',
    se: 'Timeout måste vara mellan 30 och 9999 sekunder',
    es: 'El tiempo de espera debe tener entre 30 y 9999 segundos',
  },
  'Venues.ActiveMenus': {
    en: 'Active menus',
    se: 'Aktiva menyer',
    es: 'Menús activos',
  },
  'Venues.NoSelectedMenus': {
    en: 'No selected menus',
    se: 'Inga valda menyer',
    es: 'Sin menús seleccionados',
  },
  'Venues.NoSelectedMenu': {
    en: 'No selected menu',
    se: 'Ingen meny vald',
    es: 'Sin menú seleccionado',
  },
  'UserAnalytics.CustomerCard': {
    en: 'Customer card',
    se: 'Kundkort',
    es: 'Tarjeta de cliente',
  },
  'UserAnalytics.Customer': {
    en: 'Customer',
    se: 'Kund',
    es: 'Cliente',
  },
  'UserAnalytics.TotalPoints': {
    en: 'TotalPoints',
    se: 'Totala poäng',
    es: 'Puntos totales',
  },
  'UserAnalytics.Registered': {
    en: 'Registered',
    se: 'Registrerad',
    es: 'Registrado',
  },
  'UserAnalytics.LastOrder': {
    en: 'Last order',
    se: 'Sista beställningen',
    es: 'Último pedido',
  },
  'UserAnalytics.MobileNumber': {
    en: 'Mobile number',
    se: 'Mobilnummer',
    es: 'Número de móvil',
  },
  'UserAnalytics.Activity': {
    en: 'Activity',
    se: 'Aktivitet',
    es: 'Actividad',
  },
  'UserAnalytics.FavoriteVenue': {
    en: 'Favorite venue',
    se: 'Favoritbutik',
    es: 'Lugar favorito',
  },
  'UserAnalytics.FavoritePurchase': {
    en: 'Favorite purchase',
    se: 'Favoritköp',
    es: 'Compra favorita',
  },
  'UserAnalytics.TotalSpent': {
    en: 'Total spent',
    se: 'Totalt spenderat',
    es: 'Total gastado',
  },
  'UserAnalytics.AveragePurchase': {
    en: 'Average purchase',
    se: 'Genomsnittligt köp',
    es: 'Compra promedio',
  },
  'UserAnalytics.UsedOffers': {
    en: 'Used offers',
    se: 'Använda erbjudanden',
    es: 'Ofertas usadas',
  },
  'UserAnalytics.CustomerPerformance': {
    en: 'Customer performance',
    se: 'Kundprestanda',
    es: 'Rendimiento del cliente',
  },
  'UserAnalytics.RejectedOrders': {
    en: 'Rejected orders',
    se: 'Avvisade beställningar',
    es: 'Pedidos rechazados',
  },
  'UserAnalytics.ItemsPerOrder': {
    en: 'Items per order',
    se: 'Artiklar per beställning',
    es: 'Artículos por pedido',
  },
  'UserAnalytics.Points': {
    en: 'Points',
    se: 'Poäng',
    es: 'Puntos',
  },
  'UserAnalytics.VenueManager': {
    en: 'Venue Manager',
    se: 'Venue Manager',
    es: 'Venue Manager',
  },
  'UserAnalytics.PromoCode': {
    en: 'Promo code',
    se: 'Rabattkod',
    es: 'Código promocional',
  },
  'UserAnalytics.CardTradeIn': {
    en: 'Card trade-in',
    se: 'Kortbyte',
    es: 'Intercambio de tarjeta',
  },
  'UserAnalytics.Purchase': {
    en: 'Purchase',
    se: 'Köp',
    es: 'Compra',
  },
  'UserAnalytics.UserRegistered': {
    en: 'User is registered',
    se: 'Användaren är registrerad',
    es: 'El usuario está registrado',
  },
  'UserAnalytics.ReservationId': {
    en: 'Reservation ID',
    se: 'Reservations-ID',
    es: 'ID de reserva',
  },
  'UserAnalytics.AddedCreditCardEndingIn': {
    en: 'Added credit card ending in',
    se: 'Lade till kreditkort som slutar på',
    es: 'Tarjeta de crédito agregada que termina en',
  },
  'UserAnalytics.VerifiedAt': {
    en: 'Verified at',
    se: 'Verifierad',
    es: 'Verificado en',
  },
  'UserAnalytics.NotVerified': {
    en: 'Not verified',
    se: 'Overifierad',
    es: 'No verificado',
  },
  'UserAnalytics.Scanned': {
    en: 'Scanned',
    se: 'Skannat',
    es: 'Escaneado',
  },
  'UserAnalytics.Received': {
    en: 'Received',
    se: 'Mottagen',
    es: 'Recibido',
  },
  'UserAnalytics.CustomerTimeline': {
    en: 'Customer timeline',
    se: 'Kundens tidslinje',
    es: 'Línea de tiempo del cliente',
  },
  'UserAnalytics.Everything': {
    en: 'Everything',
    se: 'Allt',
    es: 'Todo',
  },
  'UserAnalytics.Registration': {
    en: 'Registration',
    se: 'Registrering',
    es: 'Registro',
  },
  'UserAnalytics.Reservation': {
    en: 'Reservation',
    se: 'Reservering',
    es: 'Reserva',
  },
  'UserAnalytics.CreditCard': {
    en: 'CreditCard',
    se: 'Kreditkort',
    es: 'Tarjeta de crédito',
  },
  'UserAnalytics.Device': {
    en: 'Device',
    se: 'Enhet',
    es: 'Dispositivo',
  },
  'UserAnalytics.UserNotFound': {
    en: 'User not found',
    se: 'Användaren hittades inte',
    es: 'Usuario no encontrado',
  },
  'UserAnalytics.UserAnalytics': {
    en: 'User Analytics',
    se: 'Användaranalytics',
    es: 'Analítica de usuario',
  },
  'UserAnalytics.AddComment': {
    en: 'Add comment',
    se: 'Lägg till kommentar',
    es: 'Añadir comentario',
  },
  'TSR.Floorplan': {
    en: 'Floorplan',
    se: 'Planlösning',
    es: 'Plan de piso',
  },
  'TSR.CreateFloorplan': {
    en: 'Create floorplan',
    se: 'Skapa planlösning',
    es: 'Crear plan de piso',
  },
  'TSR.Tables': {
    en: 'Tables',
    se: 'Bord',
    es: 'Mesas',
  },
  'TSR.CreateTable': {
    en: 'Create table',
    se: 'Skapa bord',
    es: 'Crear mesa',
  },
  'TSR.SelectVenue': {
    en: 'Select venue',
    se: 'Välj butik',
    es: 'Seleccionar lugar',
  },
  'TSR.SelectFloorplan': {
    en: 'Select floorplan',
    se: 'Välj planlösning',
    es: 'Seleccionar plan de piso',
  },
  'TSR.SelectDevice': {
    en: 'Select device',
    se: 'Välj enhet',
    es: 'Seleccionar dispositivo',
  },
  'TSR.NoFloorplans': {
    en: 'There are no floorplans yet, create one to be able to edit tables',
    se: 'Det finns inga planlösningar ännu, skapa en för att kunna redigera bord',
    es: 'No hay planos de piso todavía, cree uno para poder editar mesas',
  },
  'TSR.AlreadyUsedTableCode': {
    en: 'This table code is already used',
    se: 'Denna bordkod används redan',
    es: 'Este código de mesa ya está en uso',
  },
  'TSR.Zones': {
    en: 'Zones',
    se: 'Zoner',
    es: 'Zonas',
  },
  'TSR.CreateZone': {
    en: 'Create zone',
    se: 'Skapa zon',
    es: 'Crear zona',
  },
  'TSR.TablesIncludedInThisZone': {
    en: 'Tables included in this zone',
    se: 'Bord som ingår i denna zon',
    es: 'Mesas incluidas en esta zona',
  },
  'TSR.LeftToPay': {
    en: 'Left to pay',
    se: 'Kvar att betala',
    es: 'Restante por pagar',
  },
  'TSR.Sold': {
    en: 'Sold',
    se: 'Såld',
    es: 'Vendido',
  },
  'TSR.Open': {
    en: 'Open',
    se: 'Öppen',
    es: 'Abierto',
  },
  'TSR.Removed': {
    en: 'Removed',
    se: 'Borttagen',
    es: 'Eliminado',
  },
  'TSR.AddItem': {
    en: 'Add item',
    se: 'Lägg till artikel',
    es: 'Añadir artículo',
  },
  'TSR.AddItems': {
    en: 'Add items',
    se: 'Lägg till artiklar',
    es: 'Añadir artículos',
  },
  'TSR.RemoveItem': {
    en: 'Remove item',
    se: 'Ta bort artikel',
    es: 'Eliminar artículo',
  },
  'TSR.RemoveItems': {
    en: 'Remove items',
    se: 'Ta bort artiklar',
    es: 'Eliminar artículos',
  },
  'TSR.MoveItem': {
    en: 'Move item',
    se: 'Flytta artikel',
    es: 'Mover artículo',
  },
  'TSR.CreateCheque': {
    en: 'Create cheque',
    se: 'Skapa nota',
    es: 'Crear cheque',
  },
  'TSR.RemoveCheque': {
    en: 'Remove cheque',
    se: 'Ta bort nota',
    es: 'Eliminar cheque',
  },
  'TSR.PredefinedMessages': {
    en: 'Predefined messages',
    se: 'Fördefinierade meddelanden',
    es: 'Mensajes predefinidos',
  },
  'TSR.CreateMessage': {
    en: 'Create message',
    se: 'Skapa meddelande',
    es: 'Crear mensaje',
  },
  'Stations.Stations': {
    en: 'Stations',
    se: 'Stationer',
    es: 'Estaciones',
  },
  'Stations.CreateStation': {
    en: 'Create station',
    se: 'Skapa station',
    es: 'Crear estación',
  },
  'Stations.CategoriesIncluded': {
    en: 'Categories included in this station',
    se: 'Kategorier som ingår i denna station',
    es: 'Categorías incluidas en esta estación',
  },
  'Stations.ItemsIncluded': {
    en: 'Items included in this station',
    se: 'Artiklar som ingår i denna station',
    es: 'Artículos incluidos en esta estación',
  },
  'Stations.OrderStatusesIncluded': {
    en: 'Order statuses included in this station',
    se: 'Orderstatus som ingår i denna station',
    es: 'Estados de pedido incluidos en esta estación',
  },
  'Stations.ServiceTypesIncluded': {
    en: 'Service types included in this station (if none is selected, all will be shown)',
    se: 'Service typer som ingår i denna station (om ingen är vald kommer alla att visas)',
    es: 'Tipos de servicio incluidos en esta estación (si no se selecciona ninguno, se mostrarán todos)',
  },
  'Stations.OrderOriginsIncluded': {
    en: 'Order origins included in this station (if none is selected, all will be shown)',
    se: 'Order origins som ingår i denna station (om ingen är vald kommer alla att visas)',
    es: 'Orígenes de pedido incluidos en esta estación (si no se selecciona ninguno, se mostrarán todos)',
  },
  'Stations.ShowAllItems': {
    en: 'Show all other order items not included in station',
    se: 'Visa alla andra beställningsartiklar som inte ingår i stationen',
    es: 'Mostrar todos los demás artículos de pedido no incluidos en la estación',
  },
  'StampCards.StampCards': {
    en: 'Stamp cards',
    se: 'Stämpelkort',
    es: 'Tarjetas de estampilla',
  },
  'StampCards.CreateStampCard': {
    en: 'Create Stamp Card',
    se: 'Skapa stämpelkort',
    es: 'Crear tarjeta de estampilla',
  },
  'StampCards.NumberOfStamps': {
    en: 'Number of stamps',
    se: 'Antal stämplar',
    es: 'Número de sellos',
  },
  'StampCards.OfferToGiveOut': {
    en: 'Offer to give out',
    se: 'Erbjudande att ge ut',
    es: 'Oferta para dar',
  },
  'StampCards.Default': {
    en: 'Default (Given to all users)',
    se: 'Standard (skickas till alla användare)',
    es: 'Predeterminado (enviado a todos los usuarios)',
  },
  'StampCards.ItemsIncluded': {
    en: 'Items included in this stamp card',
    se: 'Artiklar som ingår i detta stämpelkort',
    es: 'Artículos incluidos en esta tarjeta de estampilla',
  },
  'StampCards.CreateStampCards': {
    en: 'Create Stamp Card',
    se: 'Skapa stämpelkort',
    es: 'Crear tarjeta de estampilla',
  },
  'Staff.AdminsAndStoreManagers': {
    en: 'Back-office admins and store managers',
    se: 'Backoffice-administratörer och butikschefer',
    es: 'Administradores de back-office y gerentes de tienda',
  },
  'Staff.CreateAdmin': {
    en: 'Create Admin',
    se: 'Skapa admin',
    es: 'Crear administrador',
  },
  'Staff.AccessLevels': {
    en: 'Access levels',
    se: 'Åtkomstnivåer',
    es: 'Niveles de acceso',
  },
  'Staff.CreateAccessLevel': {
    en: 'Create access level',
    se: 'Skapa åtkomstnivå',
    es: 'Crear nivel de acceso',
  },
  'Staff.Permissions': {
    en: 'Permissions',
    se: 'Behörigheter',
    es: 'Permisos',
  },
  'Staff.Permission.Analytics': {
    en: 'Analytics',
    se: 'Analys',
    es: 'Analítica',
  },
  'Staff.Permission.CloseDay': {
    en: 'Close day',
    se: 'Stänga dag',
    es: 'Cerrar día',
  },
  'Staff.Permission.CreateInvoiceTarget': {
    en: 'Create invoice target',
    se: 'Skapa fakturamål',
    es: 'Crear objetivo de factura',
  },
  'Staff.Permission.History': {
    en: 'History',
    se: 'Historik',
    es: 'Historia',
  },
  'Staff.Permission.InvoicePurchase': {
    en: 'Invoice purchase',
    se: 'Fakturaköp',
    es: 'Factura de compra',
  },
  'Staff.Permission.LogOut': {
    en: 'Log out',
    se: 'Logga ut',
    es: 'Cerrar sesión',
  },
  'Staff.Permission.ManualDiscount': {
    en: 'Manual discount',
    se: 'Manuell rabatt',
    es: 'Descuento manual',
  },
  'Staff.Permission.PresetDiscount': {
    en: 'Preset discount',
    se: 'Förinställd rabatt',
    es: 'Descuento preestablecido',
  },
  'Staff.Permission.Refund': {
    en: 'Refund',
    se: 'Återbetalning',
    es: 'Reembolso',
  },
  'Staff.Permission.Reports': {
    en: 'Reports',
    se: 'Rapporter',
    es: 'Informes',
  },
  'Staff.Permission.Settings': {
    en: 'Settings',
    se: 'Inställningar',
    es: 'Ajustes',
  },
  'Staff.Permission.MakePayment': {
    en: 'Make payment',
    se: 'Betala',
    es: 'Hacer el pago',
  },
  'Staff.Permission.AssumeRole': {
    en: 'Assume role',
    se: 'Ta roll',
    es: 'Suplantar el papel',
  },
  'Staff.Permission.AddItemToTable': {
    en: 'Add item to table',
    se: 'Lägga till artiklar på bord',
    es: 'Agregar artículo a la mesa',
  },
  'Staff.Permission.CreateCheque': {
    en: 'Create cheque',
    se: 'Skapa nota',
    es: 'Crear cheque',
  },
  'Staff.Permission.VoidPayment': {
    en: 'Void payment',
    se: 'Ogiltigförklara betalningar',
    es: 'Anular el pago',
  },
  'Staff.Permission.GiftCards': {
    en: 'Gift cards',
    se: 'Presentkort',
    es: 'Tarjetas de regalo',
  },
  Staff: {
    en: 'Staff',
    se: 'Personal',
    es: 'Personal',
  },
  'Staff.CreateStaff': {
    en: 'Create staff',
    se: 'Skapa personal',
    es: 'Crear personal',
  },
  'Staff.AccessLevel': {
    en: 'Access level',
    se: 'Åtkomstnivå',
    es: 'Nivel de acceso',
  },
  'Staff.CodeCanOnlyContainNumbers': {
    en: 'Code can only contain numbers',
    se: 'Koden kan bara innehålla siffror',
    es: 'El código solo puede contener números',
  },
  'Staff.CodeAlreadyTakenByAnotherStaff': {
    en: 'Code already taken by another Staff',
    se: 'Koden har redan tagits av en annan personal',
    es: 'El código ya está tomado por otro personal',
  },
  'Staff.StaffReport': {
    en: 'Staff report',
    se: 'Personalrapport',
    es: 'Informe de personal',
  },
  'Staff.BeforeReturn': {
    en: 'Before return',
    se: 'Innan återkomst',
    es: 'Antes de regresar',
  },
  'Staff.SuspiciousOrders': {
    en: 'Suspicious orders',
    se: 'Misstänkta order',
    es: 'Órdenes sospechosas',
  },
  'Staff.NoStaff': {
    en: 'No staff',
    se: 'Ingen personal',
    es: 'Sin personal',
  },
  'Staff.OrderId': {
    en: 'Order ID',
    se: 'Beställnings-ID',
    es: 'ID de orden',
  },
  'SendVoucher.SendRetroactively': {
    en: 'Send vouchers retroactively',
    se: 'Skicka verifikationer retroaktivt',
    es: 'Enviar vouchers retroactivamente',
  },
  'SendVoucher.SendRetroactivelyDescription': {
    en: 'Send vouchers for the past date range by choosing a specific date range, venue and account provider',
    se: 'Skicka verifikationer för det senaste datumintervallet genom att välja ett specifikt datumintervall, plats och kontoleverantör',
    es: 'Enviar vouchers para el rango de fechas pasado eligiendo un rango de fechas específico, lugar y proveedor de cuenta',
  },
  'SendVoucher.ChooseVenue': {
    en: 'Choose venue',
    se: 'Välj butik',
    es: 'Elegir lugar',
  },
  'SendVoucher.ChooseProvider': {
    en: 'Choose provider',
    se: 'Välj leverantör',
    es: 'Elegir proveedor',
  },
  'SendVoucher.LoadingText': {
    en: 'Still loading, please wait...',
    se: 'Laddar fortfarande, var god vänta...',
    es: 'Todavía cargando, por favor espere...',
  },
  'SendExcel.SendExcel': {
    en: 'Send Excel',
    se: 'Skicka Excel',
    es: 'Enviar Excel',
  },
  'SendExcel.CouldntFindExcelData': {
    en: "Couldn't find excel data with sheet name",
    se: 'Det gick inte att hitta Excel-data med arknamn',
    es: 'No se pudo encontrar datos de Excel con el nombre de la hoja',
  },
  'SendExcel.CouldntFindVenue': {
    en: "Couldn't find venue",
    se: 'Kunde inte hitta butik',
    es: 'No se pudo encontrar lugar',
  },
  'SendExcel.RequestSuccess': {
    en: 'Request success',
    se: 'Lyckad förfrågan',
    es: 'Solicitud exitosa',
  },
  'SendCSV.SendCSV': {
    en: 'Send CSV',
    se: 'Skicka CSV',
    es: 'Enviar CSV',
  },
  'SendCSV.UnverifiedReceipts': {
    en: 'Unverified receipts',
    se: 'Overifierade kvitton',
    es: 'Recibos no verificados',
  },
  'SendCSV.DidntSelectFile': {
    en: 'You did not select a file',
    se: 'Du har inte valt en fil',
    es: 'No seleccionó un archivo',
  },
  'SendCSV.ErrorProvider': {
    en: 'Error provider',
    se: 'Fel hos leverantör',
    es: 'Proveedor de error',
  },
  'SendCSV.TableNotSent': {
    en: 'Table was not sent',
    se: 'Tabell skickades inte',
    es: 'La tabla no se envió',
  },
  'SendCSV.ReceiptId': {
    en: 'Receipt ID',
    se: 'Kvitto ID',
    es: 'ID de recibo',
  },
  'SendCSV.Today': {
    en: 'Today',
    se: 'Idag',
    es: 'Hoy',
  },
  'Segments.Segments': {
    en: 'Segments',
    se: 'Segment',
    es: 'Segmentos',
  },
  'Segments.CreateSegment': {
    en: 'Create segment',
    se: 'Skapa segment',
    es: 'Crear segmento',
  },
  'Segments.TimeLimits': {
    en: 'Time limits',
    se: 'Tidsbegränsningar',
    es: 'Límites de tiempo',
  },
  'Segments.TimeLimitsDescription': {
    en: `Control if the segment should only count orders made at most a certain amount of
                days ago`,
    se: `Kontrollera om segmentet endast ska räkna beställningar gjorda högst en viss antal
    dagar sedan`,
    es: `Controlar si el segmento solo debe contar las órdenes realizadas en la mayor cantidad de
    días atrás`,
  },
  'Segments.OnlyShowOrdersFrom': {
    en: 'Only show orders from',
    se: 'Visa endast beställningar från',
    es: 'Solo mostrar órdenes de',
  },
  'Segments.DaysAgo': {
    en: 'Days ago',
    se: 'Dagar sedan',
    es: 'Días atrás',
  },
  'Segments.OfferDescription': {
    en: 'Send out an offer when a user becomes a member of this segment',
    se: 'Skicka ut ett erbjudande när en användare blir medlem i detta segment',
    es: 'Enviar una oferta cuando un usuario se convierte en miembro de este segmento',
  },
  'Segments.MustSelectOffer': {
    en: 'You must select an offer',
    se: 'Du måste välja ett erbjudande',
    es: 'Debe seleccionar una oferta',
  },
  'Segments.PushNotificationDescription': {
    en: 'Send out a push notification when a user joins this segment',
    se: 'Skicka ut ett push-meddelande när en användare går med i detta segment',
    es: 'Enviar una notificación push cuando un usuario se une a este segmento',
  },
  'Segments.NotificationTitle': {
    en: 'Notification Title',
    se: 'Aviseringens rubrik',
    es: 'Título de la notificación',
  },
  'Segments.NotificationBody': {
    en: 'Notification body',
    se: 'Aviseringens brödtext',
    es: 'Cuerpo de la notificación',
  },
  'Segments.Filters': {
    en: 'Filters',
    se: 'Filter',
    es: 'Filtros',
  },
  'Segments.FiltersDescription': {
    en: `Create a series of sequential filters which will limit which users are included in
                the segment`,
    se: `Skapa en serie sekventiella filter som begränsar vilka användare som ingår i
    segmentet`,
    es: `Cree una serie de filtros secuenciales que limitarán qué usuarios se incluirán en el
    segmento`,
  },
  'ResetPassword.ForgotYourPassword': {
    en: 'Forgot your password?',
    se: 'Glömt ditt lösenord?',
    es: '¿Olvidaste tu contraseña?',
  },
  'ResetPassword.EnterUsername': {
    en: 'Please enter your username below and we will send you a link to your email to reset your password ',
    se: 'Ange ditt användarnamn nedan så skickar vi en länk till din e-post för att återställa ditt lösenord.',
    es: 'Ingrese su nombre de usuario a continuación y le enviaremos un enlace a su correo electrónico para restablecer su contraseña',
  },
  'ResetPassword.SendLink': {
    en: 'Send link',
    se: 'Skicka länk',
    es: 'Enviar enlace',
  },
  'ResetPassword.EmailHasBeenSentToYourEmail': {
    en: 'The verification link has been sent to your email.',
    se: 'Verifieringslänken har skickats till din e-post.',
    es: 'El enlace de verificación se ha enviado a su correo electrónico.',
  },
  'ResetPassword.ResetYourPassword': {
    en: 'Reset your password',
    se: 'Återställ ditt lösenord',
    es: 'Restablecer tu contraseña',
  },
  'ResetPassword.UseEightOrMoreCharacters': {
    en: 'Use 8 or more characters with at least one number and one upperchase character.',
    se: 'Använd 8 eller fler tecken med minst en siffra och en versal.',
    es: 'Use 8 o más caracteres con al menos un número y un carácter mayúscula.',
  },
  'ResetPassword.NewPassword': {
    en: 'New password',
    se: 'Nytt lösenord',
    es: 'Nueva contraseña',
  },
  'ResetPassword.Reset': {
    en: 'Reset',
    se: 'Återställ',
    es: 'Restablecer',
  },
  'ResetPassword.PasswordSuccessfullyUpdated': {
    en: 'Your password was successfully updated.',
    se: 'Ditt lösenord har uppdaterats.',
    es: 'Su contraseña se actualizó correctamente.',
  },
  'ResetPassword.PasswordIsTooShort': {
    en: 'Password is too short.',
    se: 'Lösenordet är för kort.',
    es: 'La contraseña es demasiado corta.',
  },
  'ResetPassword.PasswordMustContain': {
    en: 'Password must contain at least one number and one uppercase character. Only letters (a-z and A-Z), numbers (0-9), and allowed special characters (!@#$%^&*?_~) can be used.',
    se: 'Lösenordet måste innehålla minst en siffra och en versal. Endast bokstäver (a-z och A-Z), siffror (0-9) och tillåtna specialtecken (!@#$%^&*?_~) kan användas.',
    es: 'La contraseña debe contener al menos un número y un carácter mayúscula. Solo se pueden usar letras (a-z y A-Z), números (0-9) y caracteres especiales permitidos (!@#$%^&*?_~).',
  },
  'SetNewPassword.ChangePasswordTitle': {
    en: 'Change password for this user',
    se: 'Ändra lösenord för denna användare',
    es: 'Cambiar contraseña para este usuario',
  },
  'SetNewPassword.UpdateButton': {
    en: 'Update',
    se: 'Uppdatera',
    es: 'Actualizar',
  },
  'SetNewPassword.PasswordUpdated': {
    en: 'Password updated',
    se: 'Lösenord uppdaterat',
    es: 'Contraseña actualizada',
  },
  'SetNewPassword.NewPassword': {
    en: 'New password',
    se: 'Nytt lösenord',
    es: 'Nueva contraseña',
  },
  'SetNewPassword.ConfirmPassword': {
    en: 'Confirm new password',
    se: 'Bekräfta nytt lösenord',
    es: 'Confirmar nueva contraseña',
  },
  'SetNewPassword.PasswordsDoNotMatch': {
    en: 'Passwords do not match.',
    se: 'Lösenorden matchar inte.',
    es: 'Las contraseñas no coinciden.',
  },
  'Reports.PosReports': {
    en: 'POS reports',
    se: 'POS rapporter',
    es: 'POS informes',
  },
  'Reports.GeneratePosReport': {
    en: 'Generate an POS report for a specific date range',
    se: 'Skapa en POS-rapport för ett specifikt datumintervall',
    es: 'Genere un informe POS para un rango de fechas específico',
  },
  'Reports.AppPosReports': {
    en: 'App/POS reports',
    se: 'App/POS rapporter',
    es: 'App/POS informes',
  },
  'Reports.GenerateAppPosReport': {
    en: 'Generate an App/POS report for a specific date range',
    se: 'Skapa en app/POS-rapport för ett specifikt datumintervall',
    es: 'Genere un informe App/POS para un rango de fechas específico',
  },
  'Reports.ChooseReportType': {
    en: 'Choose report type',
    se: 'Välj rapporttyp',
    es: 'Elija el tipo de informe',
  },
  'Reports.AppReport': {
    en: 'App report',
    se: 'App rapport',
    es: 'Informe de App',
  },
  'Reports.PosReport': {
    en: 'POS report',
    se: 'POS rapport',
    es: 'Informe POS',
  },
  'Reports.AppPlusPosReport': {
    en: 'App + POS report',
    se: 'App + POS rapport',
    es: 'Informe de App + POS',
  },
  'Reports.GenerateReport': {
    en: 'Generate report',
    se: 'Skapa rapport',
    es: 'Generar informe',
  },
  'Reports.NewAdyenReportInfoBoxTitle': {
    en: 'New Adyen report',
    se: 'Ny Adyen-rapport',
    es: 'Nuevo informe de Adyen',
  },
  'Reports.NewAdyenReportInfoBoxDescription': {
    en: 'We have a new Adyen report available. You can find it in the reports-section named Transaction Fee reports.',
    se: 'Vi har en ny Adyen-rapport tillgänglig. Du hittar den i rapport-sektionen med namnet Transaktionsrapporter.',
    es: 'Tenemos un nuevo informe de Adyen disponible. Puede encontrarlo en la sección de informes llamada Informes de transacción.',
  },
  'Reports.NewAdyenReportInfoBoxText': {
    en: 'These reports are available from February 2025 and forward',
    se: 'Dessa rapporter är tillgängliga från februari 2025 och framåt',
    es: 'Estos informes están disponibles desde febrero de 2025 en adelante',
  },
  'Reports.NewAdyenReportInfoBoxGoToNewReport': {
    en: 'Go to new report',
    se: 'Gå till ny rapport',
    es: 'Ir al nuevo informe',
  },
  'Reports.LongReportLoading': {
    en: 'For longer durations, generating a report might take some time. You can choose to have the report delivered to your email instead.',
    se: 'För längre perioder kan det ta lite tid att skapa en rapport. Du kan välja att få rapporten levererad till din e-post istället.',
    es: 'Para períodos más largos, la generación de un informe puede tardar un poco. Puede optar por recibir el informe en su correo electrónico en su lugar.',
  },
  'Reports.SendEmailReport': {
    en: 'Send email report',
    se: 'Skicka e-postrapport',
    es: 'Enviar informe por correo electrónico',
  },
  'Reports.ReportSuccessfullySentToEmail': {
    en: 'Request successfully sent! You should have the report in a moment.',
    se: 'Förfrågan har skickats! Du borde ha rapporten om ett ögonblick.',
    es: '¡Solicitud enviada correctamente! Debería tener el informe en un momento.',
  },
  'Reports.NoSalesForChosenTimeFrame': {
    en: 'There are no sales for the chosen time frame',
    se: 'Det finns ingen försäljning under den valda tidsramen',
    es: 'No hay ventas para el período de tiempo elegido',
  },
  'Reports.NotAvailableForLimitedUsers': {
    en: 'Not available for limited users',
    se: 'Ej tillgängligt för begränsade användare',
    es: 'No disponible para usuarios limitados',
  },
  'Reports.PosItemReports': {
    en: 'POS Item reports',
    se: 'POS-artikelrapporter',
    es: 'POS artículo informes',
  },
  'Reports.GeneratePosItemReport': {
    en: 'Generate a POS Item report for a specific date range',
    se: 'Skapa en POS-artikelrapport för ett specifikt datumintervall',
    es: 'Genere un informe POS artículo para un rango de fechas específico',
  },
  'Reports.FortnoxReports': {
    en: 'Fortnox reports',
    se: 'Fortnox rapporter',
    es: 'Fortnox informes',
  },
  'Reports.GenerateFortnoxReport': {
    en: 'Generate a Fortnox report for a specific date range',
    se: 'Skapa en Fortnox-rapport för ett specifikt datumintervall',
    es: 'Genere un informe Fortnox para un rango de fechas específico',
  },
  'Reports.FortnoxReport': {
    en: 'Fortnox report',
    se: 'Fortnox rapport',
    es: 'Fortnox informe',
  },
  'Reports.FortnoxDbReport': {
    en: 'Fortnox DB report',
    se: 'Fortnox DB rapport',
    es: 'Fortnox DB informe',
  },
  'Reports.ZReports': {
    en: 'Z-Reports',
    se: 'Z-rapporter',
    es: 'Z informes',
  },
  'Reports.SeeZReportSaleReport': {
    en: 'See the Z-report/Sale report for a specific date',
    se: 'Se Z-rapporten/försäljningsrapporten för ett specifikt datum',
    es: 'Ver el informe Z/Informe de venta para una fecha específica',
  },
  'Reports.ChooseDevice': {
    en: 'Choose device',
    se: 'Välj enhet',
    es: 'Elija el dispositivo',
  },
  'Reports.ChooseZReport': {
    en: 'Choose Z-report',
    se: 'Välj Z-rapport',
    es: 'Elija el informe Z',
  },
  'Reports.NoSalesOnThisDate': {
    en: 'There were no sales on this date',
    se: 'Det var ingen försäljning det här datumet',
    es: 'No hubo ventas en esta fecha',
  },
  'Reports.NoSalesForSelectedDevice': {
    en: ' or for the selected device',
    se: ' eller för den valda enheten',
    es: ' o para el dispositivo seleccionado',
  },
  'Reports.NetSales': {
    en: 'Net sales',
    se: 'Nettointäkter',
    es: 'Ventas netas',
  },
  'Reports.Subtotal': {
    en: 'Subtotal',
    se: 'Intäkt ex. moms',
    es: 'Subtotal',
  },
  'Reports.SalesPerCategory': {
    en: 'Sales per category',
    se: 'Försäljning per kategori',
    es: 'Ventas por categoría',
  },
  'Reports.TotalSales': {
    en: 'Total sales',
    se: 'Total försäljning',
    es: 'Ventas totales',
  },
  'Reports.SalesPerZone': {
    en: 'Sales per zone',
    se: 'Försäljning per zon',
    es: 'Ventas por zona',
  },
  'Reports.TotalNetSales': {
    en: 'Total net sales',
    se: 'Total nettoomsättning',
    es: 'Ventas netas totales',
  },
  'Reports.Receipts': {
    en: 'Receipts',
    se: 'Kvitton',
    es: 'Recibos',
  },
  'Reports.RegisterReceipts': {
    en: 'Register receipts',
    se: 'Registrera kvitton',
    es: 'Registrar recibos',
  },
  'Reports.PaymentMethods': {
    en: 'Payment methods',
    se: 'Betalningsmetoder',
    es: 'Métodos de pago',
  },
  'Reports.Expenses': {
    en: 'Expenses',
    se: 'Utgifter',
    es: 'Gastos',
  },
  'Reports.OpenCheques': {
    en: 'Open cheques',
    se: 'Öppna notor',
    es: 'Cheques abiertos',
  },
  'Reports.CashRegister': {
    en: 'Cash register',
    se: 'Växelkassa',
    es: 'Caja registradora',
  },
  'Reports.CashRegister.In': {
    en: 'Cash register in',
    es: 'Caja registradora en',
    se: 'Växelkassa in',
  },
  'Reports.CashRegister.Out': {
    en: 'Cash register out',
    es: 'Caja registradora fuera',
    se: 'Växelkassa ut',
  },
  'Reports.TotalExpenses': {
    en: 'Total expenses',
    se: 'Totala utgifter',
    es: 'Gastos totales',
  },
  'Reports.Payouts': {
    en: 'Payouts',
    se: 'Utbetalningar',
    es: 'Pagos',
  },
  'Reports.Payouts.NoPayoutsFound': {
    en: 'No payouts found',
    se: 'Inga utbetalningar hittades',
    es: 'No se encontraron pagos',
  },
  'Reports.Payouts.SelectADeviceToViewPayouts': {
    en: 'Choose device to view payouts',
    se: 'Välj en enhet för att se utbetalningar',
    es: 'Seleccione un dispositivo para ver los pagos',
  },
  'Reports.Payouts.CashDrawer': {
    en: 'Cash drawer',
    se: 'Kassalåda',
    es: 'Caja registradora',
  },
  'Reports.AlltimeSales': {
    en: 'Alltime sales',
    se: 'All försäljning',
    es: 'Ventas de todos los tiempos',
  },
  'Reports.SalesIncludingVat': {
    en: 'Sales including VAT',
    se: 'Försäljning inklusive moms',
    es: 'Ventas incluyendo IVA',
  },
  'Reports.TotalRefunds': {
    en: 'Total refunds',
    se: 'Totala återbetalningar',
    es: 'Reembolsos totales',
  },
  'Reports.TotalSalesTipsAndRefunds': {
    en: 'Total sales(-tips, -refunds)',
    se: 'Total försäljning (-dricks, -återbetalningar)',
    es: 'Ventas totales (-propinas, -reembolsos)',
  },
  'Reports.DaySalesIncludingVat': {
    en: 'Day sales including VAT',
    se: 'Dagsförsäljning inklusive moms',
    es: 'Ventas diarias incluyendo IVA',
  },
  'Reports.OrgNumber': {
    en: 'Orgnr',
    se: 'Orgnr',
    es: 'Orgno',
  },
  'Reports.SendZReportToAnEmail': {
    en: 'Send Z-report to an email',
    se: 'Skicka Z-rapport till ett e-postmeddelande',
    es: 'Enviar informe Z a un correo electrónico',
  },
  'Reports.EmailHasBeenSent': {
    en: 'Email has been sent, it might take a couple of minutes.',
    se: 'E-post har skickats, det kan ta ett par minuter.',
    es: 'El correo electrónico ha sido enviado, puede tardar unos minutos.',
  },
  'Reports.TopBySalesVolume': {
    en: 'Top by sales volume',
    se: 'Toppa efter försäljningsvolym',
    es: 'Lo mejor por volumen de ventas',
  },
  'Reports.SalesPer': {
    en: 'Sales per',
    se: 'Försäljning per',
    es: 'Ventas por',
  },
  'Reports.ItemSalesPerVenue': {
    en: 'Item sales per venue',
    se: 'Försäljning av artiklar per butik',
    es: 'Ventas de artículos por lugar',
  },
  'Reports.RegisteredUsers': {
    en: 'Registered users',
    se: 'Registrerade användare',
    es: 'Usuarios registrados',
  },
  'Reports.TopSpent': {
    en: 'Top spent',
    se: 'Topp spenderade',
    es: 'Lo mejor gastado',
  },
  'Reports.TopSold': {
    en: 'Top sold',
    se: 'Topp såld',
    es: 'Lo mejor vendido',
  },
  'Reports.GiftCardReports': {
    en: 'Gift card reports',
    se: 'Presentkortsrapporter',
    es: 'Informes de tarjetas de regalo',
  },
  'Reports.GiftCardReportsDescription': {
    en: 'Monthly information about gift card sales, balances, and the number of active and inactive cards.',
    se: 'Månadsinformation om försäljning av presentkort, saldon och antalet aktiva och inaktiva kort',
    es: 'Información mensual sobre ventas de tarjetas de regalo, saldos y la cantidad de tarjetas activas e inactivas.',
  },
  'Reports.TransactionVolume': {
    en: 'Transaction volume',
    se: 'Transaktionsvolym',
    es: 'Volumen de transacciones',
  },
  'Reports.OutstandingBalance': {
    en: 'Outstanding balance',
    se: 'Utestående saldo',
    es: 'Saldo pendiente',
  },
  'Reports.NumberOfActiveCards': {
    en: 'Number of active cards',
    se: 'Antal aktiva kort',
    es: 'Número de tarjetas activas',
  },
  'Reports.NumberOfInactiveCards': {
    en: 'Number of inactive cards',
    se: 'Antal inaktiva kort',
    es: 'Número de tarjetas inactivas',
  },
  'Reports.OrdersReport': {
    en: 'Orders report',
    se: 'Beställningsrapport',
    es: 'Informe de pedidos',
  },
  'General.NotAllowed': {
    en: 'Not allowed',
    se: 'Inte tillåtet',
    es: 'No permitido',
  },
  'General.Deleted': {
    en: 'deleted',
    se: 'raderad',
    es: 'borrado',
  },
  'Reports.ExportDescription': {
    en: 'Export a list of all orders for a specific date range',
    se: 'Exportera en lista över alla beställningar för ett datumintervall',
    es: 'Exportar una lista de todas las órdenes para un rango de fechas específico',
  },
  'Reports.OrdersReport.Export': {
    en: 'Export',
    se: 'Exportera',
    es: 'Exportar',
  },
  'Register.StepFirst': {
    en: 'Step 1/2',
    se: 'Steg 1/2',
    es: 'Paso 1/2',
  },
  'Register.FirstName': {
    en: 'First name*',
    se: 'Förnamn*',
    es: 'Nombre*',
  },
  'Register.LastName': {
    en: 'Last name*',
    se: 'Efternamn*',
    es: 'Apellido*',
  },
  'Register.EmailOrUsername': {
    en: 'Email / Username*',
    se: 'E-post / Användarnamn*',
    es: 'Correo electrónico / Nombre de usuario*',
  },
  'Register.Password': {
    en: 'Password*',
    se: 'Lösenord*',
    es: 'Contraseña*',
  },
  'Register.ConfirmPassword': {
    en: 'Confirm password*',
    se: 'Bekräfta lösenord*',
    es: 'Confirmar contraseña*',
  },
  'Register.AlreadyAMember': {
    en: 'Already a member?',
    se: 'Redan medlem?',
    es: '¿Ya eres miembro?',
  },
  'Register.PasswordRestrictions': {
    en: 'Password should be at least 8 characters long, include number/s, uppercase letter/s and also can contain lowercase letters and special characters (!@#$%^&*?_~)',
    se: 'Lösenordet ska vara minst 8 tecken långt, innehålla siffror, versaler och kan även innehålla gemener och specialtecken (!@#$%^&*?_~)',
    es: 'La contraseña debe tener al menos 8 caracteres, incluir números, letras mayúsculas y también puede contener letras minúsculas y caracteres especiales (!@#$%^&*?_~)',
  },
  'Register.StepSecond': {
    en: 'Step 2/2',
    se: 'Steg 2/2',
    es: 'Paso 2/2',
  },
  'Register.TellUsMoreAboutYourBusiness': {
    en: 'Tell us more about your business',
    se: 'Berätta mer om ditt företag',
    es: 'Cuéntanos más sobre tu negocio',
  },
  'Register.BrandName': {
    en: 'Brand name*',
    se: 'Varumärke*',
    es: 'Marca*',
  },
  'Register.DefaultLanguage': {
    en: 'Default language*',
    se: 'Standardspråk*',
    es: 'Idioma predeterminado*',
  },
  'Register.Currency': {
    en: 'Currency*',
    se: 'Valuta*',
    es: 'Moneda*',
  },
  'Register.TermsAndConditions': {
    en: 'Terms and Conditions',
    se: 'Villkor',
    es: 'Términos y condiciones',
  },
  'Register.AlmostThere': {
    en: 'Almost there!',
    se: 'Nästan där!',
    es: '¡Casi está!',
  },
  'Register.VerifyYourAccount': {
    en: 'You need to verify your account. We have sent you an email with instructions.',
    se: 'Du måste verifiera ditt konto. Vi har skickat ett mejl med instruktioner.',
    es: 'Necesitas verificar tu cuenta. Te hemos enviado un correo electrónico con instrucciones.',
  },
  'Register.FirstNameValidation': {
    en: 'Please, enter your First name.',
    se: 'Vänligen ange ditt förnamn.',
    es: 'Por favor, ingrese su nombre.',
  },
  'Register.LastNameValidation': {
    en: 'Please, enter your Last name.',
    se: 'Vänligen ange ditt efternamn.',
    es: 'Por favor, ingrese su apellido.',
  },
  'Register.EmailValidation': {
    en: 'Please, enter valid email.',
    se: 'Vänligen ange giltig e-postadress.',
    es: 'Por favor, ingrese un correo electrónico válido.',
  },
  'Register.PasswordValidation': {
    en: 'Please, make sure password is at least 8 characters long, includes number/s, uppercase letter/s, and also can contain lowercase letters and special characters (!@#$%^&*?_~)',
    se: 'Se till att lösenordet är minst 8 tecken långt, innehåller siffror, versaler och kan även innehålla gemener och specialtecken (!@#$%^&*?_~)',
    es: 'Por favor, asegúrese de que la contraseña tenga al menos 8 caracteres, incluya números, letras mayúsculas y también puede contener letras minúsculas y caracteres especiales (!@#$%^&*?_~)',
  },
  'Register.PasswordMatchValidation': {
    en: 'Please, make sure passwords match',
    se: 'Se till att lösenorden matchar',
    es: 'Por favor, asegúrese de que las contraseñas coincidan',
  },
  'Register.BrandNameValidation': {
    en: 'Please, enter your Brand name.',
    se: 'Vänligen ange ditt varumärke.',
    es: 'Por favor, ingrese su marca.',
  },
  'Register.LanguageValidation': {
    en: 'Please, select your default language.',
    se: 'Vänligen välj ditt standardspråk.',
    es: 'Por favor, seleccione su idioma predeterminado.',
  },
  'Register.CurrencyValidation': {
    en: 'Please, select your default currency.',
    se: 'Vänligen välj din standardvaluta.',
    es: 'Por favor, seleccione su moneda predeterminada.',
  },
  'ReceiptTemplates.ReceiptTemplates': {
    en: 'Receipt Templates',
    se: 'Kvittomallar',
    es: 'Plantillas de recibo',
  },
  'ReceiptTemplates.CreateReceiptTemplate': {
    en: 'Create Receipt Template',
    se: 'Skapa kvittomall',
    es: 'Crear plantilla de recibo',
  },
  'ReceiptTemplates.Logo': {
    en: 'Logo',
    se: 'Logotyp',
    es: 'Logotipo',
  },
  'ReceiptTemplates.IntroText': {
    en: 'Intro text',
    se: 'Introtext',
    es: 'Texto introductorio',
  },
  'ReceiptTemplates.BottomText': {
    en: 'Bottom text',
    se: 'Undertext',
    es: 'Texto inferior',
  },
  'ReceiptTemplates.NameValidation': {
    en: 'Name can only contain characters between A-Z and numbers',
    se: 'Namn får bara innehålla tecken mellan A-Z och siffror',
    es: 'El nombre solo puede contener caracteres entre A-Z y números',
  },
  'POS.CreateNewLayout': {
    en: 'Create new layout',
    se: 'Skapa ny layout',
    es: 'Crear nueva disposición',
  },
  'POS.NewLayoutDescription': {
    en: 'Fill in the layout name and the page names',
    se: 'Fyll i namnet för layouten och sidans namn',
    es: 'Rellene el nombre de la disposición y los nombres de las páginas',
  },
  'POS.Layout': {
    en: 'Layout',
    se: 'Layout',
    es: 'Diseño',
  },
  'POS.ChangeLayoutName': {
    en: 'Change the layout name',
    se: 'Ändra layoutens namn',
    es: 'Cambie el nombre de la disposición',
  },
  'POS.DeleteLayout': {
    en: 'Delete layout',
    se: 'Ta bort layout',
    es: 'Eliminar diseño',
  },
  'POS.DeleteLayoutConfirmation': {
    en: 'Are you sure you want to remove this layout, all pages and buttons added to it will be deleted',
    se: 'Är du säker på att du vill ta bort den här layouten? Alla sidor och knappar som lagts till i den kommer att raderas',
    es: '¿Está seguro de que desea eliminar esta disposición? Todas las páginas y botones agregados se eliminarán',
  },
  'POS.Yes': {
    en: 'Yes',
    se: 'Ja',
    es: 'Sí',
  },
  'POS.No': {
    en: 'No',
    se: 'Nej',
    es: 'No',
  },
  'POS.ChoosePageGrid': {
    en: 'Choose page grid',
    se: 'Välj sidrutnät',
    es: 'Elegir cuadrícula de página',
  },
  'POS.CreateNewCategory': {
    en: 'Create a new category',
    se: 'Skapa en ny kategori',
    es: 'Crear una nueva categoría',
  },
  'POS.NewCategoryDescription': {
    en: 'Create a new category and set the default color',
    se: 'Skapa en ny kategori och ställ in standardfärgen',
    es: 'Cree una nueva categoría y establezca el color predeterminado',
  },
  'POS.Columns': {
    en: 'Columns',
    se: 'Kolumner',
    es: 'Columnas',
  },
  'POS.SaveLayout': {
    en: 'Save layout',
    se: 'Spara layout',
    es: 'Guardar diseño',
  },
  'POS.NewButtonName': {
    en: 'New button name',
    se: 'Nytt knappnamn',
    es: 'Nuevo nombre de botón',
  },
  'POS.NewButtonNamePlaceholder': {
    en: 'Write name here',
    se: 'Skriv namn här',
    es: 'Escribe el nombre aquí',
  },
  'POS.ButtonColor': {
    en: 'Button color',
    se: 'Knappens färg',
    es: 'Color del botón',
  },
  'POS.ButtonColorPlaceholder': {
    en: 'Choose color',
    se: 'Välj färg',
    es: 'Elige un color',
  },
  'POS.Article': {
    en: 'Article',
    se: 'Artikel',
    es: 'Artículo',
  },
  'POS.ArticleDescription': {
    en: 'Set a new button name or another color',
    se: 'Ange ett nytt knappnamn eller annan färg',
    es: 'Establezca un nuevo nombre de botón o otro color',
  },
  'POS.DeleteButton': {
    en: 'Delete button',
    se: 'Ta bort knapp',
    es: 'Eliminar botón',
  },
  'POS.Page': {
    en: 'Page',
    se: 'Sida',
    es: 'Página',
  },
  'POS.Pages': {
    en: 'Pages',
    se: 'Pages',
    es: 'Páginas',
  },
  'POS.PageDescription': {
    en: 'Set the grid and default colors',
    se: 'Ställ in rutnätet och standardfärger',
    es: 'Establezca la cuadrícula y los colores predeterminados',
  },
  'POS.DeletePage': {
    en: 'Delete page',
    se: 'Ta bort sida',
    es: 'Eliminar página',
  },
  'POS.Subpages': {
    en: 'Subpages (windows)',
    se: 'Undersidor (fönster)',
    es: 'Subpáginas (ventanas)',
  },
  'POS.SubpagesPlaceholder': {
    en: 'Select pages',
    se: 'Välj sidor',
    es: 'Seleccionar páginas',
  },
  'POS.AddNewSubpage': {
    en: 'Add new subpage (window)',
    se: 'Lägg till ny undersida (fönster)',
    es: 'Agregar nueva subpágina (ventana)',
  },
  'POS.AddNewSubpagePlaceholder': {
    en: 'Fill in name here',
    se: 'Fyll i namn här',
    es: 'Rellene el nombre aquí',
  },
  'POS.BundleOffers': {
    en: 'Bundle offers',
    se: 'Paketerbjudanden',
    es: 'Ofertas de paquetes',
  },
  'POS.BundleOffersPlaceholder': {
    en: 'Select bundle offers',
    se: 'Välj paketerbjudanden',
    es: 'Seleccionar ofertas de paquetes',
  },
  'POS.DeletePageConfirmation': {
    en: 'Are you sure you want to remove this page, all buttons added to it will be deleted',
    se: 'Är du säker på att du vill ta bort den här sidan? Alla knappar som lagts till i den kommer att raderas',
    es: '¿Estás seguro de que quieres eliminar esta página? Todos los botones agregados se eliminarán',
  },
  'POS.SearchForArticleCategory': {
    en: 'Search for article or category',
    se: 'Sök efter artikel eller kategori',
    es: 'Buscar artículo o categoría',
  },
  'POS.Uncategorised': {
    en: 'Uncategorised',
    se: 'Okategoriserad',
    es: 'Sin categoría',
  },
  'POS.ChangeGridConfirmation': {
    en: 'Are you sure you want to change the grid? The buttons in the following column will be deleted:',
    se: 'Är du säker på att du vill ändra rutnätet? Knapparna i följande kolumn kommer att raderas:',
    es: '¿Estás seguro de que quieres cambiar la cuadrícula? Los botones en la siguiente columna se eliminarán:',
  },
  'POS.DuplicatePage': {
    en: 'Duplicate page',
    se: 'Duplicera sida',
    es: 'Duplicar página',
  },
  'POS.DuplicatePageCreated': {
    en: 'Duplicate page created',
    se: 'Duplicerad sida skapad',
    es: 'Página duplicada creada',
  },
  'PIM.InactiveArticles': {
    en: 'Inactive articles',
    se: 'Inaktiva artiklar',
    es: 'Artículos inactivos',
  },
  'PIM.Allergen.CELERY': {
    en: 'Celery allergy',
    se: 'Selleriallergi',
    es: 'Alergia a la cebolla',
  },
  'PIM.Allergen.CRUSTACEANS': {
    en: 'Crustaceans allergy',
    se: 'Kräftdjursallergi',
    es: 'Alergia a los crustáceos',
  },
  'PIM.Allergen.EGGS': {
    en: 'Egg allergy',
    se: 'Äggallergi',
    es: 'Alergia a los huevos',
  },
  'PIM.Allergen.FISH': {
    en: 'Fish allergy',
    se: 'Fiskallergi',
    es: 'Alergia al pescado',
  },
  'PIM.Allergen.GLUTEN': {
    en: 'Gluten allergy',
    se: 'Glutenallergi',
    es: 'Alergia al gluten',
  },
  'PIM.Allergen.LUPIN': {
    en: 'Lupin allergy',
    se: 'Lupinallergi',
    es: 'Alergia al lupino',
  },
  'PIM.Allergen.MILK': {
    en: 'Milk allergy',
    se: 'Mjölkallergi',
    es: 'Alergia a la leche',
  },
  'PIM.Allergen.MOLLUSCS': {
    en: 'Molluscs allergy',
    se: 'Blötdjursallergi',
    es: 'Alergia a los moluscos',
  },
  'PIM.Allergen.MUSTARD': {
    en: 'Mustard allergy',
    se: 'Senapsallergi',
    es: 'Alergia a la mostaza',
  },
  'PIM.Allergen.NUTS': {
    en: 'Nut allergy',
    se: 'Nötallergi',
    es: 'Alergia a los frutos secos',
  },
  'PIM.Allergen.PEANUTS': {
    en: 'Peanut allergy',
    se: 'Jordnötsallergi',
    es: 'Alergia a los cacahuetes',
  },
  'PIM.Allergen.SESAME': {
    en: 'Sesame allergy',
    se: 'Sesamallergi',
    es: 'Alergia al sésamo',
  },
  'PIM.Allergen.SOYBEANS': {
    en: 'Soybeans allergy',
    se: 'Sojabönor allergi',
    es: 'Alergia a los frijoles',
  },
  'PIM.Allergen.SULPHITES': {
    en: 'Sulphites allergy',
    se: 'Sulfiter allergi',
    es: 'Alergia a los sulfitos',
  },
  'PIM.Allergen.SULPHUR_DIOXIDE': {
    en: 'Sulphur dioxide allergy',
    se: 'Svaveldioxidallergi',
    es: 'Alergia al dióxido de azufre',
  },
  'PIM.Allergens': {
    en: 'Allergens',
    se: 'Allergener',
    es: 'Alergenos',
  },
  'PIM.AllArticlesMenu': {
    en: 'All articles',
    se: 'Alla artiklar',
    es: 'Todos los artículos',
  },
  'PIM.Articles': {
    en: 'Articles',
    se: 'Artiklar',
    es: 'Artículos',
  },
  'PIM.Article': {
    en: 'Article',
    se: 'Artikel',
    es: 'Artículo',
  },
  'PIM.Categories': {
    en: 'Categories',
    se: 'Kategorier',
    es: 'Categorías',
  },
  'PIM.Category': {
    en: 'Category',
    se: 'Kategori',
    es: 'Categoría',
  },
  'PIM.Menus': {
    en: 'Menus',
    se: 'Menyer',
    es: 'Menús',
  },
  'PIM.Menu': {
    en: 'Menu',
    se: 'Meny',
    es: 'Menú',
  },
  'PIM.Ingredient': {
    en: 'Ingredient',
    se: 'Ingrediens',
    es: 'Ingrediente',
  },
  'PIM.ModificationGroup': {
    en: 'Modification groups',
    se: 'Modifieringsgrupper',
    es: 'Grupos de modificación',
  },
  'PIM.ModificationGroup.Desc': {
    en: 'For example: "Burger size: Small, Medium or Large" or "Extra burger toppings: Extra cheese, Bacon, Extra patty"',
    se: 'Till exempel: "Burgarstorlek: Liten, Medium eller Stor" eller "Extra burgartillbehör: Extra ost, Bacon, Extra biff"',
    es: 'Por ejemplo: "Tamaño de hamburguesa: Pequeño, Mediano o Grande" o "Ingredientes adicionales de hamburguesa: Queso extra, Tocino, Hamburguesa extra"',
  },
  'PIM.Upsell': {
    en: 'Upsell',
    se: 'Merförsäljning',
    es: 'Venta adicional',
  },
  'PIM.Upsells': {
    en: 'Upsells',
    se: 'Merförsäljningar',
    es: 'Ventas adicionales',
  },
  'PIM.Messages': {
    en: 'Messages',
    se: 'Meddelanden',
    es: 'Mensajes',
  },
  'PIM.Message': {
    en: 'Message',
    se: 'Meddelande',
    es: 'Mensaje',
  },
  'PIM.SearchForArticles': {
    en: 'Search for articles',
    se: 'Sök efter artiklar',
    es: 'Buscar artículos',
  },
  'PIM.NoResultsFor': {
    en: 'No result found for',
    se: 'Inget resultat hittades för',
    es: 'No se encontraron resultados para',
  },
  'PIM.NoResultsDescription': {
    en: 'Check your spelling or create the article',
    se: 'Kontrollera din stavning eller skapa artikeln',
    es: 'Revise la ortografía o cree el artículo',
  },
  'PIM.Group': {
    en: 'Group',
    se: 'Grupp',
    es: 'Grupo',
  },
  'PIM.SearchForCategories': {
    en: 'Search for categories',
    se: 'Sök efter kategorier',
    es: 'Buscar categorías',
  },
  'PIM.IngredientGroup': {
    en: 'Ingredient group',
    se: 'Ingrediensgrupp',
    es: 'Grupo de ingredientes',
  },
  'PIM.IngredientGroups': {
    en: 'Ingredient groups',
    se: 'Ingrediensgrupper',
    es: 'Grupos de ingredientes',
  },
  'PIM.UpsellGroup': {
    en: 'Upsell group',
    se: 'Merförsäljnings-grupp',
    es: 'Grupo de venta adicional',
  },
  'PIM.UpsellGroups': {
    en: 'Upsell groups',
    se: 'Merförsäljnings-grupper',
    es: 'Grupos de venta adicional',
  },
  'PIM.NewArticle': {
    en: 'New article',
    se: 'Ny artikel',
    es: 'Nuevo artículo',
  },
  'PIM.NewCategory': {
    en: 'New category',
    se: 'Ny kategori',
    es: 'Nueva categoría',
  },
  'PIM.NewIngredient': {
    en: 'New ingredient',
    se: 'Ny ingrediens',
    es: 'Nuevo ingrediente',
  },
  'PIM.NewMenu': {
    en: 'New menu',
    se: 'Ny meny',
    es: 'Nuevo menú',
  },
  'PIM.NewGroup': {
    en: 'New group',
    se: 'Ny grupp',
    es: 'Nuevo grupo',
  },
  'PIM.NewUpsell': {
    en: 'New upsell',
    se: 'Ny merförsäljning',
    es: 'Nuevo venta adicional',
  },
  'PIM.NewMessage': {
    en: 'New message',
    se: 'Nytt meddelande',
    es: 'Nuevo mensaje',
  },
  'PIM.TheArticlesYouOfferYourCustomers': {
    en: 'The articles you offer your customers',
    se: 'Artiklarna du erbjuder dina kunder',
    es: 'Los artículos que ofrece a sus clientes',
  },
  'PIM.CategoryDescription': {
    en: 'A parent of several articles. Set default values for new articles created in the category.',
    se: 'En gruppering av flera artiklar. Ställ in standardvärden för nya artiklar som skapats i kategorin.',
    es: 'Un agrupamiento de varios artículos. Establecer valores predeterminados para los nuevos artículos creados en la categoría.',
  },
  'PIM.MenuDescription': {
    en: 'Build a collection of articles, and set menu specific prices, if you want.',
    se: 'Bygg en samling av artiklar och ställ in menyspecifika priser om du vill.',
    es: 'Cree una colección de artículos y establezca precios específicos para el menú, si lo desea.',
  },
  'PIM.IngredientDescription': {
    en: 'Fragments of an article',
    se: 'Delar av en artikel',
    es: 'Fragmentos de un artículo',
  },
  'PIM.GroupDescription': {
    en: 'Combine ingredients into groups and enable the customer to tweak the order',
    se: 'Kombinera ingredienser i grupper och gör det möjligt för kunden att justera beställningen',
    es: 'Combine ingredientes en grupos y habilite al cliente para ajustar el pedido',
  },
  'PIM.UpsellDescription': {
    en: 'Combine a group of articles to offer as upsell, before adding the selected article to the cart.',
    se: 'Kombinera en grupp artiklar att erbjuda som merförsäljning innan du lägger till den valda artikeln i kundvagnen.',
    es: 'Combine un grupo de artículos para ofrecer como upsell, antes de agregar el artículo seleccionado al carrito.',
  },
  'PIM.CourseDescription': {
    en: 'Create tags for your articles, like starter, main dish, to be able to send a group of article of the order, to the kitchen.',
    se: 'Skapa taggar för dina artiklar, som förrätt, huvudrätt, för att kunna skicka en grupp av beställningsartiklar till köket.',
    es: 'Cree etiquetas para sus artículos, como entrada, plato principal, para poder enviar un grupo de artículos del pedido, a la cocina.',
  },
  'PIM.MessageDescription': {
    en: 'Generic/default comments for efficient messaging to the kitchen staff',
    se: 'Generiska/standardkommentarer för effektiv meddelandeförmedling till kökspersonalen',
    es: 'Comentarios genéricos / predeterminados para un mensaje eficiente a los empleados de la cocina',
  },
  'PIM.ArticleHeaderDescription': {
    en: 'Give you customer the experience they deserve',
    se: 'Ge din kund den upplevelse de förtjänar',
    es: 'Dale a tu cliente la experiencia que se merece',
  },
  'PIM.CategoryHeaderDescription': {
    en: 'Set the default VAT, color and course type',
    se: 'Ställ in standardmoms, färg och kurstyp',
    es: 'Establezca el IVA predeterminado, el color y el tipo de curso',
  },
  'PIM.MenuHeaderDescription': {
    en: 'Build a collection of articles and set price adjustments to items for the menu.',
    se: 'Bygg en samling artiklar och ställ in prisjusteringar på objekt för menyn.',
    es: 'Cree una colección de artículos y establezca ajustes de precio a los artículos para el menú.',
  },
  'PIM.UpsellHeaderDescription': {
    en: 'Combine a group of articles to offer the customer before completing the purchase',
    se: 'Kombinera en grupp artiklar för att erbjuda kunden innan du slutför köpet',
    es: 'Combine un grupo de artículos para ofrecer al cliente antes de completar la compra',
  },
  'PIM.IngredientHeaderDescription': {
    en: 'Fragments of an article',
    se: 'Fragment av en artikel',
    es: 'Fragmentos de un artículo',
  },
  'PIM.IngredientGroupHeaderDescription': {
    en: 'Group ingredient for customers to choose between',
    se: 'Ingrediensgrupper för kunder att välja mellan',
    es: 'Grupo de ingredientes para que los clientes elijan entre ellos',
  },
  'PIM.ModificationGroupHeaderDescription': {
    en: 'Group ingredients for customers to choose between',
    se: 'Gruppera ingredienser för kunder att välja mellan',
    es: 'Agrupe ingredientes para que los clientes elijan entre ellos',
  },
  'PIM.CourseHeaderDescription': {
    en: 'Set definitions of your articles, like starter, side-dish, main dish or dessert.',
    se: 'Ställ in definitioner av dina artiklar, som förrätt, tillbehör, huvudrätt eller efterrätt.',
    es: 'Establezca definiciones de sus artículos, como entrada, guarnición, plato principal o postre.',
  },
  'PIM.MessageHeaderDescription': {
    en: 'Generic/default comments that are available in the messaging system to send to your kitchen staff.',
    se: 'Generiska/standardkommentarer som är tillgängliga i meddelandesystemet att skicka till din kökspersonal.',
    es: 'Comentarios genéricos / predeterminados que están disponibles en el sistema de mensajería para enviar a su personal de cocina.',
  },
  'PIM.FormIngredientDescription': {
    en: 'A list of ingredients your customers can choose to deselect',
    se: 'En lista över ingredienser som dina kunder kan välja att ta bort',
    es: 'Una lista de ingredientes que sus clientes pueden elegir para deseleccionar',
  },
  'PIM.AllergenDescription': {
    en: 'Select all the allergens included in this article and if it is possible to remove or replace an ingredient',
    se: 'Välj alla allergener som ingår i denna artikel och om det är möjligt att ta bort eller ersätta en ingrediens',
    es: 'Seleccione todos los alérgenos incluidos en este artículo y si es posible eliminar o reemplazar un ingrediente',
  },
  'PIM.CanReplaceRemoveIngredient': {
    en: 'Can replace or remove ingredient',
    se: 'Kan ersätta eller ta bort ingrediens',
    es: 'Puede reemplazar o eliminar el ingrediente',
  },
  'PIM.AlternateIngredients': {
    en: 'Ingredients',
    se: 'Ingredienser',
    es: 'Ingredientes',
  },
  'PIM.RemovableIngredients': {
    en: 'Removable ingredients',
    se: 'Borttagbara ingredienser',
    es: 'Ingredientes removibles',
  },
  'PIM.ExtraIngredients': {
    en: 'Extra ingredients',
    se: 'Extra ingredienser',
    es: 'Ingredientes extra',
  },
  'PIM.ExtraIngredientsDescription': {
    en: 'Ingredients to top up the article',
    se: 'Ingredienser för att fylla på artikeln',
    es: 'Ingredientes para completar el artículo',
  },
  'PIM.AlternateIngredientsDescription': {
    en: 'A selection of ingredients for customers to choose',
    se: 'Ett urval av ingredienser som kunderna kan välja',
    es: 'Una selección de ingredientes para que los clientes elijan',
  },
  'PIM.SizesDescription': {
    en: 'Different variation of article size',
    se: 'Olika varianter av artikelstorlek',
    es: 'Diferentes variaciones de tamaño de artículo',
  },
  'PIM.HeaderInAppSelfService': {
    en: 'Header in App and Self-Service Kiosk',
    se: 'Rubrik i App och Express kassan',
    es: 'Encabezado en la App y el Express',
  },
  'PIM.SizesPlaceholder': {
    en: 'Choose your burger size',
    se: 'Välj din hamburgerstorlek',
    es: 'Elige tu tamaño de hamburguesa',
  },
  'PIM.AddSizes': {
    en: 'Add sizes',
    se: 'Lägg till storlekar',
    es: 'Añadir tamaños',
  },
  'PIM.Size': {
    en: 'Size',
    se: 'Storlek',
    es: 'Tamaños',
  },
  'PIM.LegacyGroupsDescription': {
    en: 'Groups that were created before new PIM',
    se: 'Grupper som skapades före nya PIM',
    es: 'Grupos que se crearon antes del nuevo PIM',
  },
  'PIM.FormUpsellDescription': {
    en: 'Increase your average bill. Select groups and the order they will be presented. Have 3 to 4 groups for the best outcome.',
    se: 'Öka din snittnota. Välj grupper och i vilken ordning de kommer att presenteras. Ha 3 till 4 grupper för bästa resultat.',
    es: 'Aumente su factura promedio. Seleccione grupos y el orden en que se presentarán. Tenga 3 a 4 grupos para el mejor resultado.',
  },
  'PIM.CreateArticle': {
    en: 'Create article',
    se: 'Skapa artikel',
    es: 'Crear artículo',
  },
  'PIM.UpdateArticle': {
    en: 'Update article',
    se: 'Uppdatera artikel',
    es: 'Actualizar artículo',
  },
  'PIM.AlreadyArticleWithName': {
    en: 'There is already an article with the name',
    se: 'Det finns redan en artikel med samma namn',
    es: 'Ya hay un artículo con el nombre',
  },
  'PIM.SureWantToContinue': {
    en: 'are you sure you want to continue?',
    se: 'är du säker på att du vill fortsätta?',
    es: '¿estás seguro de que quieres continuar?',
  },
  'PIM.CreateCourseType': {
    en: 'Create course type',
    se: 'Skapa rätt-typ',
    es: 'Crear tipo de curso',
  },
  'PIM.UpdateCourseType': {
    en: 'Update course type',
    se: 'Uppdatera rätt-typ',
    es: 'Actualizar tipo de curso',
  },
  'PIM.ParentCategory': {
    en: 'Parent category',
    se: 'Föräldrakategori',
    es: 'Categoría principal',
  },
  'PIM.NamePlaceholder': {
    en: 'Fill in name here',
    se: 'Fyll i namn här',
    es: 'Escriba el nombre aquí',
  },
  'PIM.DescriptionPlaceholder': {
    en: 'Fill in description',
    se: 'Fyll i beskrivning',
    es: 'Escriba la descripción',
  },
  'PIM.CategoryPlaceholder': {
    en: 'Choose category',
    se: 'Välj kategori',
    es: 'Elige categoría',
  },
  'PIM.CourseTypePlaceholder': {
    en: 'Choose type',
    se: 'Välj typ',
    es: 'Elige tipo',
  },
  'Pim.Modifications': {
    en: 'Modifications',
    se: 'Modifieringar',
    es: 'Modificaciones',
  },
  'Pim.Modifications.Group': {
    en: 'Modification Group',
    se: 'Modifieringsgrupp',
    es: 'Grupo de modificación',
  },
  'Pim.Modifications.Group.Desc': {
    en: 'Group variations into a group and enable the customer to tweak the order',
    se: 'Gruppera variationer i en grupp och möjliggör för kunden att justera beställningen',
    es: 'Agrupe variaciones en un grupo y permita al cliente ajustar el pedido',
  },
  'PIM.Modifications.InternalName': {
    en: 'Internal name',
    se: 'Internt namn',
    es: 'Nombre interno',
  },
  'PIM.Modifications.InternalName.Desc': {
    en: 'This will be used internally in the backoffice.',
    se: 'Detta kommer att användas internt i backoffice.',
    es: 'Esto se usará internamente en el backoffice.',
  },
  'PIM.Modifications.ExternalName': {
    en: 'External name',
    se: 'Externt namn',
    es: 'Nombre externo',
  },
  'PIM.Modifications.ExternalName.Desc': {
    en: 'This will be shown to the customer.',
    se: 'Detta kommer att visas för kunden.',
    es: 'Esto se mostrará al cliente.',
  },
  'PIM.Modifications.ExpandedByDefault': {
    en: 'Expanded by default',
    se: 'Öppnad som standard',
    es: 'Expandido por defecto',
  },
  'PIM.Modifications.ExpandedByDefault.Desc': {
    en: 'This section will automatically open for quick selection',
    se: 'Denna sektion kommer automatiskt att öppnas för snabbval',
    es: 'Esta sección se abrirá automáticamente para una selección rápida',
  },
  'PIM.Modifications.Type': {
    en: 'Only allow one to be selected',
    se: 'Tillåt endast en att väljas',
    es: 'Solo permitir que se seleccione uno',
  },
  'PIM.Modifications.Type.Desc': {
    en: 'If enabled, the customer will choose between the options in this group and only be able to select one.',
    se: 'Om aktiverat kommer kunden att välja mellan alternativen i denna grupp och endast kunna välja en.',
    es: 'Si está habilitado, el cliente elegirá entre las opciones de este grupo y solo podrá seleccionar una.',
  },
  'PIM.Modifications.UpdateGroup': {
    en: 'Update modification group',
    se: 'Uppdatera modifieringsgrupp',
    es: 'Actualizar grupo de modificación',
  },
  'PIM.Modifications.CreateGroup': {
    en: 'Create modification group',
    se: 'Skapa modifieringsgrupp',
    es: 'Crear grupo de modificación',
  },
  'PIM.Vat': {
    en: 'VAT %',
    se: 'Moms %',
    es: 'IVA %',
  },
  'PIM.Vat.Information': {
    en: 'Please use export/import to update the VAT or contact us at support@baemingo.com',
    se: 'Använd export/import för att uppdatera momsen eller kontakta oss på support@baemingo.com',
    es: 'Utilice la exportación/importación para actualizar el IVA o contáctenos en support@baemingo.com',
  },
  'PIM.TakeAwayVat': {
    en: 'VAT (Take away)',
    se: 'Moms (Ta med)',
    es: 'IVA (Para llevar)',
  },
  'PIM.VatPlaceholder': {
    en: 'Select VAT',
    se: 'Välj Moms',
    es: 'Elige IVA',
  },
  'PIM.ColorForPos': {
    en: 'Color for POS',
    se: 'Färg för POS',
    es: 'Color para POS',
  },
  'PIM.ColorForPosPlaceholder': {
    en: 'Choose color',
    se: 'Välj färg',
    es: 'Elige color',
  },
  'PIM.HideInCustomerOrdering': {
    en: 'Hide in Customer Ordering flows',
    se: 'Göm i kundbeställningsflöden',
    es: 'Ocultar en flujos de pedidos de clientes',
  },
  'PIM.Order': {
    en: 'Order (higher comes first)',
    se: 'Ordning (högre kommer först)',
    es: 'Orden (más alto viene primero)',
  },
  'PIM.OrderPlaceholder': {
    en: 'Enter order number (min 1)',
    se: 'Ange ordningsnummer (min 1)',
    es: 'Ingrese el número de orden (mínimo 1)',
  },
  'PIM.OrderValidation': {
    en: 'Order number must be greater than or equal to 1',
    se: 'Ordningsnummer måste vara större än eller lika med 1',
    es: 'El número de orden debe ser mayor o igual a 1',
  },
  'PIM.Image': {
    en: 'Image (recommended size: 2160 x 1440 px)',
    se: 'Bild (rekommenderad storlek: 2160 x 1440 px)',
    es: 'Imagen (tamaño recomendado: 2160 x 1440 px)',
  },
  'PIM.CreateCategory': {
    en: 'Create category',
    se: 'Skapa kategori',
    es: 'Crear categoría',
  },
  'PIM.UpdateCategory': {
    en: 'Update category',
    se: 'Uppdatera kategori',
    es: 'Actualizar categoría',
  },
  'PIM.AlreadyCategoryWithName': {
    en: 'There is already a category with the name',
    se: 'Det finns redan en kategori med samma namn',
    es: 'Ya hay una categoría con el nombre',
  },
  'PIM.MessagePlaceholder': {
    en: 'Fill in your message',
    se: 'Fyll i ditt meddelande',
    es: 'Escriba su mensaje',
  },
  'PIM.Venue': {
    en: 'Venue',
    se: 'Butik',
    es: 'Lugar',
  },
  'PIM.VenuePlaceholder': {
    en: 'Choose venue',
    se: 'Välj butik',
    es: 'Elige lugar',
  },
  'PIM.CreateMessage': {
    en: 'Create message',
    se: 'Skapa meddelande',
    es: 'Crear mensaje',
  },
  'PIM.UpdateMessage': {
    en: 'Update message',
    se: 'Uppdatera meddelande',
    es: 'Actualizar mensaje',
  },
  'PIM.Item.RemovableIngredient.Title': {
    en: 'Removable ingredients',
    se: 'Borttagbara ingredienser',
    es: 'Ingredientes removibles',
  },
  'PIM.Item.RemovableIngredient.Desc': {
    en: 'A list of ingredients your customer can choose to remove if they want.',
    se: 'En lista över ingredienser som din kund kan välja att ta bort om de vill.',
    es: 'Una lista de ingredientes que su cliente puede elegir para eliminar si lo desean.',
  },
  'PIM.Item.RemovableIngredient.InputLabel': {
    en: 'Title',
    se: 'Titel',
    es: 'Título',
  },
  'PIM.Item.RemovableIngredient.InputPlaceholder': {
    en: '(e.g "Want to remove something?")',
    se: '(t.ex. "Vill du ta bort något?")',
    es: '(por ejemplo "¿Quieres eliminar algo?")',
  },
  'PIM.Item.ExpandedByDefault': {
    en: 'Expanded by default',
    se: 'Öppnad som standard',
    es: 'Expandido por defecto',
  },
  'PIM.ItemsUsedOnUpsell': {
    en: 'Articles this upsell is used on',
    se: 'Artiklar som denna merförsäljning används på',
    es: 'Artículos en los que se utiliza esta oferta',
  },
  'PIM.Upsell.enableMultiSelect': {
    en: 'Allow customer to choose more than 1 article',
    se: 'Tillåt kunden att välja mer än 1 artikel',
    es: 'Permitir al cliente elegir más de 1 artículo',
  },
  'PIM.UpdateUpsell': {
    en: 'Update upsell',
    se: 'Uppdatera merförsäljning',
    es: 'Actualizar oferta',
  },
  'PIM.CreateUpsell': {
    en: 'Create upsell',
    se: 'Skapa merförsäljning',
    es: 'Crear oferta',
  },
  'PIM.AlreadyUpsellWithName': {
    en: 'There is already an upsell with the name',
    se: 'Det finns redan en merförsäljning med det namnet',
    es: 'Ya hay una oferta con el nombre',
  },
  'PIM.AlreadyMenuWithName': {
    en: 'There is already a menu with the name',
    se: 'Det finns redan en meny med det namnet',
    es: 'Ya hay un menú con el nombre',
  },
  'PIM.CreateIngredientGroup': {
    en: 'Create ingredient group',
    se: 'Skapa ingrediensgrupp',
    es: 'Crear grupo de ingredientes',
  },
  'PIM.UpdateIngredientGroup': {
    en: 'Update ingredient group',
    se: 'Uppdatera ingrediensgrupp',
    es: 'Actualizar grupo de ingredientes',
  },
  'PIM.AlreadyIngredientGroupWithName': {
    en: 'There is already an ingredient group with the name',
    se: 'Det finns redan en ingrediensgrupp med samma namn',
    es: 'Ya hay un grupo de ingredientes con el nombre',
  },
  'PIM.Highlighted': {
    en: 'Highlighted (in kitchen display)',
    se: 'Markerad (i köksdisplay)',
    es: 'Destacado (en pantalla de cocina)',
  },
  'PIM.CreateIngredient': {
    en: 'Create ingredient',
    se: 'Skapa ingrediens',
    es: 'Crear ingrediente',
  },
  'PIM.CreateIngredientHeaderDescription': {
    en: 'Ingredients of an article. Combine them into groups and enable the customer to tweak the item.',
    se: 'Ingredienser av en artikel. Kominera dem till grupper och tillåt kunden att göra sina egna justeringar',
    es: 'Ingredientes de un artículo. Combínalos en grupos y permite al cliente ajustar el artículo.',
  },
  'PIM.UpdateIngredient': {
    en: 'Update ingredient',
    se: 'Uppdatera ingrediens',
    es: 'Actualizar ingrediente',
  },
  'PIM.ImportCompleted': {
    en: 'Import was completed',
    se: 'Importen slutfördes',
    es: 'La importación se completó',
  },
  'PIM.ExportImportTitle': {
    en: 'Import and export articles',
    se: 'Importera och exportera artiklar',
    es: 'Importar y exportar artículos',
  },
  'PIM.ExportImportDescription': {
    en: 'Add and edit several articles and course types',
    se: 'Lägg till och redigera flera artiklar och kurstyper',
    es: 'Añadir y editar varios artículos y tipos de curso',
  },
  'PIM.FileDownload': {
    en: 'File download (.xlsx)',
    se: 'Filnedladdning (.xlsx)',
    es: 'Descarga de archivo (.xlsx)',
  },
  'PIM.FileUpload': {
    en: 'File upload',
    se: 'Filuppladdning',
    es: 'Subir archivo',
  },
  'PIM.FileUploadExcel': {
    en: 'File upload (.xlsx)',
    se: 'Filuppladdning (.xlsx)',
    es: 'Subir archivo (.xlsx)',
  },
  'PIM.AddYourFile': {
    en: 'Add your file',
    se: 'Lägg till din fil',
    es: 'Añade tu archivo',
  },
  'PIM.DropHere': {
    en: 'Drop here',
    se: 'Släpp här',
    es: 'Suelta aquí',
  },
  'PIM.FileToImport': {
    en: 'File to import',
    se: 'Fil att importera',
    es: 'Archivo para importar',
  },
  'PIM.ImportFile': {
    en: 'Import file',
    se: 'Importera fil',
    es: 'Importar archivo',
  },
  'PIM.ExportFile': {
    en: 'Export current file',
    se: 'Exportera aktuell fil',
    es: 'Exportar archivo actual',
  },
  'PIM.ImportErrorTitle': {
    en: 'There are 3 errors in your file',
    se: 'Det finns 3 fel i din fil',
    es: 'Hay 3 errores en tu archivo',
  },
  'PIM.ImportErrorDescription': {
    en: 'Please reupload your file with following corrections to proceed the import:',
    se: 'Ladda upp din fil igen med följande korrigeringar för att fortsätta importen:',
    es: 'Vuelva a cargar su archivo con las siguientes correcciones para continuar con la importación:',
  },
  'PIM.LabelPlaceHolder': {
    en: 'Fill in label here (2 letters)',
    se: 'Fyll i etiketten här (2 tecken)',
    es: 'Rellene la etiqueta aquí (2 letras)',
  },
  'PIM.FullNamePlaceHolder': {
    en: 'Fill in full name here',
    se: 'Skriv fullständiga namn här',
    es: 'Rellene el nombre completo aquí',
  },
  'PIM.AddIngredients': {
    en: 'Add ingredients',
    se: 'Lägg till ingredienser',
    es: 'Añadir ingredientes',
  },
  'PIM.Required': {
    en: 'Required',
    se: 'Obligatorisk',
    es: 'Requerido',
  },
  'PIM.Required.Description': {
    en: 'The customer must choose one of the ingredients',
    se: 'Kunden måste välja en av ingredienserna',
    es: 'El cliente debe elegir uno de los ingredientes',
  },
  'Payouts.LegalBusinessName': {
    en: 'Legal business name',
    se: 'Juridiskt företagsnamn',
    es: 'nombre legal de la empresa',
  },
  'Payouts.FirstName': {
    en: 'First name',
    se: 'Förnamn',
    es: 'Nombre de pila',
  },
  'Payouts.FirstNamePlaceholder': {
    en: 'Fill in your first name',
    se: 'Fyll i ditt förnamn',
    es: 'Rellene su nombre de pila',
  },
  'Payouts.LastName': {
    en: 'Last name',
    se: 'Efternamn',
    es: 'Apellido',
  },
  'Payouts.LastNamePlaceholder': {
    en: 'Fill in your last name',
    se: 'Fyll i ditt efternamn',
    es: 'Rellene su apellido',
  },
  'Payouts.EmailPlaceholder': {
    en: 'Fill in your email',
    se: 'Fyll i din e-post',
    es: 'Rellene su correo electrónico',
  },
  'Payouts.CreatePaymentAccount': {
    en: 'Create payment account',
    se: 'Skapa betalkonto',
    es: 'Crear cuenta de pago',
  },
  'Payouts.CreatePaymentAccountDescription': {
    en: 'Add business information and connect resturant locations to your legal entity.',
    se: 'Lägg till företagsinformation och anslut restauranger till din juridiska person.',
    es: 'Agregue información de su empresa y conecte sus ubicaciones de restaurante a su entidad legal.',
  },
  'Payouts.PaymentAccounts': {
    en: 'Payment accounts',
    se: 'Betalkonton',
    es: 'Cuentas de pago',
  },
  'Payouts.PaymentAccountsDescription': {
    en: 'Activated payment accounts with connected restaurant locations.',
    se: 'Aktiverade betalkonton med anslutna restauranger.',
    es: 'Cuentas de pago activadas con ubicaciones de restaurante conectadas.',
  },
  'Payouts.ConnectedRestaurantLocations': {
    en: 'Connected restaurant locations',
    se: 'Anslutna restauranger',
    es: 'Ubicaciones de restaurante conectadas',
  },
  'Payouts.NoConnectedRestaurantLocations': {
    en: 'No connected restaurant locations',
    se: 'Inga anslutna restauranger',
    es: 'No hay ubicaciones de restaurante conectadas',
  },
  'Payouts.For': {
    en: 'for',
    se: 'för',
    es: 'para',
  },
  'Payouts.ProcessingApplicaiton': {
    en: 'The processing of the applicaiton can take 7-14 workdays from sending in your application.',
    se: 'Behandlingen av ansökan kan ta 7-14 vardagar från dagen din ansökan skickats in.',
    es: 'El procesamiento de la solicitud puede tardar de 7 a 14 días hábiles desde el envío de su solicitud.',
  },
  'Payouts.KycApplication': {
    en: 'KYC application',
    se: 'KYC-ansökan',
    es: 'Solicitud KYC',
  },
  'Payouts.ConfirmedPayouts': {
    en: 'Confirmed payouts',
    se: 'Bekräftade utbetalningar',
    es: 'Pagos confirmados',
  },
  'Payouts.InitiatedPayouts': {
    en: 'Initiated payouts',
    se: 'Startade utbetalningar',
    es: 'Pagos iniciados',
  },
  'Payouts.PayoutsFor': {
    en: 'Payouts for',
    se: 'Utbetalningar för',
    es: 'Pagos para',
  },
  'Payouts.CreatePaymentAccountForLegalEntity': {
    en: 'Create a payment account for your legal entity.',
    se: 'Skapa ett betalkonto för din juridiska entitet.',
    es: 'Cree una cuenta de pago para su entidad legal.',
  },
  'Payouts.ProvideInformationAboutYourBusiness': {
    en: 'You need to provide information about your business, its ownership and conncet restaurant locations to your account.',
    se: 'Du måste ange information om ditt företag, dess ägande och koppla restauranger till ditt konto.',
    es: 'Debe proporcionar información sobre su empresa, su propiedad y conectar ubicaciones de restaurante a su cuenta.',
  },
  'Payouts.SelectDateRange': {
    en: 'Select date range',
    se: 'Välj datumintervall',
    es: 'Seleccionar rango de fechas',
  },
  'PaymentMethods.InternalId': {
    en: 'Internal ID',
    se: 'Internt ID',
    es: 'ID interno',
  },
  'PaymentMethods.PaymentMethods': {
    en: 'Payment methods',
    se: 'Betalningsmetoder',
    es: 'Métodos de pago',
  },
  'PaymentMethods.CreatePaymentMethod': {
    en: 'Create payment method',
    se: 'Skapa betalningsmetod',
    es: 'Crear método de pago',
  },
  'PaymentMethods.SearchForPaymentMethod': {
    en: 'Search for a payment method',
    se: 'Sök efter en betalningsmetod',
    es: 'Buscar un método de pago',
  },
  'PaymentMethods.EditPaymentMethod': {
    en: 'Edit this payment method',
    se: 'Ändra denna betalningsmetoden',
    es: 'Editar este método de pago',
  },
  'PaymentMethods.InternalIdOfAnotherPaymentMethod': {
    en: 'Internal ID of another payment method',
    se: 'Intern identifierare av en annan betalningsmetod',
    es: 'ID interno de otro método de pago',
  },
  'PaymentMethods.ChoosePaymentMethod': {
    en: 'Choose a payment method',
    se: 'Välj en betalningsmetod',
    es: 'Elija un método de pago',
  },
  'PaymentMethods.PaymentMethodExistsInTheList': {
    en: 'The entered payment method exists in the list, please select it from there',
    se: 'Betalningsmetod finns redan i listan, välj den därifrån',
    es: 'El método de pago ingresado existe en la lista, selecciónelo desde allí',
  },
  'PaymentMethods.PaymentMethod': {
    en: 'Payment method',
    se: 'Betalningsmetod',
    es: 'Método de pago',
  },
  'PaymentMethods.SelectPaymentMethod': {
    en: 'Select payment method',
    se: 'Välj betalningsmetod',
    es: 'Seleccionar método de pago',
  },
  'PaymentMethods.Adyen.Name': {
    en: 'Credit card',
    se: 'Kreditkort',
    es: 'Tarjeta de crédito',
  },
  'PaymentMethods.Adyen.Description': {
    en: 'Credit card payments using Adyen (incl. AfP)',
    se: 'Kreditkortsbetalningar med Adyen (inkl. Afp)',
    es: 'Pagos con tarjeta de crédito usando Adyen (incl. AfP)',
  },
  'PaymentMethods.AdyenManual.Name': {
    en: 'Credit Card (Manual)',
    se: 'Kreditkort (Manuell)',
    es: 'Tarjeta de crédito (manual)',
  },
  'PaymentMethods.AdyenManual.Description': {
    en: 'Add this if you are adding Adyen. For manually registering  payments where the connection to the adyen terminal was lost',
    se: 'Lägg till denna ifall du använder Adyen. För manuell registrering av betalningar där uppkopplingen med Adyen-terminalen förlorats',
    es: 'Agregue esto si está agregando Adyen. Para registrar pagos manualmente donde la conexión con el terminal Adyen se perdió',
  },
  'PaymentMethods.Card.Name': {
    en: 'Credit card',
    se: 'Kortbetalning',
    es: 'Pago con tarjeta',
  },
  'PaymentMethods.Cash.Name': {
    en: 'Cash',
    se: 'Kontanter',
    es: 'Efectivo',
  },
  'PaymentMethods.Cash.Description': {
    en: 'Cash',
    se: 'Kontanter',
    es: 'Efectivo',
  },
  'PaymentMethods.Invoice.Name': {
    en: 'Invoice',
    se: 'Faktura',
    es: 'Factura',
  },
  'PaymentMethods.Invoice.Description': {
    en: 'Invoices that use Fortnox customer lists and sends the invoice to Fortnox',
    se: 'Fakturor som använder Fortnox kundlista och skickar fakturan till Fortnox',
    es: 'Facturas que usan listas de clientes de Fortnox y envían la factura a Fortnox',
  },
  'PaymentMethods.ManualInvoice.Name': {
    en: 'Invoice (Local)',
    se: 'Faktura (Lokal)',
    es: 'Factura (Local)',
  },
  'PaymentMethods.ManualInvoice.Description': {
    en: 'Invoices created for customers manually added in Baemingo POS',
    se: 'Fakturor som skapas för kunder som lagts till manuellt i Baemingo POS',
    es: 'Facturas creadas para clientes añadidos manualmente en Baemingo POS',
  },
  'PaymentMethods.Izettle.Name': {
    en: 'Credit card',
    se: 'Kreditkort',
    es: 'Tarjeta de crédito',
  },
  'PaymentMethods.Izettle.Description': {
    en: 'Credit card payments using Zettle',
    se: 'Kreditkortsbetalningar med Zettle',
    es: 'Pagos con tarjeta de crédito usando Zettle',
  },
  'PaymentMethods.Microdeb.Name': {
    en: 'Giftcards',
    se: 'Presentkort',
    es: 'Tarjetas de regalo',
  },
  'PaymentMethods.Microdeb.Description': {
    en: 'Giftcards for customers that use Microdeb',
    se: 'Presentkort för kunder som använder Microdeb',
    es: 'Tarjetas de regalo para clientes que usan Microdeb',
  },
  'PaymentMethods.PrintedInvoice.Name': {
    en: 'Invoice',
    se: 'Faktura',
    es: 'Factura',
  },
  'PaymentMethods.PrintedInvoice.Description': {
    en: 'Invoices that are printed physically in the store',
    se: 'Fakturor som är utskrivna fysiskt i butik',
    es: 'Facturas que se imprimen físicamente en la tienda',
  },
  'PaymentMethods.Swish.Name': {
    en: 'Swish',
    se: 'Swish',
    es: 'Swish',
  },
  'PaymentMethods.Swish.Description': {
    en: 'Swish Business',
    se: 'Swish Företag',
    es: 'Swish Business',
  },
  'PaymentMethods.SwishQr.Name': {
    en: 'Swish',
    se: 'Swish',
    es: 'Swish',
  },
  'PaymentMethods.SwishQr.Description': {
    en: 'Swish Shopping',
    se: 'Swish Handel',
    es: 'Swish Shopping',
  },
  'PaymentMethods.Other.Name': {
    en: 'Other',
    se: 'Annan',
    es: 'Otro',
  },
  'PaymentMethods.Other.Description': {
    en: 'Add a custom payment method',
    se: 'Lägg till en anpassad betalningsmetod',
    es: 'Agregar un método de pago personalizado',
  },
  'Home.SelectAdmin': {
    en: 'Select admin',
    se: 'Välj administratör',
    es: 'Seleccionar administrador',
  },
  'Start.Description': {
    en: 'Get started by accessing the different menu options on your left',
    se: 'Kom igång genom att använda menyalternativen till vänster',
    es: 'Comience accediendo a las diferentes opciones de menú a su izquierda',
  },
  'Start.NewBackofficeTitle': {
    en: 'Switch to our improved backoffice!',
    se: 'Använd vårt nya och förbättrade backoffice!',
    es: '¡Usa nuestro nuevo y mejorado backoffice!',
  },
  'Start.NewBackofficeDescription': {
    en: 'This backoffice is no longer being actively developed. We recommend switching to our new backoffice for the latest features, better performance, and ongoing improvements.',
    se: 'Detta backoffice utvecklas inte längre aktivt. Vi rekommenderar att du byter till vårt nya backoffice för de senaste funktionerna, bättre prestanda och kontinuerliga förbättringar.',
    es: 'Este backoffice ya no está en desarrollo activo. Te recomendamos cambiar a nuestro nuevo backoffice para obtener las últimas funciones, mejor rendimiento y mejoras continuas.',
  },
  'Start.SwitchToQuickoffice': {
    en: 'Use the new backoffice',
    se: 'Använd det nya backoffice',
    es: 'Usar el nuevo backoffice',
  },
  'Start.Campaign': {
    en: 'Campaign',
    se: 'Kampanj',
    es: 'Campaña',
  },
  'Start.AppTitle': {
    en: 'Baemingo Marketing',
    se: 'Baemingo Marketing',
    es: 'Baemingo Marketing',
  },
  'Start.CampaignDescriptionInitial': {
    en: 'Are you ready to sell even more? Upgrade your POS and take your sales to new heights with our latest product!',
    se: 'Är din verksamhet redo att sälja ännu mer? Uppgradera din kassalösning och ta din försäljning till nya höjder med vår senaste produkt!',
    es: '¿Está listo para vender aún más? ¡Actualice su POS y lleve sus ventas a nuevas alturas con nuestro último producto!',
  },
  'Start.AppDescriptionPercentage': {
    en: '',
    se: '',
    es: '',
  },
  'Start.CampaignDescriptionFinal': {
    en: '*The offer is valid until 30/11-23.',
    se: '*Erbjudandet gäller t.o.m. 30/11-23.',
    es: '*La oferta es válida hasta el 30/11-23.',
  },
  'Start.AppDescriptionNoCost': {
    en: 'a free trial.',
    se: 'en gratis provperiod.',
    es: 'una prueba gratuita.',
  },
  'Start.leadCTAClicked': {
    en: 'We will reach out to you',
    se: 'Vi kommer att kontakta dig',
    es: 'Nos pondremos en contacto con usted',
  },
  'Start.leadCTA': {
    en: 'I want to know more',
    se: 'Jag vill veta mer',
    es: 'Quiero saber más',
  },
  'Start.leadError': {
    en: 'Error registering your interest. Reach out to your Baemingo representative.',
    se: 'Fel vid registrering av ditt intresse. Kontakta din Baemingo-representant.',
    es: 'Error al registrar su interés. Póngase en contacto con su representante de Baemingo.',
  },
  'Onbording.TryThisSteps': {
    en: 'Try these steps to get started',
    se: 'Prova dessa steg för att komma igång',
    es: 'Pruebe estos pasos para comenzar',
  },
  'Onbording.ActivatePayments': {
    en: 'Activate payments',
    se: 'Aktivera betalningar',
    es: 'Activar pagos',
  },
  'Onbording.ActivatePaymentsDescriptionFirst': {
    en: 'Set up your payment accounts for your legal entity or entities, to start receiving payments at once.',
    se: 'Ställ in dina betalningskonton för dina juridiska enheter för att börja ta emot betalningar på en gång.',
    es: 'Configure sus cuentas de pago para su entidad legal o entidades, para comenzar a recibir pagos de inmediato.',
  },
  'Onbording.ActivatePaymentsDescriptionSecond': {
    en: 'When your account is activated, you can apply for the KYC - to get payout directly to your bank account.',
    se: 'När ditt konto är aktiverat kan du ansöka om KYC för att få utbetalning direkt till ditt bankkonto.',
    es: 'Cuando su cuenta esté activada, puede solicitar el KYC para recibir pagos directamente en su cuenta bancaria.',
  },
  'Onbording.PaymentsActivated': {
    en: 'Payments activated',
    se: 'Betalningar aktiverade',
    es: 'Pagos activados',
  },
  'Onbording.PaymentsActivatedDescriptionFirst': {
    en: 'Your payments have been activated successfully!',
    se: 'Dina betalningar har aktiverats!',
    es: '¡Sus pagos se han activado con éxito!',
  },
  'Onbording.PaymentsActivatedDescriptionSecond': {
    en: 'You can apply for the KYC to get payouts directly to your bank account.',
    se: 'Du kan ansöka om KYC för att få utbetalningar direkt till ditt bankkonto.',
    es: 'Puede solicitar el KYC para recibir pagos directamente en su cuenta bancaria.',
  },
  'Onbording.ActivatePayouts': {
    en: 'Activate payouts',
    se: 'Aktivera utbetalningar',
    es: 'Activar pagos',
  },
  'Onbording.ActivatePayoutsDescription': {
    en: 'Send in your KYC application. Once approved, payouts will be sent directly to your account.',
    se: 'Skicka in din KYC-ansökan. När de har godkänts kommer utbetalningar att skickas direkt till ditt konto.',
    es: 'Envíe su solicitud de KYC. Una vez aprobado, los pagos se enviarán directamente a su cuenta.',
  },
  'Onbording.ApplicationReceived': {
    en: 'Application received',
    se: 'Ansökan mottagen',
    es: 'Solicitud recibida',
  },
  'Onbording.ApplicationReceivedDescription': {
    en: 'Your application is being processed. The processing can take 7-14 workdays.',
    se: 'Din ansökan behandlas. Handläggningen kan ta 7-14 arbetsdagar.',
    es: 'Su solicitud está siendo procesada. El procesamiento puede tardar 7-14 días hábiles.',
  },
  'Onbording.ApplicationInvalid': {
    en: 'Application invalid',
    se: 'Ansökan är ogiltig',
    es: 'Solicitud no válida',
  },
  'Onbording.ApplicationInvalidDescription': {
    en: 'Please double-check to make sure all data is correct.',
    se: 'Vänligen dubbelkolla att uppgifter är korrekta.',
    es: 'Revise nuevamente para asegurarse de que todos los datos sean correctos.',
  },
  'Onbording.ApplicationDenied': {
    en: 'Application denied',
    se: 'Ansökan avslogs',
    es: 'Solicitud denegada',
  },
  'Onbording.ApplicationDeniedDescription': {
    en: 'Please contact support for more information.',
    se: 'Kontakta supporten för mer information.',
    es: 'Comuníquese con el soporte para obtener más información.',
  },
  'Onbording.PayoutsActivated': {
    en: 'Payouts activated',
    se: 'Utbetalningar aktiverade',
    es: 'Pagos activados',
  },
  'Onbording.PayoutsActivatedDescription': {
    en: 'Your KYC application was approved and your payouts are now actived.',
    se: 'Din KYC-ansökan godkändes och dina utbetalningar är nu aktiva.',
    es: 'Su solicitud de KYC fue aprobada y sus pagos ahora están activados.',
  },
  'Onbording.AddProducts': {
    en: 'Add products',
    se: 'Lägg till produkter',
    es: 'Agregar productos',
  },
  'Onbording.AddProductsDescription': {
    en: 'Add products you want to offer your customers, one by one, or import all at once.',
    se: 'Lägg till produkter du vill erbjuda dina kunder, en efter en, eller importera alla på en gång.',
    es: 'Agregue productos que desee ofrecer a sus clientes, uno a la vez o importe todos a la vez.',
  },
  'Onbording.ProductsAdded': {
    en: 'Products added',
    se: 'Produkter tillagda',
    es: 'Productos agregados',
  },
  'Onbording.ProductsAddedDescription': {
    en: 'When you have added the products you want to offer continue with create your menu.',
    se: 'När du har lagt till de produkter du vill erbjuda fortsätt med att skapa din meny.',
    es: 'Cuando haya agregado los productos que desea ofrecer, continúe creando su menú.',
  },
  'Onbording.AddMenus': {
    en: 'Add menus',
    se: 'Lägg till menyer',
    es: 'Agregar menús',
  },
  'Onbording.AddMenusDescription': {
    en: 'Create a menu and add the selection of products you want to offer.',
    se: 'Skapa en meny och lägg till det urval av produkter du vill erbjuda.',
    es: 'Crea un menú y añade la selección de productos que quieras ofrecer',
  },
  'Onbording.MenusAdded': {
    en: 'Menus added',
    se: 'Menyer har lagts till',
    es: 'Menús agregados',
  },
  'Onbording.MenusAddedDescription': {
    en: 'Your menus are saved! Activate your menus on your restaurant locations to start receiving orders.',
    se: 'Dina menyer är sparade! Aktivera dina menyer på dina restaurang för att börja ta emot beställningar.',
    es: '¡Tus menús están guardados! Active sus menús en sus ubicaciones de restaurante para comenzar a recibir pedidos.',
  },
  'Onbording.ActivateVenues': {
    en: 'Activate venues',
    se: 'Aktivera butiker',
    es: 'Activar ubicaciones',
  },
  'Onbording.ActivateVenuesDescription': {
    en: 'Activate your online menu for your restaurant locations, to start receving orders from  your customers.',
    se: 'Aktivera din onlinemeny för dina restauranger för att börja ta emot beställningar från dina kunder.',
    es: 'Active su menú en línea para sus ubicaciones de restaurante para comenzar a recibir pedidos de sus clientes.',
  },
  'Onbording.VenuesActivated': {
    en: 'Venues activated',
    se: 'Butiker aktiverade',
    es: 'Ubicaciones activadas',
  },
  'Onbording.VenuesActivatedDescription': {
    en: 'Your restaurant locations have been activated! This concludes the onboarding process!',
    se: 'Dina restauranger har aktiverats! Detta avslutar introduktionsprocessen!',
    es: '¡Sus ubicaciones de restaurante han sido activadas! ¡Este proceso de incorporación ha concluido!',
  },
  'Onbording.GoToPayouts': {
    en: 'Go to payouts',
    se: 'Gå till utbetalningar',
    es: 'Ir a pagos',
  },
  'Onbording.ActivateRestaurantLocation': {
    en: 'Activate restaurant location',
    se: 'Aktivera restaurangen',
    es: 'Activar ubicación de restaurante',
  },
  'Integrations.Title': {
    en: 'Integrations',
    se: 'Integrationer',
    es: 'Integraciones',
  },
  'Integrations.Personalkollen.RemoveSuccess': {
    en: 'Successfully removed personalkollen integrationen for the venue',
    se: 'Personalkollen-integrationen har tagits bort för butiken',
    es: 'Se eliminó correctamente la integración de personalkollen para la ubicación',
  },
  'Integrations.Personalkollen.RemoveFailed': {
    en: 'Failed to remove the venue. Please try again later',
    se: 'Misslyckades med att ta bort butiken. Vänligen försök igen senare',
    es: 'Error al eliminar la ubicación. Por favor, inténtelo de nuevo más tarde',
  },
  'Integrations.Personalkollen.SaveFailed': {
    en: 'Failed to save venue. Please try again later',
    se: 'Misslyckades med att spara butik. Vänligen försök igen senare',
    es: 'Error al guardar la ubicación. Por favor, inténtelo de nuevo más tarde',
  },
  'Integrations.Personalkollen.SaveSuccess': {
    en: 'Saved successfully',
    se: 'Dina uppdateringar har sparats',
    es: 'Guardado con éxito',
  },
  'Integrations.Personalkollen.AddTip': {
    en: 'Add Tip',
    se: 'Aktivera dricks',
    es: 'Activar propina',
  },
  'Integrations.Personalkollen.AddVenue': {
    en: 'Add Venue',
    se: 'Lägg till butik',
    es: 'Agregar tienda',
  },
  'Integrations.Subtitle': {
    en: 'You can activate integrations here',
    se: 'Här kan du aktivera dina integrationer',
    es: 'Puede activar las integraciones aquí',
  },
  'IntegrationForm.CreateNew': {
    en: 'Create new',
    se: 'Skapa ny',
    es: 'Crear nuevo',
  },
  'IntegrationForm.IntegrationConfigs': {
    en: 'Integration configs',
    se: 'Integrationskonfigurationer',
    es: 'Configuraciones de integración',
  },
  'IntegrationForm.Edit': {
    en: 'Edit this config',
    se: 'Ändra denna konfiguration',
    es: 'Editar esta configuración',
  },
  'IntegrationForm.Deactivate': {
    en: 'Deactivate config',
    se: 'Inaktivera konfiguration',
    es: 'Desactivar configuración',
  },
  'IntegrationForm.ShowHistory': {
    en: 'Show change history',
    se: 'Visa ändringshistorik',
    es: 'Mostrar historial de cambios',
  },
  'IntegrationForm.Search': {
    en: 'Search config',
    se: 'Sök konfiguration',
    es: 'Buscar configuración',
  },
  'IntegrationForm.CreateNewConfig': {
    en: 'Create new config',
    se: 'Skapa ny konfiguration',
    es: 'Crear nueva configuración',
  },
  'IntegrationForm.NamePlaceholder': {
    en: 'Set a name for the config',
    se: 'Välj ett namn för konfigurationen',
    es: 'Establecer un nombre para la configuración',
  },
  'IntegrationForm.ChangeLogModal': {
    en: 'Changes',
    se: 'Ändringar',
    es: 'Cambios',
  },
  'IntegrationForm.Accounts': {
    en: 'Accounts',
    se: 'Konton',
    es: 'Cuentas',
  },
  'IntegrationForm.Provider': {
    en: 'Provider',
    se: 'Leverantör',
    es: 'Proveedor',
  },
  'IntegrationForm.Name': {
    en: 'Name',
    se: 'Namn',
    es: 'Nombre',
  },
  'IntegrationForm.Venues': {
    en: 'Active for venues',
    se: 'Aktiv för restauranger',
    es: 'Activo para ubicaciones',
  },
  'IntegrationForm.ApiKey': {
    en: 'API Key',
    se: 'API Nyckel',
    es: 'Clave API',
  },
  'IntegrationForm.RecipientEmail': {
    en: 'Recipient Email',
    se: 'Mottagarens e-postadress',
    es: 'Correo electrónico del destinatario',
  },
  'IntegrationForm.CostCenter': {
    en: 'Cost center',
    se: 'Kostnadscenter',
    es: 'Centro de costos',
  },
  'IntegrationForm.EOD': {
    en: 'End of day time',
    se: 'Tid för dagsavslut',
    es: 'Hora de cierre del día',
  },
  'IntegrationForm.VoucherSeries': {
    en: 'Voucher Series',
    se: 'Verifikationsserie',
    es: 'Serie de comprobantes',
  },
  'IntegrationForm.VoucherText': {
    en: 'Voucher Text',
    se: 'Verifikations text',
    es: 'Texto de comprobante',
  },
  'IntegrationForm.InvoicesConfig': {
    en: 'Invoices Config',
    se: 'Fakturerings konfiguration',
    es: 'Configuración de facturas',
  },
  'IntegrationForm.MonthlyVoucher': {
    en: 'A monthly "summary" voucher of all daily vouchers will be sent',
    se: 'En månatlig "sammanfattnings" verifikation av alla dagliga verifikationer kommer att skickas',
    es: 'Se enviará un comprobante "resumen" mensual de todos los comprobantes diarios',
  },
  'IntegrationForm.AccountNumber': {
    en: 'Account number',
    se: 'Kontonummer',
    es: 'Número de cuenta',
  },
  'IntegrationForm.VAT': {
    en: 'VAT',
    se: 'Moms',
    es: 'IVA',
  },
  'IntegrationForm.Payment': {
    en: 'Payment Methods',
    se: 'Betalmetoder',
    es: 'Métodos de pago',
  },
  'IntegrationForm.Tip': {
    en: 'Tip',
    se: 'Dricks',
    es: 'Propina',
  },
  'IntegrationForm.Expenses': {
    en: 'Expenses',
    se: 'Utgifter',
    es: 'Gastos',
  },
  'IntegrationForm.Categories': {
    en: 'Categories',
    se: 'Kategorier',
    es: 'Categorías',
  },
  'IntegrationForm.Fortnox.ActivationPrompt.Title': {
    en: 'Activate fortnox integration',
    se: 'Aktivera fortnox integrationen',
    es: 'Activar integración de fortnox',
  },
  'IntegrationForm.Fortnox.ActivationPrompt.Text_1': {
    en: 'Press the button to generate Activation URL. After the URL has been generated, copy and paste it into another tab and follow the steps to finish the activation.',
    se: 'Tryck på knappen för att generera en aktiveringslänk. Efter länken har generats, kopiera och klistra in den i en ny flik och följ stegen för att slutföra aktiveringen.',
    es: 'Presione el botón para generar la URL de activación. Después de que se haya generado la URL, copie y pegue en otra pestaña y siga los pasos para completar la activación.',
  },
  'IntegrationForm.Fortnox.ActivationPrompt.Text_2': {
    en: 'Copy the URL provided below and paste it into a new tab. Follow the steps to finish the activation.',
    se: 'Kopiera länken nedan och klistra in den i en ny flik. Följ sedan stegen för att slutföra aktiveringen.',
    es: 'Copie la URL proporcionada a continuación y péguela en una nueva pestaña. Siga los pasos para completar la activación.',
  },
  'IntegrationForm.ActivateConfig': {
    en: 'Activate config',
    se: 'Aktivera konfiguration',
    es: 'Activar configuración',
  },
  'IntegrationForm.ActivateConfigAndVenues': {
    en: 'Activate config and venues',
    se: 'Aktivera konfiguration och restauranger',
    es: 'Activar configuración y ubicaciones',
  },
  'IntegrationForm.ErrorFetchingData': {
    en: 'Error fetching data.',
    se: 'Error fetching data.',
    es: 'Error al obtener datos.',
  },
  'IntegrationForm.OverrideConfigs': {
    en: 'Override configs for this venue',
    se: 'Skriv över konfigurationer för denna restaurang',
    es: 'Sobrescribir configuraciones para este lugar',
  },
  'IntegrationForm.ConfigWasOverridden': {
    en: 'Config was successfully overridden',
    se: 'Konfigurationen överskriven',
    es: 'Configuración sobrescrita',
  },
  'IntegrationForm.DeactivateVenue': {
    en: 'Deactivate venue',
    se: 'Avaktivera restaurang',
    es: 'Desactivar ubicación',
  },
  'IntegrationForm.ActivateVenue': {
    en: 'Activate venue',
    se: 'Aktivera restaurang',
    es: 'Activar ubicación',
  },
  'IntegrationForm.SendPDF': {
    en: 'Send PDF',
    se: 'Skicka PDF',
    es: 'Enviar PDF',
  },
  'IntegrationForm.AdditionalInvoiceInfo': {
    en: 'Additional Invoice Info',
    se: 'Ytterligare Fakturainformation',
    es: 'Información adicional de la factura',
  },
  'General.Change': {
    en: 'Change',
    se: 'Ändra',
    es: 'Cambiar',
  },
  'Reports.SalesReport': {
    en: 'Sales report',
    se: 'Försäljningsrapport',
    es: 'Reporte de ventas',
  },
  'Reports.NumberOfOrders': {
    en: 'Number of orders',
    se: 'Antal ordrar',
    es: 'Numero de ordenes',
  },
  'General.Sum': {
    en: 'Sum',
    se: 'Summa',
    es: 'Suma',
  },
  'Reports.TotalDiscounts': {
    en: 'Total discounts',
    se: 'Summa rabatter',
    es: 'Descuentos totales',
  },
  'Reports.TotalRepurchases': {
    en: 'Total repurchases during the period',
    se: 'Summa returer under perioden',
    es: 'Recompras totales durante el período',
  },
  'Reports.Qty': {
    en: 'Qty',
    se: 'Antal',
    es: 'Cantidad',
  },
  'Reports.Gross': {
    en: 'Gross',
    se: 'Brutto',
    es: 'Bruto',
  },
  'Reports.Net': {
    en: 'Net',
    se: 'Netto',
    es: 'Neto',
  },
  'Reports.Vat': {
    en: 'VAT',
    se: 'MOMS',
    es: 'IVA',
  },
  'Reports.NetSalles': {
    en: 'Net sales',
    se: 'Nettoförsäljning',
    es: 'Las ventas netas',
  },
  'Reports.GrossSales': {
    en: 'Gross sales after refunds',
    se: 'Bruttoförsäljning efter återköp',
    es: 'Ventas brutas después de reembolsos',
  },
  'Reports.TotalPayout': {
    en: 'Total payout for the period',
    se: 'Summa periodens utbetalning',
    es: 'Pago total del período',
  },
  'Reports.RefundHistory': {
    en: 'Refund history',
    se: 'Återbetalningshistorik',
    es: 'Historial de reembolsos',
  },
  'Reports.RefundHistory.RefundDate': {
    en: 'Refund date',
    se: 'Datum för återbetalning',
    es: 'Fecha de reembolso',
  },
  'Reports.RefundHistory.OrderDate': {
    en: 'Order date',
    se: 'Orderdatum',
    es: 'Fecha de pedido',
  },
  'Reports.RefundHistory.Staff': {
    en: 'Staff',
    se: 'Personal',
    es: 'Personal',
  },
  'Reports.RefundHistory.Amount': {
    en: 'Amount',
    se: 'Belopp',
    es: 'Cantidad',
  },
  'IntegrationForm.ConfigWasAdded': {
    en: 'Config was added',
    se: 'Konfiguration har lagts till',
    es: 'Se agregó la configuración',
  },
  'IntegrationForm.ConfigWasUpdated': {
    en: 'Config was updated',
    se: 'Konfigurationen har uppdaterats',
    es: 'La configuración fue actualizada',
  },
  'IntegrationForm.VenueWasAssigned': {
    en: 'venue was assigned',
    se: 'butik tilldelades',
    es: 'se asignó el lugar',
  },
  'IntegrationForm.VenueConfigValueWasOverridden': {
    en: 'venue config value was overridden',
    se: 'butik konfigurations värdet åsidosattes',
    es: 'el valor de configuración del lugar fue anulado',
  },
  'IntegrationForm.VenueAccountNumberWasOverridden': {
    en: 'venue account number was overridden',
    se: 'butik kontonummer värdet åsidosattes',
    es: 'se anuló el número de cuenta del lugar',
  },
  'IntegrationForm.AccountNumberWasChanged': {
    en: 'Account number was changed',
    se: 'Kontonummer har ändrats',
    es: 'Se cambió el número de cuenta',
  },
  'IntegrationForm.ConfigWasActivated': {
    en: 'Config was activated',
    se: 'Konfigurationen har aktiverats',
    es: 'La configuración fue activada',
  },
  'IntegrationForm.ConfigWasDeactivated': {
    en: 'Config was deactivated',
    se: 'Konfigurationen har inaktiverat',
    es: 'La configuración fue desactivada',
  },
  'IntegrationForm.VenueWasActivated': {
    en: 'venue was activated',
    se: 'butik har aktiverats',
    es: 'el lugar fue activado',
  },
  'IntegrationForm.VenueWasDeactivated': {
    en: 'venue was deactivated',
    se: 'butik har inaktiverat',
    es: 'el lugar fue desactivado',
  },
  'IntegrationForm.AccountProvider': {
    en: 'Account Provider',
    se: 'Kontoleverantör',
    es: 'Proveedor de cuenta',
  },
  'IntegrationForm.ConfigName': {
    en: 'Config Name',
    se: 'Konfigurationsnamn',
    es: 'Nombre de configuración',
  },
  'IntegrationForm.FieldValue': {
    en: 'field value',
    se: 'fältvärde',
    es: 'valor de campo',
  },
  'IntegrationForm.ForThe': {
    en: 'for the',
    se: 'för',
    es: 'para el',
  },
  'IntegrationForm.WasOverridden': {
    en: 'was overridden',
    se: 'blev överskriven',
    es: 'fue anulado',
  },
  'IntegrationForm.WasChanged': {
    en: 'was changed',
    se: 'ändrades',
    es: 'fue cambiado',
  },
  'IntegrationForm.From': {
    en: 'from',
    se: 'från',
    es: 'de',
  },
  'IntegrationForm.WasRemovedFromTheListOfPaymentMethods': {
    en: 'was removed from the list of payment methods',
    se: 'togs bort från listan över betalningsmetoder',
    es: 'fue eliminado de la lista de métodos de pago',
  },
  'General.To': {
    en: 'to',
    se: 'till',
    es: 'a',
  },
  'General.Was': {
    en: 'was',
    se: 'var',
    es: 'era',
  },
  'General.Done': {
    en: 'Done',
    se: 'Klar',
    es: 'Hecho',
  },
  'General.Ingredients': {
    en: 'Ingredients',
    se: 'Ingredienser',
    es: 'Ingredientes',
  },
  'General.Express': {
    en: 'Express',
    se: 'Expresskassa',
    es: 'Expresar',
  },
  'General.Engagement': {
    en: 'Engagement',
    se: 'Engagemang',
    es: 'Compromiso',
  },
  'General.Quantity': {
    en: 'Quantity',
    se: 'Antal',
    es: 'Cantidad',
  },
  'General.Downloading': {
    en: 'Downloading...',
    se: 'Laddar ner...',
    es: 'Descargando...',
  },
  'General.DownloadReport': {
    en: 'Download Report',
    se: 'Ladda ner rapport',
    es: 'Descargar Informe',
  },
  'General.AlreadyIngredientWithName': {
    en: 'There is already an ingredient with the name',
    se: 'Det finns redan en ingrediens med samma namn',
    es: 'Ya hay un ingrediente con el nombre',
  },
  'Dashboard.NoData': {
    en: 'No data...',
    se: 'Ingen data...',
    es: 'Sin datos...',
  },
  'General.ClearImage': {
    en: 'Clear image',
    se: 'Rensa bild',
    es: 'Borrar imagen',
  },
  'General.Currency': {
    en: 'Currency',
    se: 'Valuta',
    es: 'Moneda',
  },
  'General.NoTitle': {
    en: 'No title',
    se: 'Ingen titel',
    es: 'Sin título',
  },
  'General.More': {
    en: 'more...',
    se: 'mer...',
    es: 'más...',
  },
  'General.WasCreated': {
    en: 'was created',
    se: 'skapades',
    es: 'fue creado',
  },
  'General.WasUpdated': {
    en: 'was updated',
    se: 'uppdaterades',
    es: 'fue actualizado',
  },
  'General.Online': {
    en: 'Online',
    se: 'Online',
    es: 'Online',
  },
  'General.SelfService': {
    en: 'Self-service',
    se: 'Självbetjäning',
    es: 'Autoservicio',
  },
  'Engagement.OfferOptional': {
    en: 'Offer (optional)',
    se: 'Erbjudande (valfri)',
    es: 'Oferta (opcional)',
  },
  'Engagement.ContentNewsletter': {
    en: 'Content/Newsletter',
    se: 'Innehåll/Nyhetsbrev',
    es: 'Contenido/Boletin informativo',
  },
  'Engagement.ContentNewsletterOptional': {
    en: 'Content/Newsletter (optional)',
    se: 'Innehåll/Nyhetsbrev (valfri)',
    es: 'Contenido/Boletin informativo (opcional)',
  },
  'Reports.SelectMonth': {
    en: 'Select a month',
    se: 'Välj en månad',
    es: 'Selecciona un mes',
  },
  'Segments.AddFilter': {
    en: 'add filter',
    se: 'lägg till filter',
    es: 'añadir filtro',
  },
  'Segments.Preview': {
    en: 'Preview',
    se: 'Förhandsvisa',
    es: 'Avance',
  },
  'Segments.Loading': {
    en: 'LOADING!',
    se: 'LADDAR!',
    es: 'CARGANDO!',
  },
  'Segments.NoPreviewLoaded': {
    en: 'NO PREVIEW LOADED',
    se: 'INGEN FÖRHANDSGIVNING LADDAD',
    es: 'SIN VISTA PREVIA CARGADA',
  },
  'Segments.CreatedMonthsAgo': {
    en: 'Created 3 months ago',
    se: 'Skapad för 3 månader sedan',
    es: 'Creado hace 3 meses',
  },
  'Segments.NoUsersInSegment': {
    en: 'No users in segment',
    se: 'Inga användare i segmentet',
    es: 'No hay usuarios en el segmento',
  },
  'Segments.NumberOfUsersInSegment': {
    en: 'Number of users in segment',
    se: 'Antal användare i segmentet',
    es: 'Número de usuarios en segmento',
  },
  'Segments.PercentOfAllUsersInSegment': {
    en: '% of all users in segment',
    se: '% av alla användare i segmentet',
    es: '% de todos los usuarios en segmento',
  },
  'Segments.TotalSpendOfSegment': {
    en: 'Total spend of segment',
    se: 'Totala utgifter för segmentet',
    es: 'Gasto total del segmento',
  },
  'Segments.AverageOrderSpend': {
    en: 'Average order spend',
    se: 'Genomsnittlig orderutgift',
    es: 'Gasto medio de pedido',
  },
  'Segments.TopTenUsersByTotalSpend': {
    en: 'Top 10 users by total spend',
    se: 'Topp 10 användare efter totala utgifter',
    es: 'Los 10 mejores usuarios por gasto total',
  },
  'Segments.TopTenUsersByAverageSpend': {
    en: 'Top 10 users by average spend',
    se: 'Topp 10 användare efter genomsnittliga utgifter',
    es: 'Los 10 mejores usuarios por gasto promedio',
  },
  'Monitoring.Pending': {
    en: 'Pending',
    se: 'Väntande',
    es: 'Pendiente',
  },
  'Staff.CreateAdminUser': {
    en: 'Create Admin User',
    se: 'Skapa Adminanvändare',
    es: 'Crear Usuario Administrador',
  },
  'Staff.OrderManagerVenues': {
    en: 'Order Manager Venues',
    se: 'Order Manager Butiker',
    es: 'Lugares de Order Manager',
  },
  'Staff.BackOfficeAdmin': {
    en: 'Back-Office Admin',
    se: 'Back-Office Admin',
    es: 'Administrador de Back-office',
  },
  'Staff.SuperAdmin': {
    en: 'Super admin',
    se: 'Super Admin',
    es: 'Superadministrador',
  },
  'Ingredients.SearchForItem': {
    en: 'Search for an item',
    se: 'Sök efter en artikel',
    es: 'Buscar un artículo',
  },
  'Ingredients.ExistingItemIngredients': {
    en: 'Existing item ingredients',
    se: 'Befintliga ingredienser',
    es: 'Ingredientes de elementos existentes',
  },
  'Ingredients.AddNewIngredientFor': {
    en: 'Add a new ingredient for',
    se: 'Lägg till en ny ingrediens för',
    es: 'Añadir un nuevo ingrediente para',
  },
  'Ingredients.ChangeQuantityFrom': {
    en: 'for this item. Do you want to change the quantity from',
    se: 'för denna artikel. Vill du ändra mängden från',
    es: 'para este artículo. ¿Quieres cambiar la cantidad de',
  },
  'Ingredients.ChangedOn': {
    en: 'changed on',
    se: 'ändrat på',
    es: 'cambiado en',
  },
  'Ingredients.AddedTo': {
    en: 'added to',
    se: 'tillagd på',
    es: 'añadido a',
  },
  'Ingredients.WasRemovedFrom': {
    en: 'was removed from',
    se: 'togs bort från',
    es: 'fue eliminado de',
  },
  'General.PIMLegacy': {
    en: 'PIM legacy',
    se: 'PIM legacy',
    es: 'PIM legacy',
  },
  'General.PleaseWait': {
    en: 'Please wait...',
    se: 'Vänligen vänta...',
    es: 'Espere por favor...',
  },
  'General.Report': {
    en: 'Report',
    se: 'Rapport',
    es: 'Informe',
  },
  'General.Summary': {
    en: 'Report',
    se: 'Sammanfattning',
    es: 'Resumen',
  },
  'General.Fees': {
    en: 'Fees',
    se: 'Avgifter',
    es: 'Honorarios',
  },
  'General.TheFieldIsMandatory': {
    en: 'The field is mandatory',
    se: 'Fältet är obligatoriskt',
    es: 'El campo es obligatorio',
  },
  'General.Latest': {
    en: 'Latest',
    se: 'Senaste',
    es: 'Último',
  },
  'General.Oldest': {
    en: 'Oldest',
    se: 'Äldsta',
    es: 'Más antiguo',
  },
  'PIM.ForSelfServiceAndAppUsers': {
    en: 'For Self service and app users',
    se: 'För självbetjänings- och appanvändare',
    es: 'Para usuarios de aplicaciones y autoservicio',
  },
  'PIM.ImageLibrary': {
    en: 'Image library',
    se: 'Bildbibliotek',
    es: 'Biblioteca de imágenes',
  },
  'PIM.SizeRecommendations': {
    en: 'Size recommendations 2160 x 1440 px',
    se: 'Storleksrekommendationer 2160 x 1440 px',
    es: 'Recomendaciones de tamaño 2160 x 1440 px',
  },
  'PIM.SearchFor': {
    en: 'Search for …',
    se: 'Sök efter …',
    es: 'Buscar …',
  },
  'PIM.Sort': {
    en: 'Sort:',
    se: 'Sortera:',
    es: 'Clasificar:',
  },
  'PIM.Alphabetical': {
    en: 'Alphabetical',
    se: 'Alfabetisk',
    es: 'Alfabética',
  },
  'PIM.InsertImage': {
    en: 'Insert image',
    se: 'Infoga bild',
    es: 'Insertar imagen',
  },
  'PIM.AddMenuEntries': {
    en: 'Add menu entries',
    se: 'Lägg till menyposter',
    es: 'Añadir entradas de menú',
  },
  'PIM.AddAll': {
    en: 'Add all',
    se: 'Lägg till alla',
    es: 'Añadir todo',
  },
  'PIM.CloseSideModalConfirmation': {
    en: 'Are you sure you want to close? changes you might have made will not be saved.',
    se: 'Är du säker på att du vill stänga? ändringar du kan ha gjort kommer inte att sparas.',
    es: '¿Estás seguro de que quieres cerrar? los cambios que haya realizado no se guardarán.',
  },
  'PIM.UpsellGroupArticles': {
    en: 'Upsell group articles',
    se: 'Merförsäljnings-grupp artiklar',
    es: 'Artículos del grupo de venta adicional',
  },
  'PIM.ArticleName': {
    en: 'Article name',
    se: 'Artikelnamn',
    es: 'Nombre del artículo',
  },
  'PIM.Courses': {
    en: 'Courses',
    se: 'Rätt-typer',
    es: 'Cursos',
  },
  'PIM.Course': {
    en: 'Course',
    se: 'Rätt-typ',
    es: 'Curso',
  },
  'PIM.NewCourse': {
    en: 'New course',
    se: 'Ny rätt-typ',
    es: 'Nuevo curso',
  },
  'PIM.CourseType': {
    en: 'Course type',
    se: 'Rätt-typ',
    es: 'Tipo de curso',
  },
  'PIM.UnitType': {
    en: 'Unit type',
    se: 'Enhetstyp',
    es: 'Tipo de unidad',
  },
  'PIM.SelectDefaultOrderStatus': {
    en: 'Select default order status',
    se: 'Välj standardorderstatus',
    es: 'Seleccione el estado del pedido predeterminado',
  },
  'PIM.AllowCustomPricing': {
    en: 'Allow custom pricing (Point of Sale)',
    se: 'Tillåt anpassad prissättning (Point of Sale)',
    es: 'Permitir precios personalizados (Point of Sale)',
  },
  'PIM.NoMembershipDiscount': {
    en: 'No membership discount',
    se: 'Ingen medlemsrabatt',
    es: 'Sin descuento de membresía',
  },
  'PIM.ArticleDescription': {
    en: 'Article description',
    se: 'Artikelbeskrivning',
    es: 'Descripción del articulo',
  },
  'PIM.ArticleNewVariationsActive.Desc': {
    en: 'The old variation system has been disabled. Please visit baemingo.com to edit something related to variations.',
    se: 'Det gamla variationssystemet har inaktiverats. Besök baemingo.com för att redigera något som är relaterat till variationer.',
    es: 'El antiguo sistema de variaciones ha sido deshabilitado. Visite baemingo.com para editar algo relacionado con las variaciones.',
  },
  'PIM.ItemsIncludedInThisMenu': {
    en: 'Items included in this menu',
    se: 'Artiklar som ingår i denna meny',
    es: 'Artículos incluidos en este menú',
  },
  'PIM.Instant': {
    en: 'Instant',
    se: 'Omedelbar',
    es: 'Instantánea',
  },
  'PIM.AsItem': {
    en: 'As item',
    se: 'Som artikel',
    es: 'Como artículo',
  },
  'PIM.CreateVariationGroups': {
    en: 'Create Variation Group',
    se: 'Skapa variationsgrupp',
    es: 'Crear grupos de variaciones',
  },
  'POS.PosLayouts': {
    en: 'POS layouts',
    se: 'POS layouter',
    es: 'Diseños de POS',
  },
  'POS.CurrentButtonName': {
    en: 'Current button name',
    se: 'Aktuellt knappnamn',
    es: 'Nombre del botón actual',
  },
  'Onbording.Status.TODO': {
    en: 'TODO',
    se: 'ATT GÖRA',
    es: 'HACER',
  },
  'Onbording.Status.PENDING': {
    en: 'PENDING',
    se: 'VÄNTANDE',
    es: 'PENDIENTE',
  },
  'Onbording.Status.INVALID_DATA': {
    en: 'INVALID DATA',
    se: 'OGILTIGA DATA',
    es: 'DATOS INVÁLIDOS',
  },
  'Onbording.Status.FAILED': {
    en: 'FAILED',
    se: 'MISLYCKADES',
    es: 'FALLIDA',
  },
  'Onbording.Status.PASSED': {
    en: 'PASSED',
    se: 'PASSERAD',
    es: 'APROBADO',
  },
  'Onbording.Status.completed': {
    en: 'COMPLETED',
    se: 'AVSLUTAD',
    es: 'TERMINADA',
  },
  'Reports.SelectReportContent': {
    en: 'Select report content',
    se: 'Välj rapportinnehåll',
    es: 'Seleccione el contenido del informe',
  },
  'Reports.PayoutReport': {
    en: 'Payout report',
    se: 'Utbetalningsrapport',
    es: 'Informe de pagos',
  },
  'Reports.InventoryReport': {
    en: 'Inventory report',
    se: 'Inventeringsrapport',
    es: 'Informe de inventario',
  },
  'Reports.InStore': {
    en: 'In-store',
    se: 'I lager',
    es: 'En el almacén',
  },
  'Reports.ThirdParty': {
    en: 'Third party (Deliverect)',
    se: 'Tredje part (Deliverect)',
    es: 'Tercero (Deliverect)',
  },
  'Reports.IncludeItems': {
    en: 'Include Items',
    se: 'Inkludera Artiklar',
    es: 'Incluir Artículos',
  },
  'Reports.PayoutsToInclude': {
    en: 'Payouts to Include',
    se: 'Utbetalningar att inkludera',
    es: 'Pagos a incluir',
  },
  'Reports.GeneratedReports': {
    en: 'Generated Reports',
    se: 'Genererade rapporter',
    es: 'Informes generados',
  },
  'Reports.AllGeneratedReports': {
    en: 'All generated reports',
    se: 'Alla genererade rapporter',
    es: 'Todos los informes generados',
  },
  'Reports.AllReports': {
    en: 'All Reports',
    se: 'Alla rapporter',
    es: 'Todos los informes',
  },
  'Reports.AllDevices': {
    en: 'All Devices',
    se: 'Alla enheter',
    es: 'Todos los dispositivos',
  },
  'Reports.SALES': {
    en: 'Sales',
    se: 'Försäljning',
    es: 'Ventas',
  },
  'Reports.PAYOUTS': {
    en: 'Transaction Fee',
    se: 'Transaktionsavgift',
    es: 'Tarifa de transacción',
  },
  'Reports.INVENTORY': {
    en: 'Inventory',
    se: 'Lager',
    es: 'Inventario',
  },
  'Reports.Creating': {
    en: 'Creating...',
    se: 'Skapar...',
    es: 'Creando...',
  },
  'Reports.ItemsIncluded': {
    en: 'Items Included',
    se: 'Artiklar Inkluderade',
    es: 'Artículos Incluidos',
  },
  'Reports.ContentsOfTheSelectedReport': {
    en: 'Contents of the selected report',
    se: 'Innehållet i den valda rapporten',
    es: 'Contenido del informe seleccionado',
  },
  'Reports.ExportToExcel': {
    en: 'Export to Excel',
    se: 'Exportera till Excel',
    es: 'Exportar a Excel',
  },
  'Reports.ReportDeleted': {
    en: 'Successfully deleted the report',
    se: 'Rapport borttagen',
    es: 'El informe ha sido eliminado',
  },
  'Reports.FailedDeleteReport': {
    en: 'Unable to delete report',
    se: 'Kunde inte ta bort rapport',
    es: 'No se puede eliminar el informe',
  },
  'Reports.DeleteReport': {
    en: 'Delete report',
    se: 'Ta bort rapport',
    es: 'Eliminar informe',
  },
  'Reports.DownloadPdf': {
    en: 'Download PDF',
    se: 'Ladda ner PDF',
    es: 'Descargar PDF',
  },
  'Reports.TotalPaidOut': {
    en: 'Total paid out',
    se: 'Totalt utbetalt',
    es: 'Total pagado',
  },
  'Reports.ReceiptCopies': {
    en: 'Receipt copies',
    se: 'Kvittokopior',
    es: 'Copias de recibos',
  },
  'Companies.DefaultLanguageMustBeIncluded': {
    en: 'The default language must be included in the selection',
    se: 'Standardspråket måste inkluderas i urvalet',
    es: 'El idioma predeterminado debe incluirse en la selección.',
  },
  'Integration.IntegrationConfigs': {
    en: 'Integration configs',
    se: 'Integrationskonfigurationer',
    es: 'Configuraciones de integración',
  },
  'Integration.AccountsDataWasUpdated': {
    en: 'Accounts data was successfully updated',
    se: 'Kontodata har uppdaterats',
    es: 'Los datos de las cuentas se actualizó correctamente',
  },
  'IntegrationForm.DeletedCategories': {
    en: 'Deleted Categories',
    se: 'Borttagna Kategorier',
    es: 'Categorías Eliminadas',
  },
  'PIM.LegacyVariationGroups': {
    en: 'Legacy variation groups',
    se: 'Äldre variationsgrupper',
    es: 'Grupos de variantes legados',
  },
  'IntegrationForm.Activate': {
    en: 'Activate',
    se: 'Aktivera',
    es: 'Activar',
  },
  'IntegrationForm.UnsavedChangesWarning': {
    en: 'Warning: Save the configuration changes before activating integration, if you want them to apply.',
    se: 'Varning: Spara konfigurationsändringarna innan du aktiverar integrationen, om du vill att de ska gälla.',
    es: 'Advertencia: Guarde los cambios de configuración antes de activar la integración, si desea que se apliquen.',
  },
  'General.TryAgain': {
    en: 'Try again',
    se: 'Försök igen',
    es: 'Intentar otra vez',
  },
  'Dashboard.FailedToLoadReportData': {
    en: 'Failed to load report data. Try again',
    se: 'Det gick inte att läsa in rapportdata. Försök igen',
    es: 'No se pudieron cargar los datos del informe. Intentar otra vez',
  },
  'IntegrationForm.GenericVoucherSeries': {
    en: 'Generic Voucher Series',
    se: 'Generisk kupongserie',
    es: 'Serie de comprobantes genéricos',
  },
  'Accounting.IsSupplementary': {
    en: 'Is Supplementary Voucher',
    se: 'Är en kompletterande verifikation',
    es: 'Es un voucher adicional',
  },
  'Accounting.WarningMessage': {
    en: 'You must filter either by status or company or both',
    se: 'Du måste filtrera efter antingen status eller företag eller båda',
    es: 'Debe filtrar por estado o empresa o ambos',
  },
  'Accounting.Invoices': {
    en: 'Invoices',
    se: 'Fakturor',
    es: 'Facturas',
  },
  'Accounting.InvoiceResent': {
    en: 'Invoice successfully resent',
    se: 'Faktura har skickats om',
    es: 'Factura reenviado con éxito',
  },
  'Accounting.InvoiceId': {
    en: 'Invoice ID',
    se: 'Faktura ID',
    es: 'ID de factura',
  },
  'PIM.SetUpIntegrationAccountNumbers': {
    en: 'Now you can set up account numbers of integrations for the category',
    se: 'Nu kan du ställa in kontonummer för integrationer för kategorin',
    es: 'Ahora puede configurar números de cuenta de integraciones para la categoría',
  },
  'IntegrationForm.AdyenPayoutSeries': {
    en: 'Adyen Payout Series',
    se: 'Adyen utbetalningsserie',
    es: 'Serie de pagos de Adyen',
  },
  'General.TotalQuantity': {
    en: 'Total Quantity',
    se: 'Total Antal',
    es: 'Cantidad Total',
  },
  'GiftCards.GiftCardsData': {
    en: 'Gift cards data',
    se: 'Presentkortsdata',
    es: 'Datos de tarjetas de regalo',
  },
  'Accounting.Regular': {
    en: 'Regular',
    se: 'Vanlig',
    es: 'Regular',
  },
  'Accounting.Generic': {
    en: 'Generic',
    se: 'Generisk',
    es: 'Genérico',
  },
  'Accounting.VoucherType': {
    en: 'Voucher Type',
    se: 'Verifikationstyp',
    es: 'Tipo de cupón',
  },
  'Generic.Yes': {
    en: 'Yes',
    se: 'Ja',
    es: 'Sí',
  },
  'Generic.No': {
    en: 'No',
    se: 'Nej',
    es: 'No',
  },
  'PromoCodes.SearchPlaceholder': {
    en: 'Search by code',
    se: 'Sök efter kod',
    es: 'Buscar por código',
  },
  'PromoCodes.RequiresUser': {
    en: 'Only for logged in users',
    se: 'Endast för inloggade användare',
    es: 'Solo para usuarios registrados',
  },
  'PromoCodes.PromoCode': {
    en: 'Promo code',
    se: 'Rabattkod',
    es: 'Código promocional',
  },
  'PromoCodes.ENTitle': {
    en: 'English Title',
    se: 'Engelsk titel',
    es: 'Título en inglés',
  },
  'PromoCodes.SETitle': {
    en: 'Swedish/intl title',
    se: 'Svensk/intl titel',
    es: 'Título sueco/internacional',
  },
  'PromoCodes.ESTitle': {
    en: 'Spanish Title',
    se: 'Spansk titel',
    es: 'Título español',
  },
  'PromoCodes.DiscountType': {
    en: 'Discount Type',
    se: 'Rabatt typ',
    es: 'Tipo de descuento',
  },
  'PromoCodes.DiscountRate': {
    en: 'Discount rate',
    se: 'Rabattsats',
    es: 'Tasa de descuento',
  },
  'PromoCodes.TimeActiveFrom': {
    en: 'Active from (Hour)',
    se: 'Aktiv från (Klockslag)',
    es: 'Tiempo activo desde',
  },
  'PromoCodes.TimeActiveTo': {
    en: 'Active until',
    se: 'Aktiv till (Klockslag)',
    es: 'Tiempo activo para',
  },
  'PromoCodes.MaxTotalUses': {
    en: 'Max total uses',
    se: 'Max antal användningar',
    es: 'Usos totales máximos',
  },
  'PromoCodes.ActivatesAt': {
    en: 'Activates at',
    se: 'Startdatum',
    es: 'Se activa en',
  },
  'PromoCodes.ExpiresAt': {
    en: 'Expires at',
    se: 'Utgångsdatum',
    es: 'Expira en',
  },
  'PromoCodes.ClearDates': {
    en: 'Clear dates',
    se: 'Rensa datum',
    es: 'Borrar fechas',
  },
  'PromoCodes.SelectedDatesError': {
    en: 'The activation date and time must be before the expiration date and time',
    se: 'Aktiveringsdatumet och -tiden måste vara före utgångsdatumet och tiden',
    es: 'La fecha y hora de activación deben ser anteriores a la fecha y hora de vencimiento.',
  },
  'Accounting.GenericType': {
    en: 'Generic Type',
    se: 'Generisk typ',
    es: 'Tipo genérico',
  },
  'Accounting.Payout': {
    en: 'Payout',
    se: 'Utbetalning',
    es: 'Pagar',
  },
  'General.SplitConfigs': {
    en: 'Split Configs',
    se: 'Splitkonfiguration',
    es: 'Configuraciones divididas',
  },
  'General.SplitConfigsDescripion': {
    en: 'Split Configs set up the fee structure for payments with Adyen. For each payment that is done, it will determine the applicable fee (amex, commercial, debit, foreign, credit) that should be paid to Baemingo for handling the transaction.',
    se: 'Splitkonfigurationer ställer in avgiftsstrukturen för betalningar med Adyen. För varje betalning som görs kommer den att fastställa den tillämpliga avgiften (amex, kommersiell, debet, utländsk, kredit) som ska betalas till Baemingo för att hantera transaktionen.',
    es: 'Las configuraciones divididas configuran la estructura de tarifas para los pagos con Adyen. Por cada pago que se realice, determinará la tarifa aplicable (amex, comercial, débito, extranjero, crédito) que se deberá pagar a Baemingo por el manejo de la transacción.',
  },
  'General.PaymentType': {
    en: 'Payment Type',
    se: 'Betalningstyp',
    es: 'Tipo de pago',
  },
  'Adyen.SplitConfigs.amex': {
    en: 'The card is issued by Amex',
    se: 'Kortet är utfärdat av Amex',
    es: 'La tarjeta es emitida por Amex',
  },
  'Adyen.SplitConfigs.commercial': {
    en: 'The card is a business or commercial card, determined by looking at the payment method received by Adyen.',
    se: 'Kortet är ett affärs- eller kommersiellt kort, bestämt genom att titta på betalningsmetoden som Adyen tagit emot.',
    es: 'La tarjeta es una tarjeta de negocios o comercial, determinada al observar el método de pago recibido por Adyen.',
  },
  'Adyen.SplitConfigs.debit': {
    en: 'Card is debit',
    se: 'Kortet är debet',
    es: 'La tarjeta es debito',
  },
  'Adyen.SplitConfigs.credit': {
    en: 'Card payment method is Credit',
    se: 'Kortbetalningsmetoden är Kredit',
    es: 'El método de pago con tarjeta es Crédito',
  },
  'Adyen.SplitConfigs.foreign': {
    en: "Card issuer country is different from the account holder's country",
    se: 'Kortutfärdarens land skiljer sig från account holderns land',
    es: 'El país emisor de la tarjeta es diferente del país del titular de la cuenta',
  },
  'Reports.ZReportsDescription': {
    en: 'Summary of financial activities for a specific day, including total sales, net flow, VAT and payment types for the Swedish tax authorities.',
    se: 'En sammanfattning av finansiell aktivitet för en viss dag, inklusive total försäljning, nettoflöde, moms och betalningstyper för de svenska skattemyndigheterna.',
    es: 'Un resumen de la actividad financiera de un día determinado, incluidas las ventas totales, el flujo neto, el IVA y los tipos de pago para las autoridades fiscales suecas.',
  },
  'Reports.FortnoxReportDescription': {
    en: 'Sales data that was sent to Fortnox.',
    se: 'Försäljningsdata som skickades till Fortnox.',
    es: 'Datos de ventas que se enviaron a Fortnox.',
  },
  'Reports.GiftCardSales': {
    en: 'Gift card sales',
    se: 'Presentkortsförsäljning',
    es: 'Ventas de tarjetas de regalo',
  },
  'IntegrationForm.NotAddedPaymentMethods': {
    en: 'Not added default payment methods',
    se: 'Inte tillagda standardbetalningsmetoder',
    es: 'Métodos de pago predeterminados no agregados',
  },
  'IntegrationForm.RemovePaymentMethod': {
    en: 'Are you sure you want to remove the payment method?',
    se: 'Är du säker på att du vill ta bort betalningsmetoden?',
    es: '¿Está seguro de que desea eliminar el método de pago?',
  },
  'Accounting.CustomerId': {
    en: 'Customer Id',
    se: 'Kundnummer',
    es: 'Identificación del cliente',
  },
  'Accounting.CustomerOrgNumber': {
    en: 'Customer org. number',
    se: 'Kundens org.nummer',
    es: 'El número de la organización del cliente',
  },
  'Accounting.CustomerName': {
    en: 'Customer name',
    se: 'Kundens namn',
    es: 'Nombre del cliente',
  },
  'Reports.TransactionFeeReportDateRangeError': {
    en: 'Transaction fee reports can cover max. 1 month in duration',
    se: 'Transaktionsrapporter får max täcka ett intervall på en månad',
    es: 'Los informes de tarifas de transacción pueden cubrir un máx. 1 mes de duración',
  },
  'PIM.SelectSize': {
    en: 'Select size',
    se: 'Välj storlek',
    es: 'Selecciona el tamaño',
  },
  'PIM.ChooseExtraIngredients': {
    en: 'Choose extra ingredients',
    se: 'Välj extra ingredienser',
    es: 'Elige ingredientes adicionales',
  },
  'PIM.SizeTextExample': {
    en: 'Eg. "Choose your burger size"',
    se: 'Ex. "Välj burgarstorlek"',
    es: 'Ej. "Elige el tamaño de tu hamburguesa"',
  },
  'Accounting.GStock': {
    en: 'GStock',
    se: 'GStock',
    es: 'GStock',
  },
  'Accounting.CreateGstockConfiguration': {
    en: 'Create a GStock configuration',
    se: 'Skapa en GStock-konfiguration',
    es: 'Create a GStock configuration',
  },
  'Accounting.EditGstockConfiguration': {
    en: 'Edit a GStock configuration',
    se: 'Redigera en GStock-konfiguration',
    es: 'Editar una configuración de GStock',
  },
  'Accounting.ClientId': {
    en: 'Client Id',
    se: 'Identificación del cliente',
    es: 'Klient ID',
  },
  'Accounting.ClientSecret': {
    en: 'Client Secret',
    se: 'Klienthemlighet',
    es: 'Secreto del cliente',
  },
  'Accounting.UserCenterId': {
    en: 'User Center Id',
    se: 'Användarcenter-id',
    es: 'ID del centro de usuario',
  },
  'Accounting.TheVenueAlreadyHasCredentials': {
    en: 'The venue already has credentials in another GStock config',
    se: 'Butik har redan autentiseringsuppgifter i en annan GStock-konfiguration',
    es: 'El lugar ya tiene credenciales en otra configuración de GStock',
  },
  'General.SignupCodes': {
    en: 'Signup codes',
    se: 'Registreringskoder',
    es: 'Códigos de registro',
  },
  'SignupCodes.CreateSignupCode': {
    en: 'Create signup code',
    se: 'Skapa registreringskod',
    es: 'Crear código de registro',
  },
  'IntegrationForm.DeleteConfig': {
    en: 'Delete config',
    se: 'Ta bort config',
    es: 'Eliminar configuración',
  },
  'IntegrationForm.ConfigWasRemoved': {
    en: 'Config was removed',
    se: 'Config togs bort',
    es: 'Se eliminó la configuración',
  },
  'POS.ArticlesBelowTheLine': {
    en: 'Articles below this will enable scrolling',
    se: 'Artiklar nedan kommer att möjliggöra rullning',
    es: 'Los artículos debajo de este permitirán el desplazamiento',
  },
  'PromoCodes.DuplicateCodeNameError': {
    en: 'A promo code with the same name already exists for the same venue(s)',
    se: 'En rabattkod med samma namn finns redan för samma butik(er)',
    es: 'Ya existe un código promocional con el mismo nombre para los mismos lugar(es)',
  },
  'Segments.Filter.AccountAge.Name': {
    en: 'Account age',
    se: 'Kontoålder',
    es: 'Edad de la cuenta',
  },
  'Segments.Filter.AccountAge.Description': {
    en: 'Filter by orders made by users with a certain account age',
    se: 'Filtrera efter beställningar gjorda av användare med en viss kontoålder',
    es: 'Filtrar por pedidos realizados por usuarios con una determinada antigüedad de cuenta',
  },
  'Segments.Filter.DiscountAmount.Name': {
    en: 'Discount amount',
    se: 'Rabattbelopp',
    es: 'Importe de descuento',
  },
  'Segments.Filter.DiscountAmount.Description': {
    en: 'Filter by sum of discounts',
    se: 'Filtrera efter summan av rabatter',
    es: 'Filtrar por suma de descuentos',
  },
  'Segments.Filter.HasEmail.Name': {
    en: 'User has email',
    se: 'Användaren har e-post',
    es: 'El usuario tiene correo electrónico',
  },
  'Segments.Filter.HasEmail.Description': {
    en: 'Filter by orders made by users with an email',
    se: 'Filtrera efter beställningar gjorda av användare med e-post',
    es: 'Filtrar por pedidos realizados por usuarios con un correo electrónico',
  },
  'Segments.Filter.OrderAmount.Name': {
    en: 'Order amount',
    se: 'Beställningssumma',
    es: 'Total de la orden',
  },
  'Segments.Filter.OrderAmount.Description': {
    en: 'Filter by sum of orders',
    se: 'Filtrera efter summan av beställningar',
    es: 'Filtrar por suma de pedidos',
  },
  'Segments.Filter.SpecificCategory.Name': {
    en: 'Specific category',
    se: 'Specifik kategori',
    es: 'Categoría específica',
  },
  'Segments.Filter.SpecificCategory.Description': {
    en: 'Filter by orders in a specific category',
    se: 'Filtrera efter beställningar i en specifik kategori',
    es: 'Filtrar por pedidos en una categoría específica',
  },
  'Segments.Filter.SpecificItem.Name': {
    en: 'Specific item',
    se: 'Specifik artikel',
    es: 'Artículo específico',
  },
  'Segments.Filter.SpecificItem.Description': {
    en: 'Users which have bought a specific item and optionally for how much',
    se: 'Användare som har köpt en specifik vara och valfritt för hur mycket',
    es: 'Usuarios que han comprado un artículo específico y opcionalmente por cuánto',
  },
  'Segments.Filter.SpecificMembership.Name': {
    en: 'Membership level',
    se: 'Medlemsnivå',
    es: 'Nivel de membresía',
  },
  'Segments.Filter.SpecificMembership.Description': {
    en: 'Filter by users that have a specific membership level',
    se: 'Filtrera efter användare som har en specifik medlemsnivå',
    es: 'Filtrar por usuarios que tienen un nivel de membresía específico',
  },
  'Segments.Filter.SpecificOffer.Name': {
    en: 'Specific offer',
    se: 'Specifikt erbjudande',
    es: 'Oferta específica',
  },
  'Segments.Filter.SpecificOffer.Description': {
    en: 'Filter by orders using a specific offer',
    se: 'Filtrera efter beställningar med ett specifikt erbjudande',
    es: 'Filtrar por pedidos usando una oferta específica',
  },
  'Segments.Filter.SpecificVenue.Name': {
    en: 'Specific venue',
    se: 'Specifik plats',
    es: 'Lugar específico',
  },
  'Segments.Filter.SpecificVenue.Description': {
    en: 'Filter by orders in a specific venue',
    se: 'Filtrera efter beställningar på en specifik plats',
    es: 'Filtrar por pedidos en un lugar específico',
  },
  'Segments.NotImplemented': {
    en: 'Not implemented',
    se: 'Ej implementerad',
    es: 'No se ha implementado',
  },
  'General.DeletedCategory': {
    en: 'Deleted category',
    se: 'Borttagna kategori',
    es: 'Categoría eliminada',
  },
  'Reports.SalesReportDescription': {
    en: 'Summary of financial activity for a given period, including total sales, net flow, VAT, and payment types.',
    se: 'Sammanfattning av finansiell aktivitet för en given period, inklusive total försäljning, nettoflöde, moms och betalningstyper.',
    es: 'Resumen de la actividad financiera para un período determinado, incluidas las ventas totales, el flujo neto, el IVA y los tipos de pago.',
  },
  'Reports.SalesReportMultipleVenues': {
    en: 'Sales report (multiple venues)',
    se: 'Försäljningsrapport (flera butiker)',
    es: 'Reporte de ventas (múltiples lugares)',
  },
  'Reports.SalesReportMultipleVenuesDescription': {
    en: 'Summary of financial activity for a given period, including total sales, net flow, VAT, and payment types for multiple venues.',
    se: 'Sammanfattning av finansiell aktivitet för en given period, inklusive total försäljning, nettoflöde, moms och betalningstyper för flera butiker.',
    es: 'Resumen de la actividad financiera para un período determinado, incluidas las ventas totales, el flujo neto, el IVA y los tipos de pago para múltiples lugares.',
  },
  'Reports.TransactionFee': {
    en: 'Transaction Fee',
    se: 'Transaktionsavgift',
    es: 'Tarifa de transacción',
  },
  'Reports.TransactionFeeReport': {
    en: 'Transaction Fee Report',
    se: 'Transaktionsrapporter',
    es: 'Informe de tarifas de transacción',
  },
  'Reports.TransactionFeeReportDescription': {
    en: 'Summary of revenue, refunds, fees, and payouts as well as a daily breakdown for all transactions made in the credit card terminal.',
    se: 'Sammanfattning av intäkter, återbetalningar, avgifter och utbetalningar samt en daglig uppdelning av alla transaktioner gjorda i kreditkortsterminalen.',
    es: 'Resumen de ingresos, reembolsos, tarifas y pagos, así como un desglose diario de todas las transacciones realizadas en la terminal de tarjetas de crédito.',
  },
  'Dashboard.AmountAfterDiscounts': {
    en: 'Amount after discounts',
    se: 'Belopp efter rabatter',
    es: 'Importe después de descuentos',
  },
  'Dashboard.DiscountTotal': {
    en: 'Discount total',
    se: 'Rabatt totalt',
    es: 'Descuento total',
  },
  'Dashboard.ManualDiscount': {
    en: 'Manual discount',
    se: 'Manuell rabatt',
    es: 'Descuento manual',
  },
  'Dashboard.DiscountInformation': {
    en: 'Discount information only available for App/Web/QR orders. In-store coming soon.',
    se: 'Rabattinformation är endast tillgänglig för App/Web/QR-beställningar. I butik kommer snart.',
    es: 'La información de descuento solo está disponible para pedidos de aplicación/web/QR. Próximamente en la tienda.',
  },
  'OrderStatus.Title': {
    en: 'Order status',
    se: 'Orderstatus',
    es: 'Estado del pedido',
  },
  'OrderStatus.All': {
    en: 'All',
    se: 'Alla',
    es: 'Todos',
  },
  'OrderStatus.Rejected': {
    en: 'Rejected',
    se: 'Avvisad',
    es: 'Rechazado',
  },
  'OrderStatus.Refunded': {
    en: 'Refunded',
    se: 'Återbetalad',
    es: 'Reembolsado',
  },
  'OrderStatus.Cancelled': {
    en: 'Cancelled',
    se: 'Avbruten',
    es: 'Cancelado',
  },
  'OrderStatus.Pending': {
    en: 'Pending',
    se: 'Väntande',
    es: 'Pendiente',
  },
  'OrderStatus.Ready': {
    en: 'Ready',
    se: 'Klar',
    es: 'Listo',
  },
  'OrderStatus.Completed': {
    en: 'Completed',
    se: 'Slutförd',
    es: 'Completado',
  },
  'OrderStatus.Accepted': {
    en: 'Accepted',
    se: 'Accepterad',
    es: 'Aceptado',
  },
  'OrderStatus.Delivering': {
    en: 'Delivering',
    se: 'Levererar',
    es: 'Entregando',
  },
  'OrderStatus.Finalizing': {
    en: 'Finalizing',
    se: 'Slutför',
    es: 'Finalizando',
  },
  'OrderStatus.Scheduled': {
    en: 'Scheduled',
    se: 'Schemalagd',
    es: 'Programado',
  },
  'OrderStatus.Filter.Info': {
    en: 'Info: Refunded does not show partial refunds',
    se: 'Info: Återbetalad visar inte delåterbetalningar',
    es: 'Info: Reembolsado no muestra reembolsos parciales',
  },
  'MenuSelect.POS': {
    en: 'Point of Sale',
    se: 'Point of Sale',
    es: 'Punto de venta',
  },
  'MenuSelect.TSR': {
    en: 'Table service',
    se: 'Bordservering',
    es: 'Servicio de mesa',
  },
  'MenuSelect.TakeAway': {
    en: 'App & Self service kiosk - Take away',
    se: 'App & Expresskassa - Ta med',
    es: 'Aplicación y quiosco de autoservicio - Para llevar',
  },
  'MenuSelect.EatHere': {
    en: 'App & Self service kiosk - Eat here',
    se: 'App & Expresskassa - Äta här',
    es: 'Aplicación y quiosco de autoservicio - Comer aquí',
  },
  'MenuSelect.Delivery': {
    en: 'Delivery',
    se: 'Leverans',
    es: 'Entrega',
  },
  'MenuSelect.InstantBuy': {
    en: 'Instant buy',
    se: 'Direktköp',
    es: 'Compra instantánea',
  },
  'MenuSelect.EnterManually': {
    en: 'Enter timeslots manually',
    se: 'Ange tider manuellt',
    es: 'Ingresar tiempos manualmente',
  },
  'MenuSelect.Generate': {
    en: 'Generate',
    se: 'Generera',
    es: 'Generar',
  },
  'MenuSelect.Generating': {
    en: 'Generating...',
    se: 'Genererar...',
    es: 'Generando...',
  },
  'MenuSelect.Generating.Message': {
    en: 'Can take up to a minute, be patient',
    se: 'Kan ta upp till en minut, var vänlig vänta',
    es: 'Puede tardar hasta un minuto, tenga paciencia',
  },
  'MenuSelect.ExampleAiText': {
    en: 'Example: Lunch menu (your menu name) 11-14, rest of the day All articles. Only All articles on weekends.',
    se: 'Exempel: Lunchmeny (ditt menynamn) 11-14, resten av dagen Alla artiklar. Endast Alla artiklar på helger.',
    es: 'Ejemplo: Menú de Almuerzo (nombre de tu menú) 11-14, resto del día Todos los artículos. Solo Todos los artículos los fines de semana.',
  },
  'MenuSelect.YourMenus': {
    en: 'Your menus',
    se: 'Dina menyer',
    es: 'Tus menús',
  },
  'MenuSelect.GeneratingError': {
    en: 'AI generation failed, try again or use the manual editor',
    se: 'Genereringen misslyckades, försök igen eller använd den manuella redigeraren',
    es: 'La generación de IA falló, inténtelo de nuevo o use el editor manual',
  },
  'MenuSelect.GeneratingSuccess': {
    en: '',
    se: '',
    es: '',
  },
  'MenuSelect.SaveSuccess': {
    en: 'Menu saved successfully',
    se: 'Meny sparad',
    es: 'Menú guardado con éxito',
  },
  'MenuSelect.ActivateTimeControlledMenus.Toggle': {
    en: 'Activate time controlled menus',
    se: 'Aktivera tidsstyrda menyer',
    es: 'Activar menús controlados por tiempo',
  },
  'MenuSelect.TimeControlled.Error': {
    en: 'Something went wrong, try again',
    se: 'Något gick fel, försök igen',
    es: 'Algo salió mal, inténtalo de nuevo',
  },
  'MenuSelect.WeekDay.Short.MONDAY': {
    en: 'Mon',
    se: 'Mån',
    es: 'Lun',
  },
  'MenuSelect.WeekDay.Short.TUESDAY': {
    en: 'Tue',
    se: 'Tis',
    es: 'Mar',
  },
  'MenuSelect.WeekDay.Short.WEDNESDAY': {
    en: 'Wed',
    se: 'Ons',
    es: 'Mié',
  },
  'MenuSelect.WeekDay.Short.THURSDAY': {
    en: 'Thu',
    se: 'Tor',
    es: 'Jue',
  },
  'MenuSelect.WeekDay.Short.FRIDAY': {
    en: 'Fri',
    se: 'Fre',
    es: 'Vie',
  },
  'MenuSelect.WeekDay.Short.SATURDAY': {
    en: 'Sat',
    se: 'Lör',
    es: 'Sáb',
  },
  'MenuSelect.WeekDay.Short.SUNDAY': {
    en: 'Sun',
    se: 'Sön',
    es: 'Dom',
  },
  'MenuSelect.UnknownMenu': {
    en: 'Unknown menu',
    se: 'Okänd meny',
    es: 'Menú desconocido',
  },
  'MenuSelect.TimeControlled.Start': {
    en: 'Start',
    se: 'Start',
    es: 'Comienzo',
  },
  'MenuSelect.TimeControlled.End': {
    en: 'End',
    se: 'Slut',
    es: 'Fin',
  },
  'MenuSelect.TimeControlled.Menu': {
    en: 'Menu',
    se: 'Meny',
    es: 'Menú',
  },
  'MenuSelect.TimeControlled.Error.Time': {
    en: 'The end time must be after start time and before 5am',
    se: 'Sluttiden måste vara efter starttiden samt före kl 05:00',
    es: 'La hora de finalización debe ser posterior a la hora de inicio y antes de las 5 a.m.',
  },
  'MenuSelect.TimeControlled.Error.Overlap': {
    en: 'There are overlapping times, please adjust them',
    se: 'Det finns överlappande tider som behöver justeras',
    es: 'Hay horarios superpuestos, por favor ajustarlos.',
  },
  'MenuSelect.TimeControlled.AddTimeslot': {
    en: 'Add another time slot',
    se: 'Lägg till fler',
    es: 'Agregar otro intervalo de tiempo',
  },
  'MenuSelect.TimeControlled.Save': {
    en: 'Save',
    se: 'Spara',
    es: 'Guardar',
  },
  'MenuSelect.TimeControlled.Saving': {
    en: 'Saving...',
    se: 'Sparar...',
    es: 'Guardando…',
  },
  'MenuSelect.TimeControlled.Save.Success': {
    en: 'Saved successfully',
    se: 'Sparad',
    es: 'Guardado con éxito',
  },
  'MenuSelect.Select': {
    en: 'Select menu',
    se: 'Välj meny',
    es: 'Seleccionar menú',
  },
  'MenuSelect.TimeControlled.Copy': {
    en: 'Copy this setup',
    se: 'Kopiera inställningar',
    es: 'Copiar esta configuración',
  },
  'MenuSelect.TimeControlled.Copied': {
    en: 'Copied!',
    se: 'Kopierad!',
    es: '¡Copiado!',
  },
  'MenuSelect.TimeControlled.UseCopy': {
    en: 'Use copied setup',
    se: 'Använd kopierade inställningar',
    es: 'Usar configuración copiada',
  },
  'MenuSelect.TimeControlled.Default': {
    en: 'Default menu - This menu will show in between your special menus',
    se: 'Standardmeny - Denna meny visas mellan dina specialmenyer',
    es: 'Menú predeterminado - Este menú se mostrará entre tus menús especiales',
  },
  'Licenses.Title': {
    en: 'Licenses',
    se: 'Licenser',
    es: 'Licencias',
  },
  'Licenses.PaymentPrompt.Title': {
    en: 'Payment prompts',
    se: 'Betalningspåminnelser',
    es: 'Recordatorios de pago',
  },
  'Licenses.PaymentPrompt.CurrentStatus': {
    en: 'Payment prompts',
    se: 'Betalningspåminnelser',
    es: 'Recordatorios de pago',
  },
  'Licenses.PaymentPrompt.CurrentStatus.Activated': {
    en: 'Activated',
    se: 'Aktiverat',
    es: 'Activado',
  },
  'Licenses.PaymentPrompt.CurrentStatus.Deactivated': {
    en: 'Deactivated',
    se: 'Inaktiverat',
    es: 'Desactivado',
  },
  'Licenses.PaymentPrompt.Warning': {
    en: 'Warning: Activating this will prompt the user to contact Baemingo regarding unpaid invoices on POS start.',
    se: 'Varning: Aktivering av detta kommer att visa en påminnelse för användaren att kontakta Baemingo angående obetalda fakturor vid POS-start.',
    es: 'Advertencia: Activar esto mostrará un recordatorio al usuario para que se ponga en contacto con Baemingo con respecto a las facturas impagas al iniciar el POS.',
  },
  'Licenses.AllLicenses': {
    en: 'All licenses',
    se: 'Alla licenser',
    es: 'Todas las licencias',
  },
  'Licenses.CreateLicense': {
    en: 'All licenses',
    se: 'Alla licenser',
    es: 'Todas las licencias',
  },
  'CloudPrinters.Title': {
    en: 'Cloud printers',
    se: 'Molnskrivare',
    es: 'Impresoras en la nube',
  },
  'CloudPrinters.Subtitle': {
    en: "Here you'll see a list of onboarded printers that are currently unassigned and ready to be assigned to a venue",
    se: 'Här ser du en lista över ombordtagna skrivare som för närvarande inte är tilldelade och redo att tilldelas en plats',
    es: 'Aquí verás una lista de impresoras embarcadas que actualmente no están asignadas y listas para ser asignadas a un lugar',
  },
  'CloudPrinters.Search': {
    en: 'Search for printer by id...',
    se: 'Sök efter skrivare med id...',
    es: 'Buscar impresora por id...',
  },
  'CloudPrinters.Table.LastSeen': {
    en: 'Last seen',
    se: 'Senast sedd',
    es: 'Visto por última vez',
  },
  'CloudPrinters.Table.Status': {
    en: 'Status',
    se: 'Status',
    es: 'Estado',
  },
  'CloudPrinters.Modal.Title': {
    en: 'Assign cloud printer to venue',
    se: 'Tilldela molnskrivare till plats',
    es: 'Asignar impresora en la nube a un lugar',
  },
  'CloudPrinters.Modal.Subtitle': {
    en: 'Name the printer and select a venue to assign it to',
    se: 'Namnge skrivaren och välj en butik att tilldela den till',
    es: 'Nombre de la impresora y seleccione un lugar para asignarla',
  },
  'CloudPrinters.Error.SomethingWentWrong': {
    en: 'Something went wrong',
    se: 'Något gick fel',
    es: 'Algo salió mal',
  },
  'CloudPrinters.Input.Name': {
    en: 'Name this printer',
    se: 'Namnge denna skrivare',
    es: 'Nombre de esta impresora',
  },
  'CloudPrinter.Assign': {
    en: 'Assign',
    se: 'Tilldela',
    es: 'Asignar',
  },
  'CreateCompany.Title': {
    en: 'New Company',
    se: 'Nytt Företag',
    es: 'Nueva Empresa',
  },
  'User.Venues': {
    en: 'Grant POS access for venue (optional)',
    se: 'Ge POS-åtkomst för butik (valfritt)',
    es: 'Otorgar acceso POS para el lugar (opcional)',
  },
  'User.Venues.None': {
    en: 'No venue',
    se: 'Ingen butik',
    es: 'Ningún lugar',
  },
  'User.EditPermissions.Title': {
    en: 'Backoffice permissions',
    se: 'Backoffice behörigheter',
    es: 'Permisos de backoffice',
  },
  'User.EditPermissions.Update': {
    en: 'Update permissions',
    se: 'Uppdatera behörigheter',
    es: 'Actualizar permisos',
  },
  'User.EditPermissions.Areas': {
    en: 'Accessible Areas (no selection gives access to all areas)',
    se: 'Tillgängliga områden (ingen val ger åtkomst till alla områden)',
    es: 'Áreas accesibles (ninguna selección da acceso a todas las áreas)',
  },
  'User.EditPermissions.AllAreas': {
    en: 'All areas',
    se: 'Alla områden',
    es: 'Todas las áreas',
  },
  'User.EditPermissions.Venues': {
    en: 'Accessible Venues (no selection gives access to all venues)',
    se: 'Tillgängliga butiker (ingen val ger åtkomst till alla platser)',
    es: 'Lugares accesibles (ninguna selección da acceso a todos los lugares)',
  },
  'User.EditPermissions.Success': {
    en: "User's permission has been updated",
    se: 'Användarens behörighet har uppdaterats',
    es: 'Los permisos del usuario han sido actualizados',
  },
  '404.Title': {
    en: 'This page is not accessible or does not exist, please contact admin if you suspect something is wrong.',
    se: 'Denna sida är inte tillgänglig eller existerar inte, vänligen kontakta admin om du misstänker att något är fel.',
    es: 'Esta página no es accesible o no existe, por favor contacte al administrador si sospecha que algo está mal.',
  },
  'NoPermissions.Title': {
    en: 'Access denied',
    se: 'Åtkomst nekad',
    es: 'Acceso denegado',
  },
  'NoPermissions.Subtitle': {
    en: "You don't have permission to access this page, please contact your admin if you think this is a mistake.",
    se: 'Du har inte behörighet att komma åt denna sida, vänligen kontakta din admin om du tror att detta är ett misstag.',
    es: 'No tienes permiso para acceder a esta página, por favor contacta a tu administrador si crees que esto es un error.',
  },
  'Beepers.Title': {
    en: 'Manage list of beepers',
    se: 'Hantera lista över beepers',
    es: 'Administrar lista de beepers',
  },
  'Beepers.SelectVenue': {
    en: 'Selected venue',
    se: 'Vald plats',
    es: 'Lugar seleccionado',
  },
  'Beepers.AddBeeper': {
    en: 'Add beeper',
    se: 'Lägg till puck',
    es: 'Agregar beeper',
  },
  'Beepers.WasAdded': {
    en: 'was added',
    se: 'lades till',
    es: 'fue agregado',
  },
  'Beepers.AddBeeper.Error.Empty': {
    en: 'Beeper ID cannot be empty',
    se: 'Puck-ID kan inte vara tomt',
    es: 'El ID del beeper no puede estar vacío',
  },
  'Beepers.AddBeeper.Error.AlreadyExists': {
    en: 'That beeper ID already exists',
    se: 'Det puck-ID:et finns redan',
    es: 'El ID del beeper ya existe',
  },
  'Releases.Title': {
    en: 'New features / Release notes',
    se: 'Nya funktioner / Release notes',
    es: 'Nuevas funciones / Notas de la versión',
  },
  'Releases.Subtitle': {
    en: 'A central place to share new features, product updates, and news with our customers.',
    se: 'En central plats för att dela nya funktioner, produktuppdateringar och nyheter med våra kunder.',
    es: 'Un lugar central para compartir nuevas funciones, actualizaciones de productos y noticias con nuestros clientes.',
  },
  'Releases.TriggerModal': {
    en: 'Trigger a popup in the POS & Backoffice to inform users about this release',
    se: 'Tvinga popup i POS & Backoffice för att informera användare om denna release',
    es: 'Activar una ventana emergente en el POS y Backoffice para informar a los usuarios sobre esta función',
  },
  'Releases.Breadcrumb': {
    en: 'Overview of releases',
    se: 'Översikt över releaser',
    es: 'Descripción general de las versiones',
  },
  'Releases.Publish': {
    en: 'Publish',
    se: 'Publicera',
    es: 'Publicar',
  },
  'Releases.CreatedBy': {
    en: 'Created by',
    se: 'Skapad av',
    es: 'Creado por',
  },
  'Releases.PublishNewFeature': {
    en: 'Publish new feature / news',
    se: 'Publicera ny funktion / nyhet',
    es: 'Publicar nueva función / noticia',
  },
  'Releases.PublishReleaseNotes': {
    en: 'Publish release notes',
    se: 'Publicera release notes',
    es: 'Publicar notas de la versión',
  },
  'Releases.Loading.Features': {
    en: 'Loading features & news...',
    se: 'Laddar funktioner & nyheter...',
    es: 'Cargando funciones y noticias...',
  },
  'Releases.UpdatedAt': {
    en: 'Updated at',
    se: 'Uppdaterad',
    es: 'Actualizado a las',
  },
  'Releases.FeatureForm.Loading': {
    en: 'Loading feature details...',
    se: 'Laddar funktionsdetaljer...',
    es: 'Cargando detalles de la función...',
  },
  'Releases.FeatureForm.PublishNew': {
    en: 'Publish new feature or news',
    se: 'Publicera ny funktion eller nyhet',
    es: 'Publicar nueva función o noticia',
  },
  'Releases.FeatureForm.Desc': {
    en: 'A feature is a new functionality or improvement added to the product. It can also be an announcement, such as the launch of Baemingo Boost. Features is always publicly visible on baemingo.com.',
    se: 'En funktion är en ny funktionalitet eller förbättring som lagts till i produkten. Det kan också vara ett meddelande, som lanseringen av Baemingo Boost. Funktioner är alltid offentligt synliga på baemingo.com.',
    es: 'Una función es una nueva funcionalidad o mejora añadida al producto. También puede ser un anuncio, como el lanzamiento de Baemingo Boost. Las funciones siempre son visibles públicamente en baemingo.com.',
  },
  'Releases.FeatureForm.TitleLang': {
    en: 'Release title',
    se: 'Titel',
    es: 'Título',
  },
  'Releases.FeatureForm.TitleLang.Placeholder': {
    en: 'e.g. New feature: Dark mode',
    se: 't.ex. Ny funktion: Dark mode',
    es: 'p.ej. Nueva función: Modo oscuro',
  },
  'Releases.FeatureForm.TitleLang.Translations': {
    en: 'Title translations',
    se: 'Översättningar av titeln',
    es: 'Traducciones del título',
  },
  'Releases.FeatureForm.Body': {
    en: 'Body',
    se: 'Brödtext',
    es: 'Cuerpo',
  },
  'Releases.FeatureForm.Body.Desc': {
    en: 'e.g. Include a short summary of the previous state and how this update provides a better solution.',
    se: 't. ex. Inkludera en kort sammanfattning av hur det såg ut tidigare och hur denna uppdatering ger en bättre lösning.',
    es: 'Incluya un breve resumen del estado anterior y cómo esta actualización proporciona una mejor solución.',
  },
  'Releases.FeatureForm.Body.Translations': {
    en: 'Body translations',
    se: 'Översättning av brödtext',
    es: 'Traducciones del cuerpo',
  },
  'Releases.FeatureForm.ImageUrls': {
    en: 'Images',
    se: 'Bilder',
    es: 'Imágenes',
  },
  'Releases.FeatureForm.ImageUrls.Desc': {
    en: 'Please use 1280x800 as the standard dimensions for all visuals. Resize your browser or capture window to 1280px wide by 800px high when taking the screenshot.',
    se: 'Använd 1280x800 som standardmått för alla bilder. Ändra storlek på din webbläsare eller fånga fönstret till 1280px brett och 800px högt när du tar skärmdumpen.',
    es: 'Utilice 1280x800 como dimensiones estándar para todos los gráficos. Cambie el tamaño de su navegador o capture la ventana a 1280px de ancho por 800px de alto al tomar la captura de pantalla.',
  },
  'Releases.FeatureForm.ImageUrls.Add': {
    en: 'Add an image',
    se: 'Lägg till en bild',
    es: 'Agregar una imagen',
  },
  'Releases.FeatureForm.ProductTags': {
    en: 'Product tags (optional)',
    se: 'Produkttaggar (valfritt)',
    es: 'Etiquetas de producto (opcional)',
  },
  'Releases.FeatureForm.ProductTags.Desc': {
    en: 'What products or areas that are impacted by this release.',
    se: 'Vilka produkter eller områden som påverkas av denna release.',
    es: 'Qué productos o áreas se ven afectados por esta versión.',
  },
  'Releases.FeatureForm.ProductTags.Placeholder': {
    en: 'Write a tag and press Enter (e.g QSR or Finance)',
    se: 'Skriv en tagg och tryck på Enter (t.ex. QSR eller Finance)',
    es: 'Escribe una etiqueta y presiona Enter (p. ej. QSR o Finanzas)',
  },
  'Releases.FeatureForm.ConfirmDelete': {
    en: 'Are you sure you want to delete this feature?',
    se: 'Är du säker på att du vill ta bort denna?',
    es: '¿Está seguro de que desea eliminar esta función?',
  },
  'Releases.FeatureForm.TranslationsNotGenerated': {
    en: 'Please make sure both translations for title & body are generated before publishing.',
    se: 'Se till att både översättningar för titel och brödtext är genererade innan publicering.',
    es: 'Asegúrese de que se generen ambas traducciones para el título y el cuerpo antes de publicar.',
  },
  'Releases.ReleaseNoteForm.Loading': {
    en: 'Loading release notes...',
    se: 'Laddar release notes...',
    es: 'Cargando notas de la versión...',
  },
  'Releases.ReleaseNoteForm.PublishNew': {
    en: 'Publish release notes',
    se: 'Publicera release notes',
    es: 'Publicar notas de la versión',
  },
  'Releases.ReleaseNoteForm.Desc': {
    en: 'Release notes provide a concise overview of the updates and improvements introduced in a specific product version. They will be shared via the Baemingo Slack channel and published on baemingo.com (visible to logged-in users i.e customer facing).',
    se: 'Release notes ger en kortfattad översikt över de uppdateringar och förbättringar som införts i en viss version av produkten. De kommer att delas via Baemingos Slack-kanal och publiceras på baemingo.com (synliga för inloggade användare).',
    es: 'Las notas de la versión ofrecen un resumen conciso de las actualizaciones y mejoras introducidas en una versión específica del producto. Se compartirán a través del canal de Slack de Baemingo y se publicarán en baemingo.com (visibles para los usuarios que hayan iniciado sesión).',
  },
  'Releases.ReleaseNoteForm.Title': {
    en: 'Title of the release notes, will be visible to customers in POS & Backoffice',
    se: 'Titel på release notes, kommer att vara synlig för kunder i POS & Backoffice',
    es: 'Título de las notas de la versión, será visible para los clientes en POS y Backoffice',
  },
  'Releases.ReleaseNoteForm.Title.Placeholder': {
    en: 'e.g New features and improvements',
    se: 't.ex Nya funktioner och förbättringar',
    es: 'p.ej Nuevas funciones y mejoras',
  },
  'Releases.ReleaseNoteForm.Repo': {
    en: 'What repository this release note is for (only visible in slack)',
    se: 'Vilket repo denna release note är för (endast synlig i slack)',
    es: 'Para qué repositorio es esta nota de versión (solo visible en slack)',
  },
  'Releases.ReleaseNoteForm.Repo.Placeholder': {
    en: 'e.g OM',
    se: 't.ex OM',
    es: 'p.ej OM',
  },
  'Releases.ReleaseNoteForm.Note': {
    en: 'Release note',
    se: 'Release note',
    es: 'Nota de la versión',
  },
  'Releases.ReleaseNoteForm.Note.Placeholder': {
    en: 'Given that this is customer facing, please make sure to write in a way that is easy to understand for the customer.',
    se: 'Eftersom detta är customer facing, se till att skriva på ett sätt som är lätt att förstå för kunden.',
    es: 'Dado que esto está orientado al cliente, asegúrese de escribir de una manera que sea fácil de entender para el cliente.',
  },
  'Releases.ReleaseNoteForm.ShowToCustomers': {
    en: 'Let customers see this release note in backoffice',
    se: 'Låt kunderna se denna release note i backoffice',
    es: 'Permitir que los clientes vean esta nota de versión en backoffice',
  },
  'Releases.GenerateLang': {
    en: 'Generate translations',
    se: 'Generera översättningar',
    es: 'Generar traducciones',
  },
  'Releases.ViewEditLang': {
    en: 'View/edit translations',
    se: 'Visa/redigera översättningar',
    es: 'Ver/editar traducciones',
  },
  'Organizations.Title': {
    en: 'Organizations',
    se: 'Organisationer',
    es: 'Organizaciones',
  },
  'Organizations.Subtitle': {
    en: 'Manage organizations and assign companies and users to them',
    se: 'Hantera organisationer och tilldela företag och användare till dem',
    es: 'Gestionar organizaciones y asignar empresas y usuarios a ellas',
  },
  'Organizations.CreateOrganization': {
    en: 'Create Organization',
    se: 'Skapa organisation',
    es: 'Crear organización',
  },
  'Organizations.EditOrganization': {
    en: 'Edit Organization',
    se: 'Redigera organisation',
    es: 'Editar organización',
  },
  'Organizations.SearchPlaceholder': {
    en: 'Search organizations...',
    se: 'Sök organisationer...',
    es: 'Buscar organizaciones...',
  },
  'Organizations.LoadingOrganizations': {
    en: 'Loading organizations...',
    se: 'Laddar organisationer...',
    es: 'Cargando organizaciones...',
  },
  'Organizations.NoOrganizationsFound': {
    en: 'No organizations found',
    se: 'Inga organisationer hittades',
    es: 'No se encontraron organizaciones',
  },
  'Organizations.NoMoreOrganizations': {
    en: 'This was the last page',
    se: 'Detta var sista sidan',
    es: 'Esta fue la última página',
  },
  'Organizations.UpdatedAt': {
    en: 'Updated at:',
    se: 'Uppdaterad:',
    es: 'Actualizado:',
  },
  'Organizations.AddCompany': {
    en: '+ Add company',
    se: '+ Lägg till företag',
    es: '+ Añadir empresa',
  },
  'Organizations.AddUserAccess': {
    en: '+ Give user access',
    se: '+ Ge användaråtkomst',
    es: '+ Dar acceso a usuario',
  },
  'Organizations.Companies': {
    en: 'Companies',
    se: 'Företag',
    es: 'Empresas',
  },
  'Organizations.UsersWithOrgAccess': {
    en: 'Users with org access',
    se: 'Användare med organisationsåtkomst',
    es: 'Usuarios con acceso a la organización',
  },
  'Organizations.GiveUsersAccessTitle': {
    en: 'Give users access to organization',
    se: 'Ge användare åtkomst till organisation',
    es: 'Dar acceso de usuarios a la organización',
  },
  'Organizations.UsersAccessDescription': {
    en: 'Users with access to this organization will be able to log in to all of its companies accounts.',
    se: 'Användare med åtkomst till denna organisation kommer att kunna logga in på alla dess företagskonton.',
    es: 'Los usuarios con acceso a esta organización podrán iniciar sesión en todas las cuentas de sus empresas.',
  },
  'Organizations.SearchSelectUsersLabel': {
    en: 'Search and select users from the companies assigned to this organization',
    se: 'Sök och välj användare från de företag som är tilldelade denna organisation',
    es: 'Buscar y seleccionar usuarios de las empresas asignadas a esta organización',
  },
  'Organizations.SearchSelectUsersPlaceholder': {
    en: 'Search and select users',
    se: 'Sök och välj användare',
    es: 'Buscar y seleccionar usuarios',
  },
  'Organizations.GiveAccessToSelectedUsers': {
    en: 'Give access to the selected users',
    se: 'Ge åtkomst till de valda användarna',
    es: 'Dar acceso a los usuarios seleccionados',
  },
  'Organizations.AssignCompaniesTitle': {
    en: 'Assign companies to organization',
    se: 'Tilldela företag till organisation',
    es: 'Asignar empresas a la organización',
  },
  'Organizations.SearchCompaniesLabel': {
    en: 'Search Companies',
    se: 'Sök företag',
    es: 'Buscar empresas',
  },
  'Organizations.SearchSelectCompaniesPlaceholder': {
    en: 'Search and select companies',
    se: 'Sök och välj företag',
    es: 'Buscar y seleccionar empresas',
  },
  'Organizations.AssignSelectedCompanies': {
    en: 'Assign the selected companies',
    se: 'Tilldela de valda företagen',
    es: 'Asignar las empresas seleccionadas',
  },
  'Organizations.FailedFetchUsers': {
    en: 'Failed to fetch users for selected companies',
    se: 'Det gick inte att hämta användare för valda företag',
    es: 'Error al obtener usuarios para las empresas seleccionadas',
  },
  'Organizations.OrganizationNameLabel': {
    en: 'Organization Name',
    se: 'Organisationsnamn',
    es: 'Nombre de la organización',
  },
  'Organizations.EnterOrganizationNamePlaceholder': {
    en: 'Enter organization name',
    se: 'Ange organisationsnamn',
    es: 'Ingrese el nombre de la organización',
  },
  'Organizations.EditOrganizationButton': {
    en: 'Edit organization',
    se: 'Redigera organisation',
    es: 'Editar organización',
  },
};
